{
  "accept_invite": {
    "back_to_home": "Powrót do strony głównej",
    "choose_password": "Wybierz hasło",
    "heading": "Zaakceptuj zaproszenie",
    "loading": "Ładowanie",
    "save_button": "Zaakceptuj zaproszenie",
    "text": "Zostałeś zaproszony do dołączenia do przestrzeni roboczej. Wybierz hasło, aby kontynuować."
  },
  "automation": {
    "audience": "Ta grupa obecnie ma jednego aktywnego pracownika | Ta grupa obecnie ma {count} aktywnych pracowników",
    "automation_updated": "Automatyzacja zaktualizowana",
    "delete": {
      "are_you_sure": "Czy na pewno chcesz usunąć tę sekwencję? Tej operacji nie można cofnąć.",
      "automation_deleted": "Sekwencja usunięta",
      "button": "Usuń"
    },
    "details": {
      "heading": "Szczegóły",
      "text": "Szczegóły automatyzacji"
    },
    "edit": {
      "subtitle": "Zbuduj swój przepływ automatyzacji, dodając działania",
      "title": "Działania"
    },
    "edit_automation": "Edytuj ustawienia",
    "employee_already_enrolled": "Ten pracownik jest już zapisany",
    "enroll_employees": "Zapisz pracowników",
    "enrolled_employees": "Zaktualizowano grupę",
    "flow": {
      "actions": {
        "assign_lesson": {
          "custom_label": "Niestandardowe"
        },
        "assign_quiz": {
          "custom_help": "Gdy ta opcja jest wyłączona, Moxso Intelligence wybierze najodpowiedniejsze szkolenie na podstawie profilu ryzyka pracownika.",
          "custom_label": "Niestandardowa ocena",
          "risk_categories": "Kategorie ryzyka"
        },
        "delete": {
          "button": "Usuń akcję",
          "text": "Czy na pewno chcesz usunąć tę akcję?"
        },
        "editing": {
          "add_tag_action": "Dodaj tag",
          "assign_course_action": "Przypisz kurs",
          "assign_lesson_action": "Przypisz lekcję",
          "assign_quiz_action": "Przypisz ocenę",
          "assign_video_action": "Przypisz wideo",
          "halt_action": "Wstrzymaj automatyzację",
          "remove_tag_action": "Usuń tag",
          "wait_action": "Odczekaj określony czas"
        },
        "preview": "Pokaż aktywność",
        "repeat_enabled": "Ten przepływ automatyzacji będzie powtarzany dla każdego pracownika.",
        "status": {
          "active": "Aktywne: {count}",
          "completed": "Zakończono: {count}",
          "halted": "Wstrzymane: {count}"
        },
        "step": "Krok {step}",
        "wait_units": {
          "days": "Dzień | Dni",
          "months": "Miesiąc | Miesiące",
          "weeks": "Tydzień | Tygodnie"
        }
      },
      "edit": "Edytuj",
      "length": "Długość",
      "save_step": "Zapisz krok",
      "title": {
        "preview": {
          "assign_lesson_action": {
            "text": "Moxso AI automatycznie przydzieli najlepszą lekcję dla każdego pracownika na podstawie jego poziomu umiejętności i stylu uczenia się.",
            "title": "Użyj Moxso AI, aby przypisać lekcję"
          },
          "halt_action": {
            "text": "Automatyzacja zostanie wstrzymana dla pracownika, który dotrze do tego kroku.",
            "title": "Zatrzymaj automatyzację"
          }
        },
        "wait_action": "Poczekaj {duration} {unit}"
      },
      "unit": "Jednostka"
    },
    "form_new_automation": {
      "button": "Utwórz sekwencję",
      "group": "Grupa",
      "group_placeholder": "Wybierz grupę",
      "name": "Nazwa",
      "template": {
        "label": "Szablon",
        "placeholder": "Wybierz szablon"
      },
      "title": "Utwórz sekwencję"
    },
    "funnel": {
      "button": "Edytuj sekwencję",
      "start": "Rozpocznij",
      "title": "Lejek sekwencyjny"
    },
    "hide_advanced_settings": "Ukryj zaawansowane ustawienia",
    "notification_frequency": "Częstotliwość powiadomień",
    "notifications": "Powiadomienia",
    "notifications_active": "Aktywne",
    "notifications_inactive": "Nieaktywne",
    "participants": {
      "filter": {
        "status": {
          "active": "Aktywni ({count})",
          "all": "Wszystkie ({count})",
          "completed": "Zakończone ({count})",
          "halted": "Wstrzymano ({count})"
        }
      },
      "heading": "Uczestnicy",
      "statistics": {
        "participant_coverage": "Zasięg uczestników",
        "participant_coverage_text": "Obliczony wynik na podstawie procentu pracowników zapisanych na to ćwiczenie."
      },
      "text": "Statystyki uczestnictwa"
    },
    "pause": "Wstrzymaj",
    "play": "Aktywuj",
    "search": {
      "placeholder": "Szukaj wszystkich pracowników",
      "results": "Wyniki wyszukiwania dla: {query}"
    },
    "sequence": {
      "subtitle": "Zarys sekwencji przepływu automatyzacji",
      "title": "Sekwencja"
    },
    "settings": {
      "create_segment": "Utwórz segment",
      "help": {
        "content_skipping_enabled": "Zezwól pracownikom na pomijanie kroków automatyzacji, jeśli ich poziom umiejętności jest wystarczający.",
        "notification_flow_enabled": "Włącz automatyczne powiadomienia dla pracowników, którzy jeszcze nie ukończyli swojego szkolenia.",
        "notification_past_deadline_enabled": "Wysyłaj cotygodniowe powiadomienia przez miesiąc po przekroczeniu terminu.",
        "notification_prelude_enabled": "Wyślij powiadomienie do pracowników, gdy nowa ocena zostanie im przydzielona.",
        "relative_deadlines_enabled": "Pracownik nie przejdzie dalej w procesie, dopóki nie zostanie spełniony poprzedni termin.",
        "relative_progression_enabled": "Pracownik będzie się posuwał naprzód w przepływie, niezależnie od tego, czy poprzednia lekcja została ukończona.",
        "repeat_enabled": "Zezwól pracownikom na przechodzenie przez automatyzację więcej niż raz.",
        "repeat_only_after_halt": "Powtórz tylko wtedy, gdy pracownik został wstrzymany",
        "repeatable_assignments_enabled": "Pracownikowi można przypisać lekcje, które zostały już ukończone.",
        "segment": "Zawęż automatyzację do określonego segmentu.",
        "trigger": "Wybierz wyzwalacz dla tego przepływu automatyzacji."
      },
      "labels": {
        "content_skipping_enabled": "Pomijanie treści",
        "date": "Data",
        "group": "Grupa",
        "name": "Nazwa",
        "notification_flow_enabled": "Włącz przepływ powiadomień",
        "notification_frequency": "Częstotliwość powiadomień",
        "notification_past_deadline_enabled": "Włącz przypomnienia po terminie",
        "notification_prelude_enabled": "Włącz powiadomienie wstępne",
        "relative_deadlines_enabled": "Włącz względne terminy",
        "relative_progression_enabled": "Włącz względny postęp",
        "repeat_enabled": "Powtórz przepływ automatyzacji",
        "repeat_only_after_halt": "Powtarzaj tylko po wstrzymaniu",
        "repeatable_assignments_enabled": "Włącz powtarzalne zadania",
        "segment": "Segment",
        "tag": "Etykieta",
        "trigger": "Wyzwalacz",
        "use_segment": "Użyj segmentu"
      },
      "no_segment_found": "Brak segmentów dla tej grupy.",
      "not_editable_text": "Wstrzymaj automatyzację, aby edytować ustawienia",
      "not_editable_title": "Automatyzacja jest obecnie uruchomiona",
      "placeholder": {
        "course": "Wybierz kurs",
        "date": "Wybierz datę",
        "lesson": "Wybierz lekcję",
        "segment": "Wybierz segment",
        "tag": "Wybierz tag",
        "video": "Wybierz wideo"
      },
      "repeatable_assignments_enabled": "Ponieważ wybrałeś, że pracownik może być przypisany do ćwiczeń, które już ukończył wcześniej, sekwencja musi podążać za względnymi terminami.",
      "save_settings": "Zapisz ustawienia",
      "settings_saved": "Ustawienia zapisane"
    },
    "show_advanced_settings": "Pokaż zaawansowane ustawienia"
  },
  "billing": {
    "missing_payment_banner": "Wymagane działanie: brak płatności"
  },
  "breaches": {
    "breached_accounts": "Naruszone konta",
    "compromised_info": "Zagrożone informacje",
    "data_types": "Rodzaje danych w tym wycieku",
    "date": "Data naruszenia",
    "disabled": {
      "button": "Przejdź do ustawień",
      "heading": "Naruszenia są wyłączone",
      "text": "Natychmiast powiadom swoich pracowników, jeśli zostali zaangażowani w naruszenie danych, umożliwiając szybką reakcję w celu ochrony wrażliwych informacji oraz minimalizowania ryzyka, jednocześnie zdobywając kompleksowy przegląd wszystkich naruszeń dotyczących twojego zespołu, co pozwala na lepsze zarządzanie bezpieczeństwem i szybką reakcję."
    },
    "high": "Wysoki",
    "medium": "Średni",
    "untitled_data_breach": "Nieoznakowane naruszenie danych"
  },
  "buttons": {
    "back": "Wstecz",
    "cancel": "Anuluj",
    "copy": "Kopiuj",
    "delete": "Usuń",
    "download_csv": "Pobierz CSV",
    "download_pdf": "Pobierz PDF",
    "view_details": "Zobacz szczegóły"
  },
  "charts": {
    "donut": {
      "amount_share": "Liczba / Procent",
      "category": "Kategoria"
    },
    "resilience": {
      "score": "Wynik"
    }
  },
  "competency_profile": {
    "current_level": "Obecny poziom",
    "target_level": "Poziom docelowy",
    "thresholds_info_text": "Progi są dostosowane do roli każdego pracownika i jego obecnego poziomu umiejętności.",
    "title": "Profil kompetencji"
  },
  "demo_data": {
    "automations": {
      "onboarding_new_employees": "Onboarding - Nowi pracownicy",
      "security_awareness_essentials_training": "Podstawy cyberbezpieczeństwa",
      "upskilling_all_employees": "Podnoszenie kwalifikacji - Wszyscy pracownicy"
    },
    "campaign_templates": {
      "templates": {
        "annual_benefits_enrollment_deadline": {
          "html": "<p>Witaj <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>To uprzejme przypomnienie, że okres corocznej rejestracji świadczeń dla pracowników <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span> wkrótce się kończy. Masz czas do <strong>piątku, 15 września</strong>, aby dokonać wyboru na nadchodzący rok.</p><p><strong>Ważne zmiany w tym roku:</strong></p><ul><li>Nowe opcje ubezpieczenia zdrowotnego z lepszym zakresem</li><li>Zwiększone dopłaty pracodawcy do planu emerytalnego do 6%</li><li>Ulepszone pakiety stomatologiczne i okulistyczne</li><li>Nowe limity kont elastycznych wydatków</li></ul><p>Brak ukończenia rejestracji do terminu spowoduje automatyczne zapisanie do planu podstawowego, który może nie odpowiadać Twoim obecnym potrzebom.</p><p>Zapoznaj się z opcjami i dokonaj wyboru za pośrednictwem naszego bezpiecznego portalu świadczeń:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Ukończ rejestrację świadczeń</a></strong></u></p><p>Jeśli masz pytania dotyczące dostępnych opcji, skontaktuj się z zespołem HR.</p><p>Dziękujemy,<br/><strong>Dział HR</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Wymagane działanie: Termin corocznej rejestracji świadczeń"
        },
        "security_breach_immediate_action": {
          "html": "<p>Szanowna/y <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Wykryliśmy podejrzaną aktywność na Twoim koncie w <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>, która wymaga natychmiastowej uwagi. Nasze systemy bezpieczeństwa oznaczyły wiele nieautoryzowanych prób logowania z nierozpoznanego urządzenia.</p><p>Aby chronić Twoje konto i dane firmy, tymczasowo ograniczyliśmy dostęp do Twojego konta. Musisz zweryfikować swoją tożsamość i zresetować dane logowania w ciągu najbliższych 24 godzin, aby uniknąć trwałego zawieszenia.</p><p><strong>Co musisz zrobić:</strong></p><ol><li>Kliknij bezpieczny link weryfikacyjny poniżej</li><li>Potwierdź tożsamość przy użyciu uwierzytelniania wieloskładnikowego</li><li>Natychmiast zaktualizuj hasło</li></ol><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Zweryfikuj bezpieczeństwo konta teraz</a></strong></u></p><p>Jeśli nie ukończysz procesu weryfikacji w ciągu 24 godzin, Twoje konto zostanie trwale zawieszone ze względów bezpieczeństwa.</p><p>Z poważaniem,<br/><strong>Zespół bezpieczeństwa IT</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Pilne: Naruszenie bezpieczeństwa - wymagane natychmiastowe działanie"
        },
        "upcoming_organizational_changes": {
          "html": "<p>Szanowna/y <span data-type=\"mention\" data-id=\"::employee.first_name::\">::employee.first_name::</span>,</p><p>Kontaktujemy się, aby poinformować o ważnych nadchodzących zmianach w <span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span>. Ze względu na zmieniające się potrzeby biznesowe będziemy restrukturyzować niektóre działy i niestety część stanowisk zostanie zlikwidowana.</p><p>Ważne jest, aby jak najszybciej zapoznać się ze szczegółowymi informacjami na temat tych zmian, aby zrozumieć, jak mogą one wpłynąć na Ciebie i Twój zespół.</p><p>Kliknij poniższy link, aby przeczytać oficjalny wpis na blogu opisujący kolejne kroki i dostępne wsparcie:</p><p><u><strong><a href=\"::attackLink::\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">Przeczytaj aktualizację organizacyjną CEO</a></strong></u></p><p>Będziemy wdzięczni za szybkie zajęcie się tą sprawą.</p><p>Z poważaniem,<br/><strong>Zarząd,</strong><br/><span data-type=\"mention\" data-id=\"::workspace.name::\">::workspace.name::</span></p>",
          "subject": "Nadchodzące zmiany organizacyjne"
        }
      }
    },
    "campaigns": {
      "completed_events": {
        "event_0": {
          "filename": "event_3.pl.html",
          "from_name": "Microsoft",
          "title": "Ostrzeżenie: usunięto 4214 plików - Microsoft"
        },
        "event_1": {
          "filename": "event_1.pl.html",
          "from_name": "Zespół Love2Race",
          "title": "[Love2Race] Spersonalizowany zestaw biegowy na Wasze kolejne wydarzenie"
        },
        "event_10": {
          "filename": "event_10.pl.html",
          "from_name": "Maria Caroline Thomsen",
          "title": "Spotkanie przy kawie"
        },
        "event_11": {
          "filename": "event_11.pl.html",
          "from_name": "SAS",
          "title": "Najniższa cena w historii!"
        },
        "event_12": {
          "filename": "event_12.pl.html",
          "from_name": "Filippa",
          "title": "Zapisy do sztafety DHL!"
        },
        "event_13": {
          "filename": "event_13.pl.html",
          "from_name": "Zespół bezpieczeństwa Slacka",
          "title": "[Slack] Ważne: nowa polityka prywatności"
        },
        "event_14": {
          "filename": "event_14.pl.html",
          "from_name": "HubSpot",
          "title": "[HubSpot] Twoje hasło zostanie zmienione"
        },
        "event_15": {
          "filename": "event_15.pl.html",
          "from_name": "Twój zespół SAP ID Service",
          "title": "[SAP] Powiadomienie o zresetowaniu hasła"
        },
        "event_16": {
          "filename": "event_16.pl.html",
          "from_name": "1Password",
          "title": "[1Password] Twoje hasło główne zostało zaktualizowane"
        },
        "event_17": {
          "filename": "event_17.pl.html",
          "from_name": "LinkedIn",
          "title": "[LinkedIn] Twoje statystyki zaangażowania są gotowe"
        },
        "event_18": {
          "filename": "event_18.pl.html",
          "from_name": "DocuSign",
          "title": "[DocuSign] Sprawdź dokument"
        },
        "event_2": {
          "filename": "event_2.pl.html",
          "from_name": "DHL Express",
          "title": "[DHL Express] Wymagana weryfikacja adresu doręczenia"
        },
        "event_3": {
          "filename": "event_3.pl.html",
          "from_name": "Microsoft",
          "title": "Ostrzeżenie: usunięto 4214 plików - Microsoft"
        },
        "event_4": {
          "filename": "event_4.pl.html",
          "from_name": "Zespół Bezpieczeństwa Allegro",
          "title": "[Allegro] PILNE: Twoje konto zostało tymczasowo zawieszone"
        },
        "event_5": {
          "filename": "event_5.pl.html",
          "title": "Propozycja rozwiązania płatności za kawę"
        },
        "event_6": {
          "filename": "event_6.pl.html",
          "from_name": "e-Boks A/S",
          "title": "Masz nową wiadomość od Policji"
        },
        "event_7": {
          "filename": "event_7.pl.html",
          "from_name": "Facebook",
          "title": "Odnów hasło - Facebook"
        },
        "event_8": {
          "filename": "event_8.pl.html",
          "title": "[Slack] Ważne: nowa polityka prywatności"
        },
        "event_9": {
          "filename": "event_9.pl.html",
          "from_name": "Microsoft",
          "title": "Przekroczono limit - Microsoft"
        }
      },
      "completed_sms_events": {
        "event_0": {
          "body": "TrackIt: Nie udało się dostarczyć Twojej paczki dzisiaj. Potwierdź adres dostawy przed 18:00: https://trk-it.example/delivery",
          "from_name": "TrackIt"
        },
        "event_1": {
          "body": "Kadry: Twój pasek płacowy za kwiecień jest gotowy. Sprawdź bezpieczny dokument tutaj: https://payroll-example.test/review",
          "from_name": "Kadry"
        },
        "event_2": {
          "body": "IT Support: Wykryliśmy nowe logowanie do Twojej skrzynki e-mail. Jeśli to nie Ty, potwierdź teraz swoją tożsamość: https://it-help.example/verify",
          "from_name": "IT Support"
        },
        "event_3": {
          "body": "Biuro: Zostałeś dodany do jutrzejszej listy dostępu do budynku. Otwórz przepustkę tutaj: https://office-pass.example/access",
          "from_name": "Biuro"
        },
        "event_4": {
          "body": "Bank: Płatność kartą została wstrzymana. Potwierdź transakcję, aby uniknąć tymczasowej blokady: https://bank-secure.example/check",
          "from_name": "Bank"
        }
      },
      "names": {
        "automatic_campaign": "Kampania automatyczna",
        "christmas": "Boze Narodzenie",
        "sms_campaign": "Kampania SMS",
        "test": "Test"
      }
    },
    "custom_courses": {
      "names": {
        "access_control_principles": "Zasady kontroli dostępu",
        "backup_and_recovery_procedures": "Procedury tworzenia kopii zapasowych i odzyskiwania",
        "business_continuity_planning": "Planowanie ciągłości działania",
        "cloud_security_basics": "Podstawy bezpieczeństwa chmury",
        "cybersecurity_awareness_training": "Szkolenie ze świadomości cyberbezpieczeństwa",
        "data_protection_fundamentals": "Podstawy ochrony danych",
        "digital_ethics_and_compliance": "Etyka cyfrowa i zgodność",
        "email_security_guidelines": "Wytyczne dotyczące bezpieczeństwa e-maili",
        "gdpr_compliance_essentials": "Podstawy zgodności z RODO",
        "incident_response_training": "Szkolenie z reagowania na incydenty",
        "information_classification": "Klasyfikacja informacji",
        "mobile_device_security": "Bezpieczeństwo urządzeń mobilnych",
        "network_security_fundamentals": "Podstawy bezpieczeństwa sieci",
        "password_security_best_practices": "Najlepsze praktyki bezpieczeństwa haseł",
        "phishing_prevention": "Zapobieganie phishingowi",
        "privacy_by_design": "Prywatność w fazie projektowania",
        "remote_work_security": "Bezpieczeństwo pracy zdalnej",
        "secure_coding_practices": "Praktyki bezpiecznego kodowania",
        "social_engineering_defense": "Obrona przed inżynierią społeczną",
        "vendor_risk_management": "Zarządzanie ryzykiem dostawców"
      }
    },
    "custom_videos": {
      "videos": {
        "creating_strong_passwords": {
          "description": "Najlepsze praktyki tworzenia i zarządzania silnymi, bezpiecznymi hasłami.",
          "title": "Tworzenie silnych haseł"
        },
        "data_privacy_basics": {
          "description": "Najważniejsze zagadnienia dotyczące prywatności danych i ochrony danych osobowych.",
          "title": "Podstawy prywatności danych"
        },
        "introduction_to_cyber_security": {
          "description": "Przegląd podstaw cyberbezpieczeństwa i tego, dlaczego jest to ważne.",
          "title": "Wprowadzenie do cyberbezpieczeństwa"
        },
        "multi_factor_authentication": {
          "description": "Jak działa uwierzytelnianie wieloskładnikowe i dlaczego warto z niego korzystać.",
          "title": "Uwierzytelnianie wieloskładnikowe"
        },
        "new_employee_security_awareness": {
          "description": "Film wprowadzający dla nowych pracowników o podstawowych praktykach bezpieczeństwa.",
          "title": "Świadomość bezpieczeństwa dla nowych pracowników"
        },
        "recognizing_phishing_emails": {
          "description": "Naucz się rozpoznawać i unikać e-maili phishingowych, aby chronić swoje informacje.",
          "title": "Rozpoznawanie e-maili phishingowych"
        },
        "safe_internet_browse": {
          "description": "Wskazówki i techniki bezpiecznego przeglądania internetu.",
          "title": "Bezpieczne przeglądanie internetu"
        },
        "securing_mobile_devices": {
          "description": "Dowiedz się, jak chronić swoje urządzenia mobilne przed zagrożeniami.",
          "title": "Zabezpieczanie urządzeń mobilnych"
        },
        "social_engineering_attacks": {
          "description": "Zrozum taktyki socjotechniczne i dowiedz się, jak się przed nimi bronić.",
          "title": "Ataki socjotechniczne"
        },
        "understanding_ransomware": {
          "description": "Wprowadzenie do ransomware i sposoby ochrony danych przed nim.",
          "title": "Zrozumienie ransomware"
        }
      }
    },
    "policies": {
      "content": {
        "heading_second_paragraph": "Drugi akapit",
        "paragraph_1": "W [Company Name] zobowiązujemy się do utrzymywania najwyższych standardów bezpieczeństwa danych we wszystkich obszarach naszej działalności. Uznajemy, że poufność, integralność i dostępność danych osobowych oraz informacji wrażliwych mają kluczowe znaczenie dla utrzymania zaufania naszych klientów, pracowników, partnerów i organów regulacyjnych.",
        "paragraph_2": "W związku z tym ustanowiliśmy niniejszą politykę bezpieczeństwa danych, aby określić zasady i praktyki kierujące naszymi działaniami mającymi na celu ochronę danych przed nieuprawnionym dostępem, nadużyciem, utratą, zmianą lub zniszczeniem. Polityka ma zastosowanie do wszystkich danych osobowych, które gromadzimy, przetwarzamy lub przechowujemy, zarówno w formie cyfrowej, jak i fizycznej, i jest zgodna z uznanymi standardami branżowymi oraz wymogami regulacyjnymi, w tym [wstaw obowiązujące przepisy, np. GDPR, CCPA, HIPAA].",
        "paragraph_3": "Naszym celem jest wdrażanie proaktywnych środków bezpieczeństwa, które ograniczają ryzyko, zapewniają zgodność i wspierają nasze ogólne ramy ładu informacyjnego. Stosujemy połączenie zabezpieczeń technicznych, administracyjnych i fizycznych, aby chronić dane przez cały ich cykl życia.",
        "paragraph_4": "Obejmuje to mechanizmy kontroli dostępu, szyfrowanie, bezpieczne praktyki tworzenia oprogramowania, planowanie reagowania na incydenty, szkolenia pracowników oraz regularne audyty. Od każdego pracownika, współpracownika i zewnętrznego dostawcy usług, który ma styczność z danymi osobowymi, oczekuje się zrozumienia i przestrzegania obowiązków bezpieczeństwa określonych w tej polityce.",
        "paragraph_5": "Poprzez ciągłą ocenę i doskonalenie naszego poziomu bezpieczeństwa dążymy do wyprzedzania zmieniających się zagrożeń oraz zapewnienia, że powierzone nam dane osobowe są traktowane z najwyższą starannością."
      },
      "names": {
        "acceptable_use_policy": "Polityka dopuszczalnego użytkowania",
        "access_control_policy": "Polityka kontroli dostępu",
        "bring_your_own_device_byod_policy": "Polityka własnych urządzeń (BYOD)",
        "business_continuity_and_disaster_recovery_policy": "Polityka ciągłości działania i odzyskiwania po awarii",
        "change_management_policy": "Polityka zarządzania zmianą",
        "cloud_usage_policy": "Polityka korzystania z chmury",
        "code_of_conduct": "Kodeks postępowania",
        "company_it_security_policy": "Polityka bezpieczeństwa IT firmy",
        "data_protection_and_privacy_policy": "Polityka ochrony danych i prywatności",
        "email_and_communication_policy": "Polityka poczty elektronicznej i komunikacji",
        "employee_onboarding_policy": "Polityka onboardingu pracowników",
        "encryption_policy": "Polityka szyfrowania",
        "incident_response_policy": "Polityka reagowania na incydenty",
        "internet_usage_policy": "Polityka korzystania z internetu",
        "mobile_device_management_policy": "Polityka zarządzania urządzeniami mobilnymi",
        "monitoring_and_logging_policy": "Polityka monitorowania i logowania",
        "network_security_policy": "Polityka bezpieczeństwa sieci",
        "password_management_policy": "Polityka zarządzania hasłami",
        "patch_management_policy": "Polityka zarządzania poprawkami",
        "physical_security_policy": "Polityka bezpieczeństwa fizycznego",
        "remote_work_policy": "Polityka pracy zdalnej",
        "secure_development_policy": "Polityka bezpiecznego rozwoju",
        "social_media_policy": "Polityka mediów społecznościowych",
        "software_installation_policy": "Polityka instalacji oprogramowania",
        "third_party_vendor_security_policy": "Polityka bezpieczeństwa dostawców zewnętrznych"
      }
    },
    "simulations": {
      "subjects": {
        "new_work_phones": "Otrzymamy nowe telefony sluzbowe",
        "slack_privacy_policy": "[Slack] Wazne: Nowa polityka prywatnosci",
        "warning_files_deleted": "Ostrzezenie: 4 214 plikow zostalo pomyslnie usunietych - Microsoft"
      }
    },
    "threats": {
      "emails": {
        "free_gift_card_sender": "no-reply@ing.pl"
      },
      "subjects": {
        "free_gift_card_opportunity_short": "Twoja szansa na darmową kartę podarunkową o wartości 300 kr e...",
        "free_gift_card_opportunity_short_with_space": " Twoja szansa na darmową kartę podarunkową o wartości 300 kr e..."
      }
    },
    "training": {
      "courses": {
        "10564bf8-aa3e-4295-9cf0-d350276455da": "Podstawy cyberbezpieczenstwa",
        "19a78f09-8c46-4090-b2aa-e2d655efb9cf": "Przetwarzanie danych osobowych",
        "27ad50e1-7967-49bd-a85a-3c8a4a97975a": "Wprowadzenie do RODO",
        "2ba7b31b-c23c-4195-9506-6dd064f9c72d": "Phishing",
        "69e29286-5079-4053-bd59-f59e64b41cf2": "Dla poczatkujacych",
        "9dadf2a3-6883-4929-b77d-ac424f690a7c": "Hasla",
        "a07d3c2d-0414-43bd-b8a7-6555af86c065": "Ransomware",
        "cdf2ba12-d0cd-4c71-a58e-267ec870007a": "Bezpieczenstwo fizyczne"
      },
      "videos": {
        "a_secure_network": "Bezpieczna siec",
        "ai_impact_on_phishing": "Wplyw AI na phishing",
        "ai_powered_social_engineering_tactics": "Taktyki socjotechniczne oparte na AI",
        "beware_of_public_networks": "Uwazaj na sieci publiczne",
        "beware_of_usbs_and_other_hard_drives": "Uwazaj na USB i inne dyski",
        "black_white_and_grey_hat_hackers": "Hakerzy black hat, white hat i grey hat",
        "cybersecurity_on_mobile_devices": "Cyberbezpieczenstwo na urzadzeniach mobilnych",
        "data_leak_monitoring": "Monitorowanie wyciekow danych",
        "gdpr_and_security_breaches": "RODO i naruszenia bezpieczenstwa",
        "hacking_of_hashes": "Lamanie hashy",
        "how_has_cryptocurrency_changed_hacking": "Jak kryptowaluty zmienily hacking?",
        "how_to_create_strong_passwords": "Jak tworzyc silne hasla",
        "how_to_detect_phishing": "Jak rozpoznac phishing",
        "how_to_prevent_tailgating": "Jak zapobiegac tailgatingowi",
        "how_to_protect_confidential_data_in_llms": "Jak chronic poufne dane w LLM-ach",
        "how_to_strengthen_your_physical_security": "Jak wzmocnic bezpieczenstwo fizyczne",
        "multi_factor_authentication": "Uwierzytelnianie wieloskladnikowe",
        "password_managers": "Menedzery hasel",
        "phishing_from_a_trusted_sender": "Phishing od zaufanego nadawcy",
        "processing_of_personal_data": "Przetwarzanie danych osobowych"
      }
    }
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "at_least_two_options": "Proszę podać co najmniej dwie opcje dla każdego pytania",
        "invalid_locale": "Proszę wybrać prawidłowy język",
        "network": "Wystąpił błąd",
        "noResponse": "Nie otrzymano odpowiedzi od serwera",
        "no_audience": "Proszę wybrać odbiorców",
        "no_date": "Proszę podać prawidłową datę",
        "no_group": "Proszę wybrać grupę",
        "no_lesson": "Proszę wybrać lekcję",
        "no_manager": "Proszę wybrać kierownika",
        "no_phone_country_code": "Proszę wybrać krajowy numer kierunkowy",
        "no_role": "Proszę wybrać rolę",
        "no_tag": "Proszę wybrać tag",
        "no_timezone": "Proszę wybrać strefę czasową",
        "unknown": "Wystąpił nieznany błąd"
      },
      "messages": {
        "at_least_one_manager": "Musisz mieć co najmniej jednego menedżera w swoim przestrzeni roboczej.",
        "auth_failed": "Nieprawidłowy email i / lub hasło",
        "course_could_not_be_published": "Nie można opublikować. Upewnij się, że wszystkie kroki są wypełnione we wszystkich językach i że żaden z nich nie pozostaje bez tytułu.",
        "deepl_translation_failed": "Nie udało się przetłumaczyć za pomocą AI. Spróbuj ponownie później.",
        "duplicate_field_identifier": "Identyfikator pola już istnieje",
        "duplicate_goal": "Cel z tym typem i datą zakończenia już istnieje.",
        "general_exception": "Wystąpił błąd",
        "goal_expired": "Nie można zaktualizować celu, który już wygasł.",
        "group_has_automation": "Ta grupa nie może zostać usunięta, ponieważ jest częścią aktywnej automatyzacji.",
        "group_has_campaign": "Ta grupa nie może zostać usunięta, ponieważ jest częścią aktywnej kampanii.",
        "invalid_domain": "Nieprawidłowa domena",
        "invalid_invite": "Nieprawidłowe zaproszenie",
        "invalid_metadata": "Nie można pobrać adresu URL metadanych albo nie zawiera on użytecznych metadanych SAML. Upewnij się, że konfiguracje SAML zostały wprowadzone w Twoim IdP.",
        "invalid_phone_number": "Nieprawidłowy numer telefonu",
        "invalid_provider": "Wybrany dostawca jest nieprawidłowy.",
        "invalid_provider_id": "Podany identyfikator dostawcy jest nieprawidłowy",
        "invalid_request": "Błąd techniczny",
        "invalid_request_signature": "Link, którego użyłeś, jest nieprawidłowy lub nieaktywny. Poproś administratora o wydanie nowego zaproszenia.",
        "invalid_response": "Dostawca tożsamości zwrócił nieprawidłową odpowiedź.",
        "missing_calculation": "Wygląda na to, że brakuje nam pewnych danych. Spróbuj ponownie później.",
        "missing_teams_app_installation": "Aplikacja Teams nie jest zainstalowana. Zainstaluj aplikację Moxso Teams.",
        "missing_user": "Nie możemy znaleźć użytkownika z takim adresem e-mail.",
        "no_available_integration": "Brak dostępnej integracji dla wybranego dostawcy.",
        "not_found": "Nie można znaleźć żądanego elementu",
        "passwords_dont_match": "Podane hasła nie są identyczne.",
        "policy_has_active_audit": "Nie można usunąć, ponieważ polityka ma aktywny audyt.",
        "policy_not_approved": "Nie można utworzyć audytu, ponieważ polityka nie została zatwierdzona.",
        "provider_resource_not_found": "Grupa nie została znaleziona w katalogu integracji.",
        "saml_provider_not_found": "Nie znaleziono połączenia SAML.",
        "sync_conflict": "Synchronizacja pracowników jest już włączona przez inną integrację katalogową lub połączenie SCIM. Wyłącz inne połączenie synchronizacji pracowników przed włączeniem tego połączenia.",
        "sync_provider_missing": "Nie można skontaktować się z dostawcą",
        "sync_provider_response_failure": "Nie można zsynchronizować kontaktów",
        "too_many_requests": "Zbyt wiele prób. Spróbuj ponownie za kilka minut.",
        "two_factor_challenge_invalid": "Wyzwanie logowania wygasło. Zaloguj się ponownie.",
        "two_factor_code_invalid": "Kod uwierzytelniający jest nieprawidłowy.",
        "unexpected_error": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie.",
        "upcoming_action_has_data": "Działania są już zaplanowane dla kolejnych kroków w tej sekwencji. Proszę usunąć te działania przed zapisaniem.",
        "user_already_active": "Użytkownik już istnieje.",
        "user_exists_in_different_workspace": "Użytkownik już istnieje, ale w innym obszarze roboczym. Skontaktuj się z pomocą techniczną, aby dodać użytkownika do tego obszaru roboczego.",
        "user_not_found": "Link, którego użyłeś, jest nieprawidłowy lub nieaktywny. Poproś administratora o wydanie nowego zaproszenia.",
        "video_could_not_be_uploaded": "Nie udało się przesłać wideo"
      },
      "validations": {
        "messages": {
          "accepted_if": "Nieprawidłowe pola",
          "after_or_equal": "Data zakończenia musi być taka sama lub późniejsza niż data rozpoczęcia.",
          "alpha": "Pole {_field_} może zawierać tylko znaki alfabetu.",
          "alpha_dash": "Pole {_field_} może zawierać znaki alfanumeryczne, a także myślniki i podkreślenia.",
          "alpha_num": "Pole {_field_} może zawierać tylko znaki alfanumeryczne.",
          "alpha_spaces": "Pole {_field_} może zawierać tylko znaki alfabetu oraz spacje.",
          "between": "Pole {_field_} musi zawierać się między {min} a {max}",
          "boolean": "Pole {_field_} nie jest prawidłową wartością",
          "confirmed": "Potwierdzenie pola {_field_} nie pasuje.",
          "currentPassword": "Hasło jest nieprawidłowe",
          "date": "Pole {_field_} nie jest prawidłową datą.",
          "date_format": "Pole {_field_} nie jest prawidłową datą.",
          "digits": "Pole {_field_} musi być numeryczne i zawierać dokładnie {length} cyfr.",
          "dimensions": "Pole {_field_} musi mieć {width} pikseli na {height} pikseli.",
          "double": "Pole {_field_} musi być poprawną liczbą dziesiętną.",
          "email": "Pole {_field_} musi zawierać prawidłowy adres e-mail",
          "excluded": "Pole {_field_} nie jest prawidłową wartością",
          "ext": "Pole {_field_} nie jest prawidłowym plikiem",
          "image": "Pole {_field_} musi być obrazem",
          "in": "Pole {_field_} ma nieprawidłową wartość",
          "integer": "Pole {_field_} musi być liczbą całkowitą",
          "invalid_domain": "Musisz zweryfikować swoją domenę, zanim będziesz mógł dodać użytkowników.",
          "invalid_field": "Nieprawidłowe pola",
          "invalid_phone_number": "Nieprawidłowy numer telefonu",
          "length": "Pole {_field_} musi mieć długość {length}.",
          "max": "Pole {_field_} nie może być dłuższe niż {length} znaków.",
          "max_value": "Pole {_field_} musi być równe {max} lub mniejsze.",
          "mimes": "Pole {_field_} musi mieć prawidłowy typ pliku",
          "min": "Pole {_field_} musi mieć co najmniej {length} znaków.",
          "min_value": "Pole {_field_} musi być równe lub większe niż {min}",
          "missing_user": "Nie możemy znaleźć użytkownika z tym adresem e-mail.",
          "non_disposable_email": "Pole {_field_} musi być prawidłowym adresem email.",
          "not_found": "{_field_} nie został znaleziony",
          "numeric": "Pole {_field_} może zawierać tylko znaki numeryczne",
          "oneOf": "Pole {_field_} nie jest prawidłową wartością",
          "regex": "Format pola {_field_} jest nieprawidłowy.",
          "required": "To pole jest wymagane",
          "required_if": "Pole {_field_} jest wymagane",
          "size": "Pole {_field_} musi mieć rozmiar mniejszy niż {size}KB.",
          "string": "Pole {_field_} może zawierać tylko znaki alfabetu.",
          "true": "Pole {_field_} musi zostać zaakceptowane.",
          "unique": "Pole {_field_} jest już zajęte.",
          "unique_provider_id": "Ta grupa już istnieje u dostawcy integracji."
        }
      }
    },
    "automation": {
      "flow": {
        "title": {
          "action_selector": "Wybierz akcję",
          "add_tag_action": "Dodaj tag",
          "assign_course_action": "Przypisz kurs",
          "assign_lesson_action": "Przypisz lekcję",
          "assign_quiz_action": "Przypisz ocenę",
          "assign_video_action": "Przypisz wideo",
          "halt_action": "Zatrzymaj automatyzację",
          "missing_action": "Brakująca akcja",
          "remove_tag_action": "Usuń tag",
          "wait_action": "Czekaj przez czas trwania"
        }
      },
      "frequency": {
        "intense": "Intensywne",
        "loose": "Luźny",
        "normal": "Normalny"
      },
      "status": {
        "paused": "wstrzymano",
        "running": "uruchomiony",
        "started": "rozpoczęto"
      },
      "templates": {
        "advanced-it-security-training": {
          "description": "Zaawansowane szkolenie z bezpieczeństwa dla personelu IT i technicznego.",
          "title": "Zaawansowane szkolenie z bezpieczeństwa IT"
        },
        "blank": {
          "description": "Zacznij od zera z pustą automatyzacją.",
          "title": "Pusta automatyzacja"
        },
        "cybersecurity-and-physical-security-awareness-intense": {
          "description": "Kompleksowe szkolenie z bezpieczeństwa dla zaawansowanych użytkowników.",
          "title": "Świadomość cyber- i bezpieczeństwa fizycznego (Intensywny)"
        },
        "cybersecurity-and-physical-security-awareness-light": {
          "description": "Wprowadzające szkolenie z bezpieczeństwa dla pracowników bez dostępu do komputera.",
          "title": "Świadomość cyber- i bezpieczeństwa fizycznego (Podstawowy)"
        },
        "cybersecurity-and-physical-security-awareness-medium": {
          "description": "Szkolenie z zakresu świadomości bezpieczeństwa dla pracowników z dostępem do komputera.",
          "title": "Świadomość cyber- i bezpieczeństwa fizycznego (Średni)"
        },
        "cybersecurity-fundamentals": {
          "description": "Kluczowe zasady i najlepsze praktyki cyberbezpieczeństwa.",
          "title": "Podstawy cyberbezpieczeństwa"
        },
        "management-training-in-it-security": {
          "description": "Świadomość cyberbezpieczeństwa dla menedżerów i kadry kierowniczej.",
          "title": "Szkolenie z bezpieczeństwa IT dla kadry zarządzającej"
        },
        "security-awareness-essentials-training": {
          "description": "Podstawowa świadomość cyberbezpieczeństwa dla wszystkich pracowników.",
          "title": "Podstawowe szkolenie z bezpieczeństwa"
        }
      },
      "triggers": {
        "date_trigger": "W określony dzień",
        "employee_added_to_audience_trigger": "Kiedy pracownik zostanie dodany do grupy odbiorców sekwencji",
        "employee_created_trigger": "Kiedy pracownik jest tworzony",
        "simulation_link_clicked_trigger": "Kiedy pracownik kliknie link w symulacji",
        "tag_added_trigger": "Gdy pracownikowi zostanie przypisany tag",
        "tag_removed_trigger": "Gdy pracownik zostanie usunięty z tagu"
      },
      "triggers_help": {
        "date_trigger": "Rejestruje wszystkie osoby z wybranej grupy odbiorców w momencie aktywacji wyzwalacza. Osoby dodane do grupy odbiorców po tej dacie nie zostaną zarejestrowane automatycznie.",
        "employee_added_to_audience_trigger": "Rejestruje pracownika po dodaniu go do grupy odbiorców powiązanej z automatyzacją.",
        "employee_created_trigger": "Rejestruje pracownika natychmiast po dodaniu go do Moxso.",
        "simulation_link_clicked_trigger": "Rejestruje pracownika, gdy kliknie link w symulacji phishingowej, umożliwiając przypisanie mu ukierunkowanego szkolenia naprawczego."
      },
      "wait_units": {
        "days": "dzień | dni",
        "hours": "godzina | godziny",
        "minutes": "minuta | minuty",
        "months": "miesiąc | miesięcy",
        "seconds": "sekunda | sekundy",
        "weeks": "tydzień | tygodnie"
      }
    },
    "employees": {
      "deactivation_notice": {
        "account_disabled": "To konto zostało ręcznie dezaktywowane przez administratora w dniu {date}.",
        "active_directory": "To konto zostało dezaktywowane z powodu zmiany w Twoim Active Directory dnia {date}.",
        "simulation_bounce": "Konto zostało dezaktywowane z powodu odbicia w symulacji dnia {date}.",
        "simulation_complaint": "To konto zostało dezaktywowane z powodu skargi w symulacji w dniu {date}."
      },
      "recent_activity": {
        "type": {
          "clicked": "{name} - użytkownik kliknął link do symulacji",
          "completed_course": "{name} ukończył(a) kurs",
          "correct": "{name} poprawnie odpowiedział(a) na quiz dotyczący phishingu",
          "delivered": "{name} otrzymał(a) symulację",
          "incorrect": "{name} niepoprawnie odpowiedział(a) na quiz dotyczący phishingu",
          "mc_correct": "{name} poprawnie odpowiedział(a) na pytanie wielokrotnego wyboru",
          "mc_incorrect": "{name} nieprawidłowo odpowiedział(a) na pytanie wielokrotnego wyboru",
          "reported": "{name} zgłosił(a) symulację",
          "sms_clicked": "{name} kliknął(a) link w symulacji smishingowej",
          "sms_delivered": "{name} otrzymał(a) symulację smishingową",
          "submission": "{name} podał(a) dane logowania podczas symulacji phishingowej",
          "submit_delivered": "{name} otrzymał(a) symulację",
          "watched_video": "{name} obejrzał(a) wideo"
        }
      },
      "status": {
        "active": "aktywny",
        "inactive": "nieaktywna"
      }
    },
    "export_form_fields": {
      "clicked_count": "Symulacje kliknięte",
      "created_at": "Data utworzenia",
      "department": "Dział",
      "dynamic_group_memberships": "Dynamiczne członkostwa w grupach",
      "email": "E-mail",
      "first_name": "Imię",
      "group_count": "Liczba grup",
      "last_name": "Nazwisko",
      "locale": "Język",
      "manager_name": "Nazwa menedżera",
      "onboarded": "Status wdrożenia",
      "phishing_quizzes_count": "Ukończone quizy phishingowe",
      "phone_number": "Numer telefonu",
      "point_count": "Suma punktów",
      "provider": "Dostawca integracji",
      "received_count": "Otrzymane symulacje",
      "reported_count": "Zgłoszone symulacje",
      "score": "Wynik",
      "status": "Status",
      "submitted_count": "Logowania w symulacjach",
      "video_quizzes_count": "Ukończone quizy wideo",
      "watched_count": "Obejrzane filmy"
    },
    "feature_upsell": {
      "bring-your-own-content": {
        "items": [
          "Przesyłaj własne filmy i materiały szkoleniowe",
          "Lokalizuj przesłane materiały dla wielu języków i zespołów",
          "Udostępniaj onboarding i treści compliance dopasowane do organizacji",
          "Zautomatyzuj harmonogramy, działania następcze i raportowanie dla własnych treści."
        ],
        "summary": "Łącz szkolenia Moxso z własnymi materiałami, aby dostarczać treści dopasowane do waszych procesów, narzędzi i komunikacji wewnętrznej.",
        "title": "Własne treści"
      },
      "compliance-integration": {
        "items": [
          "Połącz Drata i Vanta z mniejszym nakładem pracy przy konfiguracji.",
          "Ogranicz ręczne zbieranie dowodów zgodności.",
          "Mapuj aktywność szkoleniową do workflowów przyjaznych audytowi.",
          "Wspieraj cykliczne przeglądy przy mniejszej liczbie przekazań."
        ],
        "summary": "Synchronizuj dowody zgodności i połącz aktywność Moxso z workflowami Drata i Vanta, ograniczając ręczne działania następcze.",
        "title": "Integracja compliance z Drata i Vanta"
      },
      "goal-setting": {
        "items": [
          "Ustawiaj mierzalne cele dla kluczowych metryk efektywności.",
          "Śledź postępy względem celu w czasie.",
          "Korzystaj z prognozowanych trendów, aby sprawdzić, czy cel jest realistyczny.",
          "Wcześnie wykrywaj, czy wyniki są zgodne z planem."
        ],
        "summary": "Ustaw cel, śledź postępy w czasie i porównuj je z prognozowaną linią trendu, aby sprawdzić, czy cel jest realistyczny i zgodny z planem.",
        "title": "Ustawianie celów"
      },
      "human-risk-intelligence": {
        "items": [
          "Monitoruj sygnały ludzkiego ryzyka w jednym miejscu.",
          "Śledź przypisania i interwencje w czasie.",
          "Wcześniej rozpoznawaj pojawiające się ryzyko behawioralne.",
          "Priorytetyzuj działania dzięki bogatszemu kontekstowi ryzyka."
        ],
        "summary": "Śledź sygnały ludzkiego ryzyka, interwencje i przypisania w jednym widoku, aby lepiej rozumieć pojawiające się ryzyko behawioralne.",
        "title": "Wgląd w ludzkie ryzyko"
      },
      "industry-benchmarking": {
        "items": [
          "Porównuj wyniki z benchmarkami podobnych organizacji.",
          "Dodawaj kontekst do metryk odporności i szkoleń.",
          "Szybciej wykrywaj odchylenia w kluczowych KPI.",
          "Wzmacniaj raportowanie dla interesariuszy i kierownictwa."
        ],
        "summary": "Porównuj odporność i wyniki szkoleń z benchmarkami branżowymi, aby nadać kontekst waszym metrykom bezpieczeństwa.",
        "title": "Benchmarking branżowy"
      },
      "phishing-reporting-add-in": {
        "items": [
          "Ułatw pracownikom natychmiastowe zgłaszanie podejrzanych wiadomości.",
          "Szybciej wykrywaj ataki, zanim zdążą się rozprzestrzenić.",
          "Utrzymuj proste zgłaszanie i świadomość bezpieczeństwa w całej firmie.",
          "Włącz zgłaszanie do codziennej pracy bez dodatkowych utrudnień."
        ],
        "summary": "Dodatek do klienta poczty, który pozwala pracownikom zgłaszać phishing i podejrzane wiadomości bezpośrednio ze skrzynki odbiorczej.",
        "title": "Zgłaszanie phishingu"
      },
      "policy-management": {
        "items": [
          "Twórz i aktualizuj wewnętrzne polityki w jednym miejscu",
          "Przypisuj polityki do odpowiednich zespołów we właściwym czasie",
          "Zbieraj potwierdzenia zapoznania się z politykami od pracowników",
          "Śledź status i zachowuj ścieżkę audytu"
        ],
        "summary": "Publikuj polityki wewnętrzne, śledź potwierdzenia i utrzymuj porządek w dokumentacji w całej organizacji.",
        "title": "Zarządzanie politykami"
      },
      "risk-based-training": {
        "items": [
          "Adaptacyjne szkolenie oparte na zachowaniu i sygnałach ryzyka.",
          "Zmniejsz ryzyko ludzkie dzięki spersonalizowanemu szkoleniu.",
          "Skup się na realnych podatnościach, nie hipotetycznych zagrożeniach.",
          "Ogranicz zmęczenie użytkowników niskiego ryzyka."
        ],
        "summary": "Szkolenie świadomości bezpieczeństwa, które dostosowuje treść i intensywność na podstawie sygnałów ryzyka pracowników oraz ich profilu ryzyka, wywiedzionych z symulacji i obserwowanego zachowania.",
        "title": "Szkolenie oparte na ryzyku"
      },
      "simulation-builder": {
        "items": [
          "Dopasuj symulacje do organizacji i jej zagrożeń.",
          "Kieruj kampanie do użytkowników, ról lub grup, które mają największe znaczenie.",
          "Używaj znanych nadawców, komunikatów i motywów dla większej autentyczności.",
          "Projektuj kampanie na własnych zasadach i skup się na priorytetach.",
          "Generuj realistyczne symulacje phishingu z pomocą AI."
        ],
        "summary": "Narzędzia konfiguracyjne do tworzenia i zarządzania kampaniami symulacji phishingu, w tym szablony, profile nadawców i domeny.",
        "title": "Kreator symulacji"
      },
      "smishing": {
        "items": [
          "Uruchamiaj symulacje phishingu oparte na SMS-ach.",
          "Testuj, jak pracownicy reagują na urządzeniach mobilnych.",
          "Rozszerz szkolenia awareness poza skrzynkę odbiorczą.",
          "Mierz odporność na wzorce ataków mobile-first."
        ],
        "summary": "Rozszerz symulacje poza e-mail o scenariusze phishingowe oparte na SMS-ach i kodach QR, dopasowane do ataków mobile-first.",
        "title": "Smishing i quishing"
      },
      "spear-phishing": {
        "items": [
          "Symuluj ataki ukierunkowane na oprogramowanie i oszustwa z podszywaniem się pod kadrę kierowniczą.",
          "Testuj przechwytywanie poświadczeń w bardziej realistycznych scenariuszach.",
          "Rozszerz programy phishingowe o zaawansowane typy ataków.",
          "Przygotuj pracowników na social engineering o wyższym ryzyku."
        ],
        "summary": "Twórz zaawansowane symulacje phishingu dla scenariuszy ukierunkowanych na oprogramowanie, podszywanie się pod kadrę kierowniczą i przechwytywanie poświadczeń.",
        "title": "Spear phishing"
      },
      "teams-slack-integration": {
        "items": [
          "Połącz kanały współpracy z workflowami bezpieczeństwa.",
          "Kieruj istotne powiadomienia tam, gdzie zespoły już pracują.",
          "Rozszerz raportowanie i awareness na codzienną komunikację.",
          "Wspieraj szybsze działania następcze między bezpieczeństwem a operacjami."
        ],
        "summary": "Połącz platformy współpracy, aby synchronizować powiadomienia i rozszerzać workflowy bezpieczeństwa na codzienne kanały komunikacji.",
        "title": "Integracja z MS Teams i Slack"
      },
      "threat-management": {
        "items": [
          "Wgląd w zgłoszone zagrożenia w czasie rzeczywistym",
          "Branżowe alerty o nowych wzorcach ataków",
          "Analiza trendów zagrożeń w organizacji",
          "Działa bezpośrednio z Outlookiem i Gmailem."
        ],
        "summary": "Analizuj podejrzane wiadomości e-mail, rozumiej sygnały ryzyka i reaguj na zagrożenia z jednego workflow stworzonego dla zespołów bezpieczeństwa.",
        "title": "Zarządzanie zagrożeniami"
      }
    },
    "frameworks": {
      "ai_act": "AI Act",
      "dora": "DORA",
      "gdpr": "GDPR",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "nis2": "NIS2",
      "soc_2": "SOC 2"
    },
    "goals": {
      "metric": {
        "click_rate": "Współczynnik kliknięć",
        "employees_behind": "Pracownicy z zaległościami",
        "report_rate": "Współczynnik zgłoszeń",
        "resilience_score": "Wynik odporności"
      },
      "outcome": {
        "achieved": "Osiągnięty",
        "missed": "Nieosiągnięty"
      },
      "status": {
        "ahead": "Przed planem",
        "at_risk": "Zagrożone",
        "on_track": "Zgodnie z planem"
      }
    },
    "group": {
      "sync_failure": {
        "invalid_provider": {
          "subtitle": "Proszę wybrać prawidłowego dostawcę i odświeżyć dane."
        },
        "invalid_provider_id": {
          "subtitle": "Proszę wybrać prawidłowy identyfikator dostawcy i odświeżyć dane."
        },
        "no_available_integration": {
          "subtitle": "Proszę wybrać dostępną integrację."
        },
        "provider_resource_not_found": {
          "subtitle": "Proszę zaktualizować identyfikator dostawcy dla grup."
        },
        "recommended_action": "Zalecane działanie",
        "title": "Synchronizacja nie powiodła się"
      }
    },
    "groups": {
      "adaptive_conditions": {
        "fields": {
          "department": "Dział",
          "email": "E-mail",
          "locale": "Język",
          "manager_id": "Menedżer",
          "onboarded": "Status onboardingu",
          "organizational_role_id": "Rola",
          "provider": "Dostawca integracji",
          "score": "Wynik",
          "status": "Status",
          "timezone": "Strefa czasowa"
        },
        "operators": {
          "contains": "zawiera",
          "ends_with": "kończy się na",
          "equals": "jest",
          "greater_than": "jest większe niż",
          "greater_than_or_equal": "jest większe lub równe",
          "is_empty": "jest puste",
          "is_not_empty": "nie jest puste",
          "less_than": "jest mniejsze niż",
          "less_than_or_equal": "jest mniejsze lub równe",
          "not_equals": "nie jest",
          "starts_with": "zaczyna się od"
        },
        "values": {
          "active": "Aktywny",
          "false": "Fałsz",
          "google": "Google Workspace",
          "google_scim": "Google SCIM",
          "inactive": "Nieaktywny",
          "microsoft": "Microsoft Entra ID",
          "microsoft_scim": "Microsoft Entra SCIM",
          "okta_scim": "Okta SCIM",
          "slack": "Slack",
          "true": "Prawda"
        }
      }
    },
    "hri_integration_tags": {
      "access_permissions": {
        "description": "Zdarzenia dostępu, autoryzacja, uprawnienia i dostęp do aplikacji.",
        "headline": "Dostęp"
      },
      "account_security": {
        "description": "Stan, ochrona, zmiany i cykl życia kont oraz użytkownicy obciążeni ryzykiem.",
        "headline": "Bezpieczeństwo kont"
      },
      "audit_administration": {
        "description": "Dzienniki audytu, zdarzenia administracyjne i zmiany ustawień bezpieczeństwa.",
        "headline": "Dzienniki audytu"
      },
      "authentication_mfa": {
        "description": "Logowania, aktywność logowania, wyniki uwierzytelniania i zdarzenia MFA.",
        "headline": "Uwierzytelnianie"
      },
      "data_protection_insider_risk": {
        "description": "Zapobieganie utracie danych (DLP) i zdarzenia związane z ryzykiem wewnętrznym.",
        "headline": "Ochrona danych"
      },
      "device_management": {
        "description": "Zakres objęcia zarządzaniem, stan agentów i stan zabezpieczeń dostępu urządzeń.",
        "headline": "Zarządzanie urządzeniami"
      },
      "device_security": {
        "description": "Szyfrowanie, blokady ekranu, ochrona punktów końcowych i zgodność urządzeń.",
        "headline": "Bezpieczeństwo urządzeń"
      },
      "email_security": {
        "description": "Zagrożenia pocztowe i przejęcia kont.",
        "headline": "Bezpieczeństwo poczty"
      },
      "incidents_investigations": {
        "description": "Incydenty bezpieczeństwa, ich waga i stan dochodzeń.",
        "headline": "Incydenty"
      },
      "remediation_control_gaps": {
        "description": "Luki w ochronie, ustalenia dotyczące zabezpieczeń i postęp działań naprawczych.",
        "headline": "Luki w zabezpieczeniach"
      },
      "service_health": {
        "description": "Incydenty usług, stan komponentów i zaplanowane prace konserwacyjne.",
        "headline": "Stan usług"
      },
      "sharing_data_activity": {
        "description": "Zmiany udostępniania, przepływ danych, użycie elementów i aktywność Git.",
        "headline": "Aktywność związana z danymi"
      },
      "threats_detections": {
        "description": "Alerty bezpieczeństwa, sygnały zagrożeń i wykryte ryzyka.",
        "headline": "Zagrożenia"
      },
      "vulnerabilities_exposure": {
        "description": "Podatności, ustalenia dotyczące chmury i testów penetracyjnych oraz ekspozycja na zagrożenia.",
        "headline": "Podatności"
      },
      "workforce_organization": {
        "description": "Role, zespoły, zatrudnienie i organizacja pracy.",
        "headline": "Pracownicy"
      }
    },
    "hri_integrations": {
      "abnormal_ai": {
        "bullets": [
          {
            "label": "Rzeczywiste zagrożenia pocztowe",
            "text": "{label}: Wykryty phishing i inne obsługiwane ataki pocztowe dostarczają dowodów wykraczających poza symulacje."
          },
          {
            "label": "Przejęcie konta",
            "text": "{label}: Ustalenia dotyczące przejęć pomagają wskazać konta, które mogą wymagać pilnego zbadania."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotne dowody ataków, aby doprecyzować wskazówki dotyczące phishingu i bezpieczeństwa kont."
          },
          {
            "label": "Kontekst reagowania",
            "text": "{label}: Zarejestrowane działania naprawcze i stan spraw pomagają wyjaśnić, czym już się zajęto."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o zagrożeniach i reakcjach bez usuwania wiadomości ani podejmowania działań na kontach."
          }
        ],
        "description_long": "Abnormal AI wykrywa ataki pocztowe i przejęcia kont. Połącz tę usługę, aby Moxso mogło wykorzystywać sygnały rzeczywistych ataków do ukierunkowania działań dotyczących ryzyka ludzkiego na zagrożenia, z którymi pracownicy spotykają się w Twoim środowisku.",
        "description_short": "Wykorzystuj zagrożenia pocztowe i ustalenia dotyczące przejęć kont do ukierunkowania działań związanych z bezpieczeństwem.",
        "title": "Abnormal AI"
      },
      "aikido": {
        "bullets": [
          {
            "label": "Ustalenia dotyczące bezpieczeństwa",
            "text": "{label}: Podatności i inne obsługiwane problemy wskazują obszary wymagające uwagi technicznej."
          },
          {
            "label": "Kontekst ekspozycji",
            "text": "{label}: Waga problemu i informacje o zasobach, których dotyczy, pomagają wyjaśnić znaczenie ustalenia."
          },
          {
            "label": "Ukierunkowane działania",
            "text": "{label}: Wykorzystuj istotne ustalenia, aby kierować techniczne działania naprawcze i wskazówki dotyczące bezpieczeństwa do właściwych zespołów."
          },
          {
            "label": "Postęp w czasie",
            "text": "{label}: Zmiany stanu ustaleń pomagają odróżnić nierozwiązane problemy od tych, którymi już się zajęto."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane ustalenia dotyczące bezpieczeństwa bez zmieniania kodu ani stosowania poprawek."
          }
        ],
        "description_long": "Aikido Security identyfikuje słabe punkty oprogramowania i infrastruktury. Połącz tę usługę, aby uwzględniać istotną ekspozycję techniczną w kontekście przeglądów ryzyka ludzkiego i działań następczych związanych z bezpieczeństwem.",
        "description_short": "Uwzględniaj podatności oprogramowania i infrastruktury w przeglądach ryzyka.",
        "title": "Aikido Security"
      },
      "airtable": {
        "bullets": [
          {
            "label": "Ochrona kont",
            "text": "{label}: Dostępne wskaźniki uwierzytelniania i uprawnień pomagają wskazać problemy z dostępem."
          },
          {
            "label": "Rzeczywista aktywność",
            "text": "{label}: Wybrane zdarzenia audytu dostarczają dowodów działań i zmian istotnych dla bezpieczeństwa."
          },
          {
            "label": "Ukierunkowane wskazówki",
            "text": "{label}: Wykorzystuj istotne zdarzenia, aby ukierunkować porady na ochronę kont i odpowiedzialny dostęp do współdzielonych informacji."
          },
          {
            "label": "Bieżący przegląd",
            "text": "{label}: Rozpatruj zmiany bezpieczeństwa kont i powtarzające się zdarzenia wraz z innymi dowodami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez dostępu do rekordów tabel. Dostęp do Enterprise API wymaga odpowiedniego planu."
          }
        ],
        "description_long": "Airtable pomaga zespołom pracować ze współdzielonymi informacjami biznesowymi. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne sygnały bezpieczeństwa kont i audytu do oceny ryzyka ludzkiego i ukierunkowanych działań następczych.",
        "description_short": "Analizuj sygnały bezpieczeństwa kont i aktywność audytową związaną ze współdzielonymi informacjami biznesowymi.",
        "title": "Airtable"
      },
      "asana": {
        "bullets": [
          {
            "label": "Sygnały dostępu",
            "text": "{label}: Obsługiwane zdarzenia audytu wskazują aktywność wpływającą na dostęp do kont i projektów."
          },
          {
            "label": "Zmiany udostępniania",
            "text": "{label}: Wybrane zdarzenia członkostwa i dostępu przez link dostarczają dowodów zmian dostępu do współpracy."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj okoliczności zdarzenia do ukierunkowania przeglądów dostępu i wskazówek dotyczących bezpiecznego udostępniania."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się zmiany dostępu wraz z innymi dowodami dotyczącymi bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane metadane audytu bez dostępu do opisów zadań ani treści projektów. Dostępność audytu zależy od planu Asana."
          }
        ],
        "description_long": "Asana pomaga zespołom organizować i współdzielić pracę. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane zdarzenia dostępu i udostępniania do oceny ryzyka ludzkiego oraz wspierania bezpieczniejszej współpracy.",
        "description_short": "Wykorzystuj zdarzenia dostępu i udostępniania do wspierania bezpieczniejszej współpracy.",
        "title": "Asana"
      },
      "atlassian": {
        "bullets": [
          {
            "label": "Sygnały bezpieczeństwa kont",
            "text": "{label}: Obsługiwane zdarzenia audytu dostarczają dowodów aktywności związanej z dostępem."
          },
          {
            "label": "Wrażliwe zmiany",
            "text": "{label}: Działania administracyjne pomagają wskazać zmiany wymagające dokładniejszego przeglądu."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotne zdarzenia do ukierunkowania przeglądów dostępu i porad dotyczących bezpieczeństwa kont."
          },
          {
            "label": "Bieżąca świadomość",
            "text": "{label}: Przed podjęciem decyzji o działaniu rozpatruj powtarzającą się aktywność wraz z innymi dowodami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane metadane audytu bez dostępu do treści zgłoszeń Jira ani stron Confluence."
          }
        ],
        "description_long": "Atlassian wspiera współpracę w całej organizacji. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane zdarzenia dotyczące kont i administracji do oceny ryzyka ludzkiego i ukierunkowania odpowiednich działań następczych.",
        "description_short": "Analizuj aktywność kont i działania administracyjne w narzędziach do współpracy.",
        "title": "Atlassian"
      },
      "auth0": {
        "bullets": [
          {
            "label": "Rzeczywiste sygnały logowania",
            "text": "{label}: Wybrane nieudane logowania, zdarzenia MFA i zdarzenia związane z atakami ujawniają problemy z dostępem."
          },
          {
            "label": "Ochrona kont",
            "text": "{label}: Zmiany danych uwierzytelniających i zmiany kont związane z bezpieczeństwem dostarczają dodatkowych dowodów do przeglądu."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj aktywność, którą można powiązać z pracownikami, do ukierunkowania dochodzeń i porad dotyczących bezpieczeństwa kont."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się problemy z uwierzytelnianiem w kontekście danej aplikacji."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybraną aktywność bez zmieniania kont aplikacji ani ustawień uwierzytelniania."
          }
        ],
        "description_long": "Auth0 obsługuje logowanie do Twoich aplikacji. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne sygnały uwierzytelniania i bezpieczeństwa kont do oceny ryzyka ludzkiego, gdy aktywność dotyczy Twoich pracowników.",
        "description_short": "Wykorzystuj zdarzenia logowania pracowników i bezpieczeństwa kont w przeglądach ryzyka.",
        "title": "Auth0"
      },
      "clerk": {
        "bullets": [
          {
            "label": "Stan kont",
            "text": "{label}: Dostępne informacje o zablokowanych i wykluczonych kontach pomagają wskazać konta wymagające dokładniejszego przeglądu."
          },
          {
            "label": "Kontekst dostępu",
            "text": "{label}: Członkostwo w organizacji pomaga spojrzeć na dostęp do aplikacji w szerszym kontekście."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotny kontekst kont do ukierunkowania przeglądów dostępu i rozmów o bezpieczeństwie kont."
          },
          {
            "label": "Aktualny obraz",
            "text": "{label}: Przy ustalaniu, co wymaga uwagi, uwzględniaj najnowszy stan kont wraz z innymi dowodami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o kontach i dostępie bez zmieniania ustawień Clerk. To połączenie nie zbiera zdarzeń logowania ani aktywności sesji."
          }
        ],
        "description_long": "Clerk zarządza dostępem do Twoich aplikacji. Połącz tę usługę, aby Moxso mogło uwzględniać kontekst dostępu do kont obok ryzyka ludzkiego i lepiej dopasowywać działania następcze związane z bezpieczeństwem kont.",
        "description_short": "Wykorzystuj stan kont i członkostwo w organizacji w przeglądach dostępu.",
        "title": "Clerk"
      },
      "cloudflare_zero_trust": {
        "bullets": [
          {
            "label": "Zmiany bezpieczeństwa",
            "text": "{label}: Wybrane zdarzenia audytu wskazują zmiany ustawień i zasobów związanych z dostępem."
          },
          {
            "label": "Kontekst dostępu",
            "text": "{label}: Dostępne szczegóły wykonawcy, działania i wyniku pomagają wyjaśnić znaczenie zdarzenia."
          },
          {
            "label": "Ukierunkowany przegląd",
            "text": "{label}: Wykorzystuj wrażliwe zmiany do wskazywania obszarów wymagających przeglądu dostępu lub działań następczych związanych z bezpieczeństwem."
          },
          {
            "label": "Bieżąca widoczność",
            "text": "{label}: Rozpatruj powtarzające się zmiany administracyjne wraz z innymi dowodami dotyczącymi bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez zmieniania zasad dostępu. To połączenie nie zapewnia monitorowania ruchu ani telemetrii logowań Access."
          }
        ],
        "description_long": "Cloudflare Zero Trust chroni dostęp do zasobów firmowych. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane zmiany bezpieczeństwa i kontroli dostępu jako kontekst oceny ryzyka ludzkiego i dochodzeń.",
        "description_short": "Analizuj zmiany bezpieczeństwa i kontroli dostępu wpływające na zasoby firmowe.",
        "title": "Cloudflare Zero Trust"
      },
      "comp_ai": {
        "bullets": [
          {
            "label": "Ustalenia dotyczące bezpieczeństwa",
            "text": "{label}: Obsługiwane ustalenia wskazują sytuacje wymagające przeglądu lub działań naprawczych."
          },
          {
            "label": "Kontekst ochrony",
            "text": "{label}: Dostępne kontrole bezpieczeństwa urządzeń, w tym stan szyfrowania, pomagają wyjaśnić problem."
          },
          {
            "label": "Praktyczne działania",
            "text": "{label}: Wykorzystuj istotne dowody do ukierunkowania działań z pracownikiem, zespołem IT lub osobą odpowiedzialną za zabezpieczenie."
          },
          {
            "label": "Zmieniające się warunki",
            "text": "{label}: Aktualizacje ustaleń i stanu ochrony pomagają odróżnić utrzymujące się problemy od rozwiązanych."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane dowody dotyczące bezpieczeństwa bez wykonywania zadań ani zmieniania zasad."
          }
        ],
        "description_long": "Comp AI śledzi zabezpieczenia i ustalenia dotyczące zgodności. Połącz tę usługę, aby Moxso mogło uwzględniać istotne luki w ochronie podczas przeglądów ryzyka ludzkiego i ustalania, gdzie potrzebne są działania następcze.",
        "description_short": "Wykorzystuj ustalenia dotyczące bezpieczeństwa i luki w ochronie urządzeń do ukierunkowania działań następczych.",
        "title": "Comp AI"
      },
      "crowdstrike": {
        "bullets": [
          {
            "label": "Sygnały rzeczywistych ataków",
            "text": "{label}: Alerty punktów końcowych dostarczają dowodów podejrzanej lub złośliwej aktywności."
          },
          {
            "label": "Kontekst ekspozycji",
            "text": "{label}: Waga problemu, zasoby, których dotyczy, i dostępne szczegóły podatności pomagają umieścić ustalenia w szerszym kontekście."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotne ustalenia do koordynowania dochodzeń, napraw urządzeń i wskazówek dla pracowników."
          },
          {
            "label": "Postęp dochodzenia",
            "text": "{label}: Stan ustaleń i spraw pomaga wskazać problemy, które nadal wymagają uwagi."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane ustalenia dotyczące bezpieczeństwa bez izolowania hostów ani zmieniania dochodzeń."
          }
        ],
        "description_long": "CrowdStrike Falcon wykrywa zagrożenia na urządzeniach służbowych. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne ustalenia dotyczące punktów końcowych do oceny ryzyka ludzkiego i skupiania działań następczych na rzeczywistych problemach bezpieczeństwa.",
        "description_short": "Uwzględniaj alerty punktów końcowych i ustalenia dotyczące podatności w przeglądach ryzyka.",
        "title": "CrowdStrike"
      },
      "datadog": {
        "bullets": [
          {
            "label": "Sygnały bezpieczeństwa",
            "text": "{label}: Wybrane ustalenia dostarczają dowodów aktywności wymagającej zbadania."
          },
          {
            "label": "Aktywność kont",
            "text": "{label}: Obsługiwane zdarzenia uwierzytelniania, dostępu i konfiguracji bezpieczeństwa dostarczają kontekstu."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj dowody związane z pracownikami do ukierunkowania przeglądów bezpieczeństwa kont i odpowiednich porad."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się zdarzenia i aktualizacje ustaleń wraz z innymi dowodami dotyczącymi ryzyka."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez importowania ogólnych metryk aplikacji ani zmieniania ustawień."
          }
        ],
        "description_long": "Datadog identyfikuje aktywność związaną z bezpieczeństwem w monitorowanych środowiskach. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne ustalenia dotyczące bezpieczeństwa i zdarzenia kont w przeglądach ryzyka ludzkiego.",
        "description_short": "Dodawaj ustalenia dotyczące bezpieczeństwa i aktywność kont z monitorowanych środowisk.",
        "title": "Datadog"
      },
      "deel": {
        "bullets": [
          {
            "label": "Kontekst roli",
            "text": "{label}: Obowiązki i działy pomagają spojrzeć na problemy bezpieczeństwa w szerszym kontekście."
          },
          {
            "label": "Zmiany kadrowe",
            "text": "{label}: Zmiany statusu zatrudnienia dostarczają kontekstu do oceny, czy dostęp nadal jest odpowiedni."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Przy wyborze porad dotyczących bezpieczeństwa i tematów budowania świadomości uwzględniaj kontekst pracy danej osoby."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj kontekst roli i cyklu zatrudnienia wraz z dowodami dotyczącymi bezpieczeństwa, aby prowadzić rozmowy z właściwymi osobami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje kadrowe bez zmieniania dokumentacji zatrudnienia ani przetwarzania list płac."
          }
        ],
        "description_long": "Deel pomaga zarządzać pracownikami pełniącymi różne role i pracującymi w różnych modelach. Połącz tę usługę, aby Moxso mogło uwzględniać istotny kontekst kadrowy podczas przeglądów ryzyka ludzkiego i planowania działań następczych związanych z bezpieczeństwem.",
        "description_short": "Dodawaj kontekst kadrowy z globalnej dokumentacji pracowników.",
        "title": "Deel"
      },
      "drata": {
        "bullets": [
          {
            "label": "Sygnały ochrony",
            "text": "{label}: Obsługiwane kontrole szyfrowania, antywirusa, zapory, aktualizacji i blokady ekranu pomagają identyfikować słabe punkty."
          },
          {
            "label": "Codzienne bezpieczeństwo",
            "text": "{label}: Kontrole menedżera haseł i inne dostępne kontrole zabezpieczeń dostarczają kontekstu dla praktycznych nawyków bezpieczeństwa."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj konkretne luki do ustalania, co wymaga wskazówek dla pracowników, a co działania IT."
          },
          {
            "label": "Ciągłe doskonalenie",
            "text": "{label}: Rozpatruj zmieniające się wyniki kontroli wraz z innymi dowodami dotyczącymi ryzyka ludzkiego."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane dowody dotyczące bezpieczeństwa bez zmieniania wyników kontroli ani ustawień urządzeń."
          }
        ],
        "description_long": "Drata zbiera dowody dotyczące zabezpieczeń w miejscu pracy. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne luki w zabezpieczeniach jako kontekst oceny ryzyka ludzkiego i bardziej ukierunkowanych działań następczych.",
        "description_short": "Wykorzystuj kontrole bezpieczeństwa urządzeń i miejsca pracy do identyfikowania luk w ochronie.",
        "title": "Drata"
      },
      "duo": {
        "bullets": [
          {
            "label": "Rzeczywiste sygnały uwierzytelniania",
            "text": "{label}: Zdarzenia udanego, odrzuconego i nieudanego uwierzytelniania oraz zgłoszonego oszustwa pomagają wskazać aktywność wymagającą przeglądu."
          },
          {
            "label": "Przydatny kontekst",
            "text": "{label}: Dostępne czynniki uwierzytelniania i przyczyny wyników pomagają wyjaśnić, co się wydarzyło."
          },
          {
            "label": "Ukierunkowane wskazówki",
            "text": "{label}: Kieruj porady dotyczące rozpoznawania nieoczekiwanych próśb o uwierzytelnienie i ochrony dostępu tam, gdzie występują istotne zdarzenia."
          },
          {
            "label": "Powtarzająca się aktywność",
            "text": "{label}: Przed podjęciem decyzji o działaniu rozpatruj powtarzające się odmowy lub niepowodzenia wraz z innymi dowodami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje aktywność uwierzytelniania i wybraną aktywność związaną z bezpieczeństwem bez zatwierdzania żądań ani zmieniania zasad Duo."
          }
        ],
        "description_long": "Duo pomaga chronić konta za pomocą uwierzytelniania wieloskładnikowego. Połącz tę usługę, aby Moxso mogło wykorzystywać rzeczywiste wyniki uwierzytelniania do ukierunkowania działań dotyczących nawyków MFA i bezpieczeństwa kont.",
        "description_short": "Wykorzystuj wyniki uwierzytelniania do ukierunkowania działań dotyczących MFA i bezpieczeństwa kont.",
        "title": "Duo"
      },
      "fortinet_fortianalyzer": {
        "bullets": [
          {
            "label": "Sygnały dostępu",
            "text": "{label}: Obsługiwane wyniki uwierzytelniania pomagają wskazać aktywność kont wartą zbadania."
          },
          {
            "label": "Wrażliwe zmiany",
            "text": "{label}: Zdarzenia administracyjne dostarczają dowodów zmian wpływających na Twoje środowisko."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotną aktywność kont do ukierunkowania dochodzeń i porad dotyczących bezpieczeństwa dostępu."
          },
          {
            "label": "Powtarzające się wzorce",
            "text": "{label}: Przed wyborem reakcji rozpatruj powtarzające się problemy z dostępem wraz z innymi sygnałami."
          },
          {
            "label": "Dostęp do danych",
            "text": "{label}: Wykorzystuje zadania przeszukiwania dzienników do odczytu wybranych zdarzeń bez zmieniania konfiguracji zapory."
          }
        ],
        "description_long": "FortiAnalyzer zbiera aktywność związaną z bezpieczeństwem ze środowiska Fortinet. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane zdarzenia dostępu i administracji w przeglądach ryzyka ludzkiego.",
        "description_short": "Analizuj zdarzenia uwierzytelniania i administracji ze środowiska Fortinet.",
        "title": "FortiAnalyzer"
      },
      "github_enterprise": {
        "bullets": [
          {
            "label": "Wrażliwe zmiany",
            "text": "{label}: Wybrane zdarzenia audytu wskazują zmiany dostępu, uprawnień i bezpieczeństwa kont."
          },
          {
            "label": "Aktywność dostępu do kodu",
            "text": "{label}: Obsługiwane zdarzenia Git dostarczają dodatkowych dowodów dotyczących dostępu do repozytoriów."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Wykorzystuj zdarzenia związane z pracownikami do ukierunkowania porad dotyczących ochrony danych uwierzytelniających i bezpiecznych praktyk programistycznych."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzającą się aktywność dostępu i wrażliwe zmiany w kontekście pracy."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane metadane aktywności bez dostępu do kodu źródłowego repozytoriów."
          }
        ],
        "description_long": "GitHub Enterprise chroni dostęp do kodu źródłowego i procesów programistycznych. Połącz tę usługę, aby Moxso mogło wykorzystywać istotną aktywność kont programistów do oceny ryzyka ludzkiego i ukierunkowanych działań następczych związanych z bezpieczeństwem.",
        "description_short": "Wykorzystuj aktywność kont programistów i dostępu do repozytoriów do ukierunkowania działań związanych z bezpieczeństwem.",
        "title": "GitHub Enterprise"
      },
      "google_workspace": {
        "bullets": [
          {
            "label": "Sygnały rzeczywistej aktywności",
            "text": "{label}: Wybrane zdarzenia logowania, bezpieczeństwa kont i administracji wskazują aktywność wartą przeglądu."
          },
          {
            "label": "Ryzyko udostępniania",
            "text": "{label}: Obsługiwane pobrania, zmiany udostępniania i zdarzenia autoryzacji aplikacji dostarczają dowodów sposobu uzyskiwania dostępu do informacji."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Kieruj wskazówki dotyczące ochrony kont, aplikacji zewnętrznych i bezpiecznego udostępniania tam, gdzie dowody wskazują taką potrzebę."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się zdarzenia i zmieniające się zachowania związane z dostępem wraz z wynikami dotyczącymi świadomości."
          },
          {
            "label": "Dostęp do odczytu",
            "text": "{label}: Odczytuje wybrane metadane bezpieczeństwa bez czytania wiadomości Gmail ani zawartości plików Drive."
          }
        ],
        "description_long": "Google Workspace to miejsce, w którym pracownicy logują się, udostępniają pliki i autoryzują aplikacje. Połącz tę usługę, aby Moxso mogło wykorzystywać aktywność istotną dla bezpieczeństwa do oceny ryzyka ludzkiego i lepszego dopasowania działań następczych do codziennej pracy.",
        "description_short": "Analizuj aktywność logowania, udostępniania i dostępu aplikacji na potrzeby oceny ryzyka ludzkiego.",
        "title": "Google Workspace"
      },
      "gusto": {
        "bullets": [
          {
            "label": "Znajomość roli",
            "text": "{label}: Kontekst stanowiska i działu pomaga wyjaśnić pracę stojącą za aktywnością konta."
          },
          {
            "label": "Zmiany zatrudnienia",
            "text": "{label}: Dostępne informacje o statusie zatrudnienia wspierają rozmowy o dostępie w miarę zmiany okoliczności."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Uwzględniaj obowiązki przy wyborze tematów budowania świadomości i praktycznych porad dotyczących bezpieczeństwa."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Przy ustalaniu, co wymaga uwagi, wykorzystuj kontekst zatrudnienia wraz z sygnałami bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje o zatrudnieniu bez zmieniania wynagrodzeń ani naliczania płac."
          }
        ],
        "description_long": "Gusto przechowuje informacje o zatrudnieniu, gdy pracownicy dołączają, zmieniają role i odchodzą. Połącz tę usługę, aby Moxso mogło uwzględniać ten kontekst podczas przeglądów ryzyka ludzkiego i dopasowywać działania następcze do obowiązków danej osoby.",
        "description_short": "Dodawaj kontekst kadrowy z dokumentacji pracowników.",
        "title": "Gusto"
      },
      "hibob": {
        "bullets": [
          {
            "label": "Kontekst roli",
            "text": "{label}: Obowiązki i działy pomagają spojrzeć na aktywność związaną z bezpieczeństwem w szerszym kontekście."
          },
          {
            "label": "Środowisko pracy",
            "text": "{label}: Dostępne informacje o miejscu pracy dostarczają kontekstu pozwalającego zrozumieć sytuację danej osoby."
          },
          {
            "label": "Zmiany w cyklu zatrudnienia",
            "text": "{label}: Zmiany statusu zatrudnienia mogą wspierać dyskusje o dostępie do kont i obowiązkach dotyczących bezpieczeństwa."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj kontekst pracy wraz z rzeczywistymi dowodami dotyczącymi bezpieczeństwa do formułowania praktycznych porad."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje kadrowe bez zmieniania dokumentacji HR ani uzyskiwania przez to połączenie dostępu do ocen pracowniczych."
          }
        ],
        "description_long": "HiBob dostarcza kontekstu dotyczącego ról pracowników i środowiska pracy. Połącz tę usługę, aby Moxso mogło uwzględniać ten kontekst obok ryzyka ludzkiego i lepiej dopasowywać działania następcze związane z bezpieczeństwem do codziennej pracy.",
        "description_short": "Dodawaj kontekst pracowników i ról zawodowych z systemu HR.",
        "title": "HiBob"
      },
      "hubspot": {
        "bullets": [
          {
            "label": "Sygnały logowania",
            "text": "{label}: Zdarzenia udanego i nieudanego logowania pomagają wskazać problemy z dostępem do kont."
          },
          {
            "label": "Wrażliwe działania",
            "text": "{label}: Wybrane zdarzenia dotyczące uprawnień, danych uwierzytelniających, integracji i przepływu danych dostarczają kontekstu."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Wykorzystuj aktywność związaną z pracownikami do ukierunkowania porad dotyczących bezpieczeństwa kont i postępowania z informacjami o klientach."
          },
          {
            "label": "Powracające problemy",
            "text": "{label}: Przed wyborem reakcji rozpatruj powtarzające się zdarzenia wraz z innymi dowodami dotyczącymi ryzyka."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybraną aktywność związaną z bezpieczeństwem bez dostępu do kontaktów CRM, transakcji ani treści marketingowych."
          }
        ],
        "description_long": "HubSpot wspiera pracę z informacjami o klientach. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne zdarzenia dostępu do kont i bezpieczeństwa do oceny ryzyka ludzkiego i dopasowywania działań następczych do tej pracy.",
        "description_short": "Analizuj aktywność logowania i bezpieczeństwa związaną z dostępem do informacji o klientach.",
        "title": "HubSpot"
      },
      "iru": {
        "bullets": [
          {
            "label": "Zakres ochrony",
            "text": "{label}: Wskaźniki zarządzania i stanu agentów pomagają wskazać urządzenia wymagające uwagi."
          },
          {
            "label": "Dostępność urządzeń",
            "text": "{label}: Informacje o ostatnim kontakcie i wskaźniki brakujących urządzeń pozwalają ocenić aktualność informacji o ochronie."
          },
          {
            "label": "Istotna aktywność",
            "text": "{label}: Wybrane zdarzenia audytu związane z bezpieczeństwem pomagają wyjaśnić zmiany wymagające przeglądu."
          },
          {
            "label": "Praktyczne działania następcze",
            "text": "{label}: Wykorzystuj luki w ochronie do ukierunkowania działań z pracownikami i IT."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje o bezpieczeństwie urządzeń bez wykonywania działań na urządzeniach."
          }
        ],
        "description_long": "Iru pomaga organizacjom zarządzać urządzeniami służbowymi i je chronić. Połącz tę usługę, aby Moxso mogło uwzględniać luki w objęciu urządzeń zarządzaniem podczas przeglądów ryzyka ludzkiego.",
        "description_short": "Identyfikuj luki w objęciu urządzeń zarządzaniem i ochronie zapewnianej przez agentów.",
        "title": "Iru"
      },
      "jamf_pro": {
        "bullets": [
          {
            "label": "Ochrona urządzeń",
            "text": "{label}: Obsługiwane informacje o FileVault i kodach dostępu mogą wskazać ustawienia bezpieczeństwa wymagające uwagi."
          },
          {
            "label": "Zakres zarządzania",
            "text": "{label}: Dostępny stan zarządzania pomaga ustalić, czy urządzenie znajduje się pod kontrolą organizacji."
          },
          {
            "label": "Praktyczne działania następcze",
            "text": "{label}: Luki w ochronie mogą ukierunkować rozmowy z pracownikami i zespołem IT odpowiedzialnym za ich urządzenia."
          },
          {
            "label": "Przeglądy oparte na informacjach",
            "text": "{label}: Rozpatruj stan urządzeń wraz z innymi dowodami, zamiast traktować niespełnienie wymogów zabezpieczenia jako dowód niebezpiecznego zachowania."
          },
          {
            "label": "Stan połączenia",
            "text": "{label}: Tej integracji nie można obecnie połączyć w katalogu zarejestrowanych dostawców."
          }
        ],
        "description_long": "Dostępność: Obecnie niedostępna. Jamf Pro pomaga chronić urządzenia Apple używane do pracy. Informacje o bezpieczeństwie urządzeń mogą pomóc umieścić ryzyko ludzkie w kontekście i odróżnić luki w ochronie od problemów wymagających wskazówek dla pracowników.",
        "description_short": "Zarządzanie urządzeniami Apple. Ta integracja jest obecnie niedostępna.",
        "title": "Jamf Pro"
      },
      "jumpcloud": {
        "bullets": [
          {
            "label": "Dowody uwierzytelniania",
            "text": "{label}: Wybrane zdarzenia Directory Insights pokazują udane i nieudane próby dostępu."
          },
          {
            "label": "Wrażliwa aktywność",
            "text": "{label}: Obsługiwane zdarzenia administracyjne i dostępu uprzywilejowanego wskazują zmiany wymagające uwagi."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj dowody związane z kontami do ukierunkowania dochodzeń i wskazówek dotyczących bezpieczeństwa dostępu."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Analizuj powtarzające się problemy z uwierzytelnianiem i wrażliwe zmiany wraz z innymi sygnałami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez zmieniania ustawień JumpCloud."
          }
        ],
        "description_long": "JumpCloud pomaga zabezpieczać dostęp do aplikacji i urządzeń. Połącz tę usługę, aby Moxso mogło wykorzystywać rzeczywiste sygnały uwierzytelniania i administracji do oceny ryzyka ludzkiego oraz skupiania działań następczych na istotnych problemach z dostępem.",
        "description_short": "Wykorzystuj zdarzenia uwierzytelniania i administracji do przeglądu ryzyka związanego z dostępem.",
        "title": "JumpCloud"
      },
      "lattice": {
        "bullets": [
          {
            "label": "Znajomość roli",
            "text": "{label}: Kontekst stanowiska i działu pomaga wyjaśnić obowiązki danej osoby."
          },
          {
            "label": "Cykl życia konta",
            "text": "{label}: Dostępne informacje o stanie konta dostarczają kontekstu, gdy osoby zaczynają lub przestają korzystać z aplikacji."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Uwzględniaj obowiązki służbowe przy wyborze tematów bezpieczeństwa i praktycznych porad."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: W rozmowach o dostępie i działaniach następczych wykorzystuj kontekst organizacyjny wraz z dowodami dotyczącymi bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje o kontach i organizacji bez uzyskiwania przez to połączenie dostępu do ocen pracowniczych, opinii ani wynagrodzeń."
          }
        ],
        "description_long": "Lattice dostarcza kontekstu dotyczącego ról i obowiązków w organizacji. Połącz tę usługę, aby Moxso mogło uwzględniać ten kontekst podczas przeglądów ryzyka ludzkiego i wyboru odpowiednich działań następczych związanych z bezpieczeństwem.",
        "description_short": "Dodawaj kontekst profili pracowników i struktury zespołów.",
        "title": "Lattice"
      },
      "linear": {
        "bullets": [
          {
            "label": "Zmiany kont",
            "text": "{label}: Obsługiwane zdarzenia audytu wskazują zmiany istotne dla bezpieczeństwa, takie jak zawieszenie konta."
          },
          {
            "label": "Kontekst dostępu",
            "text": "{label}: Dostępne szczegóły wykonawcy i działania pomagają wyjaśnić, co się wydarzyło."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotne zdarzenia do ukierunkowania przeglądów dostępu do kont i rozmów o bezpieczeństwie."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się zmiany wraz z innymi sygnałami bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane metadane audytu bez dostępu do treści zgłoszeń. Dzienniki audytu wymagają odpowiedniego planu Enterprise."
          }
        ],
        "description_long": "Linear wspiera współpracę zespołów produktowych i inżynierskich. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane zmiany kont i dostępu do oceny ryzyka ludzkiego i ukierunkowania działań następczych związanych z bezpieczeństwem.",
        "description_short": "Analizuj zmiany kont i dostępu w zespołach produktowych i inżynierskich.",
        "title": "Linear"
      },
      "microsoft_defender_xdr": {
        "bullets": [
          {
            "label": "Rzeczywiste sygnały zagrożeń",
            "text": "{label}: Alerty i incydenty wskazują aktywność, którą Microsoft uznaje za podejrzaną lub złośliwą."
          },
          {
            "label": "Kontekst ekspozycji",
            "text": "{label}: Dostępne ustalenia dotyczące punktów końcowych i podatności pomagają wyjaśnić okoliczności zdarzenia."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Nadawaj priorytet dochodzeniom i odpowiednim wskazówkom dotyczącym bezpieczeństwa, gdy ustalenia dotyczą osób lub ich urządzeń służbowych."
          },
          {
            "label": "Postęp dochodzenia",
            "text": "{label}: Zmiany stanu ustaleń pomagają odróżnić aktywne problemy od rozwiązanych."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane ustalenia bez izolowania urządzeń, zamykania incydentów ani stosowania poprawek."
          }
        ],
        "description_long": "Microsoft Defender XDR identyfikuje zagrożenia w środowisku Microsoft. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne alerty i incydenty do opierania przeglądów ryzyka ludzkiego na rzeczywistych zdarzeniach bezpieczeństwa.",
        "description_short": "Uwzględniaj alerty bezpieczeństwa, incydenty i podatności Microsoft w przeglądach ryzyka.",
        "title": "Microsoft Defender XDR"
      },
      "microsoft_entra": {
        "bullets": [
          {
            "label": "Sygnały rzeczywistych ataków",
            "text": "{label}: Wyciekłe dane uwierzytelniające, ataki password spray, nietypowe podróże i nierozpoznane logowania mogą ujawnić konta wymagające uwagi."
          },
          {
            "label": "Kontekst ryzyka ludzkiego",
            "text": "{label}: Poziomy ryzyka i szczegóły wykrycia pomagają spojrzeć na podejrzaną aktywność w szerszym kontekście."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Skupiaj dochodzenia i wskazówki dotyczące bezpieczeństwa kont na osobach dotkniętych istotnymi zdarzeniami."
          },
          {
            "label": "Ryzyko w czasie",
            "text": "{label}: Zmiany stanu ryzyka z aktywnego na usunięte lub odrzucone pomagają ustalić, co nadal wymaga uwagi."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje stan użytkowników obciążonych ryzykiem i wykryte ryzyka. Szczegółowość sygnałów zależy od licencji Microsoft; wykrycia premium mogą wymagać Entra ID P2."
          }
        ],
        "description_long": "Entra ID Protection oznacza logowania i konta wykazujące oznaki naruszenia bezpieczeństwa. Połącz tę usługę, aby Moxso mogło wykorzystywać rzeczywiste sygnały ryzyka tożsamości do planowania działań następczych na podstawie zdarzeń w Twoim środowisku, obok symulacji.",
        "description_short": "Wykorzystuj ryzykowne logowania i sygnały przejęcia kont do ukierunkowania działań związanych z bezpieczeństwem.",
        "title": "Microsoft Entra ID Protection"
      },
      "microsoft_intune": {
        "bullets": [
          {
            "label": "Sygnały bezpieczeństwa urządzeń",
            "text": "{label}: Dostępne stany zgodności i szyfrowania wskazują luki w ochronie."
          },
          {
            "label": "Istotne zmiany",
            "text": "{label}: Wybrane zdarzenia zarządzania dostarczają kontekstu działań wpływających na bezpieczeństwo urządzeń."
          },
          {
            "label": "Praktyczne działania następcze",
            "text": "{label}: Pomagaj odróżnić problem urządzenia wymagający uwagi IT od tematu, który można poruszyć we wskazówkach dla pracowników."
          },
          {
            "label": "Zmieniający się stan zabezpieczeń",
            "text": "{label}: Podczas przeglądów ryzyka uwzględniaj aktualny stan ochrony i powracające luki."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje o bezpieczeństwie urządzeń i audycie bez zmieniania ustawień urządzeń. Wymaga odpowiedniego dostępu do Intune i licencji."
          }
        ],
        "description_long": "Microsoft Intune pomaga chronić urządzenia używane do pracy. Połącz tę usługę, aby Moxso mogło uwzględniać stan zabezpieczeń punktów końcowych obok ryzyka ludzkiego i ukierunkowywać praktyczne działania następcze.",
        "description_short": "Analizuj luki w zgodności i szyfrowaniu urządzeń obok ryzyka ludzkiego.",
        "title": "Microsoft Intune"
      },
      "microsoft_purview": {
        "bullets": [
          {
            "label": "Sygnały ochrony danych",
            "text": "{label}: Obsługiwane zdarzenia DLP wskazują aktywność, która uruchomiła regułę postępowania z danymi."
          },
          {
            "label": "Dodatkowy kontekst ryzyka",
            "text": "{label}: Wybrane zdarzenia ryzyka wewnętrznego dostarczają dodatkowych dowodów do dochodzeń, jeśli są dostępne."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Wykorzystuj okoliczności zdarzenia do ukierunkowania porad dotyczących bezpiecznego postępowania z informacjami firmowymi i ich udostępniania."
          },
          {
            "label": "Przegląd oparty na informacjach",
            "text": "{label}: Przed wyciągnięciem wniosków o zachowaniu lub zamiarach rozpatruj powtarzające się sygnały i ich kontekst."
          },
          {
            "label": "Ograniczony dostęp",
            "text": "{label}: Odczytuje wybrane metadane aktywności i może inicjować wymagane kanały danych. Nie zmienia zasad ochrony danych."
          }
        ],
        "description_long": "Microsoft Purview pomaga identyfikować ryzykowne postępowanie z poufnymi informacjami. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne sygnały ochrony danych do ukierunkowania przeglądów ryzyka ludzkiego i bardziej precyzyjnych działań następczych.",
        "description_short": "Wykorzystuj zdarzenia ochrony danych i ryzyka wewnętrznego do wspierania bezpiecznego postępowania z informacjami.",
        "title": "Microsoft Purview"
      },
      "microsoft_sentinel": {
        "bullets": [
          {
            "label": "Rzeczywiste incydenty",
            "text": "{label}: Waga i szczegóły incydentów dostarczają dowodów problemów bezpieczeństwa, które są już badane."
          },
          {
            "label": "Przydatny kontekst",
            "text": "{label}: Dostępne informacje o źródle i ataku pomagają wyjaśnić znaczenie incydentu."
          },
          {
            "label": "Skoordynowane działania następcze",
            "text": "{label}: Wykorzystuj istotne dowody z incydentów, aby dostosować wskazówki dla pracowników do reakcji zespołu bezpieczeństwa."
          },
          {
            "label": "Postęp dochodzenia",
            "text": "{label}: Zmiany stanu pomagają odróżnić nowe, aktywne i rozwiązane problemy."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o incydentach bez zmieniania dochodzeń ani wykonywania ogólnych wyszukiwań w dziennikach."
          }
        ],
        "description_long": "Microsoft Sentinel gromadzi incydenty bezpieczeństwa na potrzeby dochodzeń. Połącz tę usługę, aby Moxso mogło uwzględniać istotne incydenty obok ryzyka ludzkiego i pomagać w uzgadnianiu działań następczych z zespołem bezpieczeństwa.",
        "description_short": "Wykorzystuj incydenty bezpieczeństwa i stan dochodzeń do koordynowania działań następczych.",
        "title": "Microsoft Sentinel"
      },
      "monday": {
        "bullets": [
          {
            "label": "Stan kont",
            "text": "{label}: Dostępne stany aktywności i nieaktywności pomagają wskazać konta, które mogą wymagać przeglądu."
          },
          {
            "label": "Kontekst dostępu",
            "text": "{label}: Typy kont i powiązania z zespołami pomagają spojrzeć na dostęp do aplikacji w szerszym kontekście."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Przy ustalaniu, gdzie potrzebna jest uwaga, uwzględniaj kontekst kont wraz z sygnałami bezpieczeństwa."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj ten kontekst do ukierunkowania rozmów o bezpieczeństwie kont i odpowiednim dostępie."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o dostępie do kont bez zmieniania ustawień monday.com ani uzyskiwania dostępu do treści tablic i elementów."
          }
        ],
        "description_long": "monday.com pomaga zespołom organizować pracę i współpracować między działami. Połącz tę usługę, aby Moxso mogło uwzględniać kontekst dostępu do aplikacji obok ryzyka ludzkiego i lepiej dopasowywać działania następcze związane z bezpieczeństwem kont.",
        "description_short": "Wykorzystuj stan kont i powiązania z zespołami w przeglądach dostępu.",
        "title": "monday.com"
      },
      "new_relic": {
        "bullets": [
          {
            "label": "Kontekst dostępu",
            "text": "{label}: Dostępne powiązania kont pomagają spojrzeć na dostęp do środowiska monitorowania w szerszym kontekście."
          },
          {
            "label": "Kontekst organizacyjny",
            "text": "{label}: Członkostwo w grupach dostarcza informacji przydatnych w przeglądzie sposobu organizacji dostępu."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Przy ustalaniu, co wymaga uwagi, uwzględniaj dostęp do aplikacji wraz z innymi dowodami."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj kontekst dostępu do ukierunkowania rozmów o bezpieczeństwie kont z odpowiedzialnymi zespołami."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o dostępie do kont bez zmieniania ustawień New Relic. To połączenie nie zbiera alertów monitorowania, telemetrii aplikacji ani zdarzeń audytu."
          }
        ],
        "description_long": "New Relic wspiera zespoły odpowiedzialne za monitorowanie Twoich systemów. Połącz tę usługę, aby Moxso mogło uwzględniać kontekst dostępu do aplikacji obok ryzyka ludzkiego i pomagać w ukierunkowaniu przeglądów bezpieczeństwa kont.",
        "description_short": "Dodawaj kontekst katalogu użytkowników i członkostwa w grupach z New Relic.",
        "title": "New Relic"
      },
      "okta": {
        "bullets": [
          {
            "label": "Sygnały uwierzytelniania",
            "text": "{label}: Wyniki logowania i wybrane zdarzenia bezpieczeństwa dostarczają dowodów sposobu korzystania z kont."
          },
          {
            "label": "Wrażliwe zmiany",
            "text": "{label}: Zmiany kont i uprawnień pomagają wskazać dostęp wymagający dokładniejszego przeglądu."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Wykorzystuj istotne zdarzenia do ukierunkowania dochodzeń i praktycznych porad dotyczących bezpieczeństwa kont."
          },
          {
            "label": "Powracające problemy",
            "text": "{label}: Rozpatruj powtarzające się problemy z uwierzytelnianiem wraz z innymi dowodami dotyczącymi ryzyka ludzkiego."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez zmieniania kont Okta ani zasad dostępu."
          }
        ],
        "description_long": "Okta chroni dostęp do aplikacji firmowych. Połącz tę usługę, aby Moxso mogło wykorzystywać sygnały uwierzytelniania i bezpieczeństwa kont do zrozumienia rzeczywistych zagrożeń związanych z dostępem i ukierunkowania lepiej dopasowanych działań następczych.",
        "description_short": "Analizuj zdarzenia uwierzytelniania i bezpieczeństwa kont, aby zrozumieć ryzyko związane z dostępem.",
        "title": "Okta"
      },
      "oneleet": {
        "bullets": [
          {
            "label": "Potwierdzone słabe punkty",
            "text": "{label}: Dostępne ustalenia z testów penetracyjnych opisują problemy zidentyfikowane podczas testów bezpieczeństwa."
          },
          {
            "label": "Kontekst ryzyka",
            "text": "{label}: Priorytet, obiekty, których dotyczy problem, i wskazówki naprawcze pomagają wyjaśnić, co wymaga uwagi."
          },
          {
            "label": "Ukierunkowane działania",
            "text": "{label}: Wykorzystuj istotne ustalenia do ukierunkowania technicznych działań naprawczych i rozmów o bezpieczeństwie z odpowiedzialnymi zespołami."
          },
          {
            "label": "Postęp w czasie",
            "text": "{label}: Stan ustaleń pomaga odróżnić otwarte problemy od tych, którymi już się zajęto."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje ustalenia bez uruchamiania testów ani zmieniania ich stanu rozwiązania."
          }
        ],
        "description_long": "Oneleet identyfikuje słabe punkty bezpieczeństwa poprzez testy penetracyjne i prace nad zgodnością. Połącz tę usługę, aby dodawać istotne ustalenia techniczne do kontekstu wykorzystywanego w przeglądach ryzyka ludzkiego i działaniach następczych związanych z bezpieczeństwem.",
        "description_short": "Dodawaj ustalenia z testów penetracyjnych i kontekst działań naprawczych do przeglądów bezpieczeństwa.",
        "title": "Oneleet"
      },
      "onepassword": {
        "bullets": [
          {
            "label": "Sygnały logowania",
            "text": "{label}: Udane i nieudane próby dostarczają dowodów aktywności dostępu do kont."
          },
          {
            "label": "Wrażliwe działania",
            "text": "{label}: Obsługiwane zdarzenia użycia elementów i administracji dostarczają kontekstu sposobu korzystania z menedżera haseł."
          },
          {
            "label": "Ukierunkowane działania następcze",
            "text": "{label}: Skupiaj wskazówki dotyczące bezpieczeństwa danych uwierzytelniających i dochodzenia na istotnej aktywności."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzające się problemy z dostępem wraz z innymi dowodami dotyczącymi bezpieczeństwa kont."
          },
          {
            "label": "Bez dostępu do tajnych treści",
            "text": "{label}: Odczytuje metadane aktywności bez dostępu do haseł, bezpiecznych notatek ani dokumentów w sejfach."
          }
        ],
        "description_long": "1Password pomaga chronić dane uwierzytelniające i z nich korzystać. Połącz tę usługę, aby Moxso mogło wykorzystywać aktywność logowania i menedżera haseł do oceny ryzyka ludzkiego bez dostępu do sekretów przechowywanych w sejfach.",
        "description_short": "Analizuj aktywność logowania i menedżera haseł bez dostępu do przechowywanych sekretów.",
        "title": "1Password"
      },
      "ping_one": {
        "bullets": [
          {
            "label": "Stan kont",
            "text": "{label}: Dostępne informacje o włączeniu kont dostarczają kontekstu do przeglądów dostępu."
          },
          {
            "label": "Powiązania dostępu",
            "text": "{label}: Członkostwo w grupach pomaga wyjaśnić sposób organizacji kont."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Uwzględniaj kontekst dostępu wraz ze zdarzeniami bezpieczeństwa z innych połączonych narzędzi."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj połączone dowody do ukierunkowania rozmów o bezpieczeństwie kont i przeglądów dostępu."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o dostępie do kont bez zmieniania zasad PingOne. To połączenie nie zbiera zdarzeń uwierzytelniania."
          }
        ],
        "description_long": "PingOne pomaga zarządzać dostępem do aplikacji firmowych. Połącz tę usługę, aby Moxso mogło uwzględniać istotny kontekst dostępu do kont obok ryzyka ludzkiego i ukierunkowywać bardziej precyzyjne przeglądy bezpieczeństwa.",
        "description_short": "Dodawaj kontekst katalogu użytkowników i członkostwa z PingOne.",
        "title": "PingOne"
      },
      "remote": {
        "bullets": [
          {
            "label": "Kontekst roli",
            "text": "{label}: Dostępne informacje o obowiązkach i działach pomagają spojrzeć na problemy bezpieczeństwa w szerszym kontekście."
          },
          {
            "label": "Organizacja pracy",
            "text": "{label}: Kontekst kraju i modelu zatrudnienia może pomóc dopasować porady do sytuacji danej osoby."
          },
          {
            "label": "Zmiany zatrudnienia",
            "text": "{label}: Dostępne informacje o cyklu zatrudnienia wspierają rozmowy o dostępie, gdy zmienia się organizacja pracy."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Przy wyborze praktycznych wskazówek uwzględniaj kontekst kadrowy wraz z dowodami dotyczącymi bezpieczeństwa."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje o zatrudnieniu bez zmieniania umów ani przetwarzania list płac."
          }
        ],
        "description_long": "Remote pomaga zarządzać osobami pracującymi w różnych krajach i modelach zatrudnienia. Połącz tę usługę, aby Moxso mogło uwzględniać istotny kontekst pracy podczas przeglądów ryzyka ludzkiego i planowania działań następczych związanych z bezpieczeństwem.",
        "description_short": "Dodawaj kontekst kadrowy dla globalnych i rozproszonych zespołów.",
        "title": "Remote"
      },
      "rippling": {
        "bullets": [
          {
            "label": "Znajomość roli",
            "text": "{label}: Informacje o stanowisku i kontekście pracy pomagają wyjaśnić obowiązki stojące za aktywnością konta."
          },
          {
            "label": "Kontekst zatrudnienia",
            "text": "{label}: Dostępne informacje o stanie zatrudnienia dostarczają tła do przeglądów dostępu w miarę zmiany okoliczności."
          },
          {
            "label": "Trafne wskazówki",
            "text": "{label}: Uwzględniaj obowiązki danej osoby przy wyborze porad dotyczących bezpieczeństwa i tematów budowania świadomości."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Wykorzystuj kontekst zatrudnienia wraz z dowodami dotyczącymi bezpieczeństwa w rozmowach o dostępie i działaniach następczych."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje istotne informacje kadrowe bez zmieniania płac, świadczeń ani ustawień dostępu w Rippling."
          }
        ],
        "description_long": "Rippling przechowuje kontekst dotyczący ról i zatrudnienia pracowników. Połącz tę usługę, aby Moxso mogło uwzględniać ten kontekst obok ryzyka ludzkiego i dopasowywać działania następcze związane z bezpieczeństwem do zmieniających się obowiązków.",
        "description_short": "Dodawaj kontekst pracowników i zatrudnienia z Rippling.",
        "title": "Rippling"
      },
      "sentinel_one": {
        "bullets": [
          {
            "label": "Rzeczywiste sygnały zagrożeń",
            "text": "{label}: Zagrożenia i alerty wskazują podejrzaną aktywność dotyczącą urządzeń służbowych."
          },
          {
            "label": "Kontekst ryzyka",
            "text": "{label}: Dostępne informacje o wadze, klasyfikacji i podatnościach pomagają wyjaśnić, co wymaga uwagi."
          },
          {
            "label": "Ukierunkowane działania",
            "text": "{label}: Wykorzystuj dowody do koordynowania dochodzeń i ustalania, czy działania następcze należą do IT, zespołu bezpieczeństwa czy pracownika."
          },
          {
            "label": "Zmieniający się stan",
            "text": "{label}: Aktualizacje ustaleń pomagają odróżnić utrzymujące się problemy od aktywności, którą już się zajęto."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane informacje dotyczące bezpieczeństwa bez izolowania urządzeń ani usuwania zagrożeń."
          }
        ],
        "description_long": "SentinelOne wykrywa i bada zagrożenia punktów końcowych. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne sygnały zagrożeń do oceny ryzyka ludzkiego i ukierunkowania działań następczych związanych z bezpieczeństwem.",
        "description_short": "Wykorzystuj zagrożenia punktów końcowych i ustalenia dotyczące podatności do ukierunkowania działań związanych z bezpieczeństwem.",
        "title": "SentinelOne"
      },
      "slack": {
        "bullets": [
          {
            "label": "Rzeczywista aktywność kont",
            "text": "{label}: Obsługiwane zdarzenia logowania i dostępu pomagają ujawniać problemy bezpieczeństwa kont."
          },
          {
            "label": "Sygnały udostępniania",
            "text": "{label}: Wybrane zdarzenia dotyczące plików i udostępniania dostarczają dowodów sposobu postępowania z informacjami."
          },
          {
            "label": "Ukierunkowane wskazówki",
            "text": "{label}: Kieruj porady dotyczące bezpiecznej współpracy, ochrony kont i udostępniania informacji tam, gdzie występują istotne zdarzenia."
          },
          {
            "label": "Wzorce w czasie",
            "text": "{label}: Rozpatruj powtarzającą się aktywność wraz z wynikami dotyczącymi świadomości i symulacji."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane metadane audytu bez czytania wiadomości ani zawartości plików. Dostęp do audytu wymaga organizacji Slack Enterprise spełniającej odpowiednie warunki."
          }
        ],
        "description_long": "Slack to miejsce codziennej współpracy i wymiany informacji. Połącz tę usługę, aby Moxso mogło wykorzystywać istotne sygnały logowania i udostępniania do oceny ryzyka ludzkiego i bardziej praktycznych działań następczych.",
        "description_short": "Wykorzystuj aktywność logowania i udostępniania do wspierania bezpieczniejszej codziennej współpracy.",
        "title": "Slack"
      },
      "splunk": {
        "bullets": [
          {
            "label": "Ustalenia dotyczące bezpieczeństwa",
            "text": "{label}: Wybrane ustalenia wskazują aktywność, którą monitoring bezpieczeństwa uznał za wymagającą uwagi."
          },
          {
            "label": "Aktywność kont",
            "text": "{label}: Obsługiwane zdarzenia uwierzytelniania i administracji dostarczają dodatkowych dowodów do dochodzeń."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj ustalenia dotyczące osób lub ich kont do ukierunkowania działań i porad dotyczących bezpieczeństwa."
          },
          {
            "label": "Zmieniające się ryzyko",
            "text": "{label}: Zaktualizowany stan ustaleń pomaga umieścić trwające problemy w kontekście."
          },
          {
            "label": "Dostęp do danych",
            "text": "{label}: Wykorzystuje wyszukiwania do odczytu wybranych informacji dotyczących bezpieczeństwa bez zmieniania ustaleń źródłowych."
          }
        ],
        "description_long": "Splunk gromadzi dowody dotyczące bezpieczeństwa z całego środowiska. Połącz tę usługę, aby Moxso mogło wykorzystywać wybrane ustalenia i zdarzenia związane z kontami do oceny ryzyka ludzkiego i ukierunkowanych działań następczych.",
        "description_short": "Łącz ustalenia dotyczące bezpieczeństwa i aktywność kont na potrzeby przeglądów ryzyka ludzkiego.",
        "title": "Splunk"
      },
      "statuspage": {
        "bullets": [
          {
            "label": "Incydenty usług",
            "text": "{label}: Opublikowane informacje o incydentach wyjaśniają zakłócenia zgłoszone przez właściciela usługi."
          },
          {
            "label": "Usługi objęte problemem",
            "text": "{label}: Stan komponentów pomaga wskazać, których części usługi dotyczy problem."
          },
          {
            "label": "Zaplanowane prace konserwacyjne",
            "text": "{label}: Powiadomienia o pracach konserwacyjnych dostarczają kontekstu oczekiwanych przerw."
          },
          {
            "label": "Postęp reagowania",
            "text": "{label}: Aktualizacje incydentów pomagają wyjaśnić, czy problem jest badany, czy został rozwiązany."
          },
          {
            "label": "Kontekst operacyjny",
            "text": "{label}: Samo zakłócenie działania usługi nie dowodzi przejęcia konta ani niebezpiecznego zachowania pracownika."
          }
        ],
        "description_long": "Status redakcyjny: Wersja robocza; zakres integracji Moxso nie został zweryfikowany w tym repozytorium. Statuspage informuje o incydentach usług i pracach konserwacyjnych. Informacje o stanie usług mogą stanowić przydatne tło podczas działań następczych związanych z bezpieczeństwem, pomagając zespołom zrozumieć, kiedy problem z dostępem zbiega się ze znanym zakłóceniem.",
        "description_short": "Kontekst incydentów usług i prac konserwacyjnych. Zakres integracji nie został jeszcze zweryfikowany.",
        "title": "Statuspage"
      },
      "tailscale": {
        "bullets": [
          {
            "label": "Stan zabezpieczeń dostępu",
            "text": "{label}: Autoryzacja urządzeń i stan dostępu zewnętrznego pomagają wskazać warunki warte sprawdzenia."
          },
          {
            "label": "Kontekst ochrony",
            "text": "{label}: Informacje o wygaśnięciu kluczy i stanie połączenia dostarczają dodatkowego kontekstu dostępu do sieci."
          },
          {
            "label": "Praktyczne działania następcze",
            "text": "{label}: Wykorzystuj istotne problemy z dostępem do ukierunkowania kontroli bezpieczeństwa urządzeń z odpowiedzialnym zespołem."
          },
          {
            "label": "Aktualne warunki",
            "text": "{label}: Analizuj stan zabezpieczeń dostępu w miarę jego zmian, zamiast traktować dawny obraz sytuacji jako stały."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o dostępie urządzeń bez zmieniania autoryzacji sieciowej ani przechwytywania ruchu."
          }
        ],
        "description_long": "Tailscale łączy urządzenia z Twoją siecią prywatną. Połącz tę usługę, aby dodawać stan zabezpieczeń dostępu do sieci do kontekstu bezpieczeństwa wykorzystywanego w przeglądach ryzyka ludzkiego.",
        "description_short": "Analizuj autoryzację urządzeń i ochronę dostępu do sieci obok ryzyka ludzkiego.",
        "title": "Tailscale"
      },
      "vanta": {
        "bullets": [
          {
            "label": "Sygnały zabezpieczeń",
            "text": "{label}: Dostępne kontrole szyfrowania, blokady ekranu, antywirusa i menedżera haseł wskazują luki w ochronie."
          },
          {
            "label": "Jaśniejszy kontekst",
            "text": "{label}: Wyniki poszczególnych kontroli dostarczają bardziej przydatnych szczegółów niż pojedyncza etykieta zgodności."
          },
          {
            "label": "Praktyczne działania następcze",
            "text": "{label}: Wykorzystuj istotne luki do ukierunkowania działań z pracownikami i IT."
          },
          {
            "label": "Zmiany w czasie",
            "text": "{label}: Podczas przeglądów ryzyka uwzględniaj aktualne wyniki kontroli i powtarzające się niepowodzenia."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane dowody dotyczące bezpieczeństwa bez zmieniania wyników zgodności ani ustawień urządzeń."
          }
        ],
        "description_long": "Vanta sprawdza, czy wdrożono ważne zabezpieczenia. Połącz tę usługę, aby Moxso mogło uwzględniać istotne luki w ochronie obok ryzyka ludzkiego i pomagać w nadawaniu działaniom następczym praktycznego charakteru.",
        "description_short": "Wykorzystuj kontrole szyfrowania, blokady ekranu i punktów końcowych do identyfikowania luk w ochronie.",
        "title": "Vanta"
      },
      "wiz": {
        "bullets": [
          {
            "label": "Ustalenia dotyczące bezpieczeństwa chmury",
            "text": "{label}: Obsługiwane problemy wskazują ekspozycje wymagające zbadania lub działań naprawczych."
          },
          {
            "label": "Przydatny kontekst",
            "text": "{label}: Waga problemu i informacje o zasobach, których dotyczy, pomagają wyjaśnić okoliczności ustalenia."
          },
          {
            "label": "Ukierunkowane działania",
            "text": "{label}: Wykorzystuj istotną ekspozycję w rozmowach o odpowiedzialności i technicznych działaniach następczych."
          },
          {
            "label": "Zmieniająca się ekspozycja",
            "text": "{label}: Aktualizacje ustaleń pomagają odróżnić aktywne problemy od rozwiązanych."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje wybrane ustalenia dotyczące chmury bez zmieniania konfiguracji chmurowej."
          }
        ],
        "description_long": "Wiz identyfikuje zagrożenia bezpieczeństwa w środowiskach chmurowych. Połącz tę usługę, aby dodawać istotną ekspozycję chmurową do kontekstu wykorzystywanego w przeglądach ryzyka ludzkiego i skoordynowanych działaniach następczych związanych z bezpieczeństwem.",
        "description_short": "Dodawaj ustalenia dotyczące bezpieczeństwa chmury i kontekst ekspozycji do przeglądów ryzyka.",
        "title": "Wiz"
      },
      "workos": {
        "bullets": [
          {
            "label": "Stan kont",
            "text": "{label}: Dostępne informacje o stanie kont dostarczają kontekstu do przeglądów dostępu do aplikacji."
          },
          {
            "label": "Powiązania dostępu",
            "text": "{label}: Powiązania z organizacjami i grupami pomagają spojrzeć na dostęp do kont w szerszym kontekście."
          },
          {
            "label": "Ukierunkowane przeglądy",
            "text": "{label}: Uwzględniaj kontekst kont wraz ze zdarzeniami bezpieczeństwa z innych połączonych narzędzi."
          },
          {
            "label": "Trafne działania następcze",
            "text": "{label}: Wykorzystuj połączone dowody do ukierunkowania przeglądów dostępu i rozmów o bezpieczeństwie kont."
          },
          {
            "label": "Tylko do odczytu",
            "text": "{label}: Odczytuje informacje o dostępie z katalogu bez zmieniania kont. To połączenie nie zbiera zdarzeń logowania ani aktywności sesji."
          }
        ],
        "description_long": "WorkOS łączy aplikacje z organizacyjnymi systemami dostępu. Połącz tę usługę, aby Moxso mogło uwzględniać istotny kontekst dostępu do kont obok ryzyka ludzkiego i pomagać w ukierunkowaniu przeglądów bezpieczeństwa.",
        "description_short": "Dodawaj kontekst katalogu i członkostwa w organizacjach z WorkOS.",
        "title": "WorkOS"
      }
    },
    "human_risk_intelligence": {
      "assignment": {
        "rule_labels": {
          "cooldown_days": "Okno karencji",
          "interval_days": "Interwał przypisań",
          "respect_mandatory_training": "Uwzględniaj obowiązkowe szkolenie"
        }
      },
      "assignment_status": {
        "awaiting_assignment": "Jeszcze nie zaplanowano",
        "completed": "Ukończone",
        "due_soon": "Wkrótce termin",
        "overdue": "Po terminie"
      },
      "intervention": {
        "notification_type": {
          "hri_employee_intervention_email": "E-mail interwencyjny do pracownika",
          "hri_intervention_email": "E-mail interwencyjny do pracownika"
        }
      },
      "onboarding": {
        "glance": {
          "notifications_behavior": {
            "continue_until_completion": "Powiadomienia będą wysyłane po upływie terminu aż do ukończenia",
            "stop_after_deadline": "Powiadomienia zostaną zatrzymane po upływie terminu"
          },
          "notifications_frequency": {
            "intense": "Intensywny",
            "loose": "Luźny",
            "normal": "Normalny"
          }
        }
      },
      "polarity": {
        "neutral": "Neutralny",
        "risky": "Ryzykowny",
        "vigilant": "Czujny"
      },
      "risk_level": {
        "critical": "Krytyczny",
        "high": "Wysoki",
        "low": "Niski",
        "minimal": "Minimalny",
        "moderate": "Umiarkowany",
        "severe": "Poważny"
      },
      "risk_matrix": {
        "columns": {
          "somewhat_likely": "Umiarkowanie prawdopodobne",
          "very_likely": "Bardzo prawdopodobne",
          "very_unlikely": "Bardzo mało prawdopodobne"
        },
        "rows": {
          "high": "Wysoki",
          "low": "Niski",
          "medium": "Umiarkowany"
        }
      },
      "settings": {
        "interventions": {
          "actions": {
            "assignment": "Przypisz nową lekcję",
            "notify_admin": "Powiadom administratorów",
            "notify_employee": "Powiadom pracownika",
            "notify_manager": "Powiadom przełożonego"
          },
          "groups": {
            "breach_exposure": {
              "description": "Reaguj, gdy pracownik pojawi się w znanym naruszeniu danych.",
              "title": "Ekspozycja na naruszenie"
            },
            "critical_phishing_interactions": {
              "description": "Reaguj, gdy pracownik wykonuje krytyczną czynność phishingową, taką jak podanie danych logowania, otwarcie załącznika lub odpowiedź.",
              "title": "Krytyczne interakcje phishingowe"
            },
            "phishing_interactions": {
              "description": "Reaguj, gdy pracownik kliknie łącze w symulacji phishingu e-mail lub SMS.",
              "title": "Interakcje z phishingiem"
            },
            "simulation_non_reporting": {
              "description": "Reaguj, gdy pracownik nie zgłosi symulacji phishingu w ciągu 2 lub 7 dni.",
              "title": "Niezgłoszenie symulacji"
            },
            "training_inactivity": {
              "description": "Reaguj, gdy wymagane szkolenie pracownika jest przeterminowane.",
              "title": "Brak aktywności szkoleniowej"
            }
          },
          "severities": {
            "high": "Wysoki (ponad 60 dni po terminie)",
            "low": "Niski (7 dni po terminie)",
            "medium": "Średni (30 dni po terminie)"
          },
          "timeframe_options": {
            "intense": "Intensywny",
            "loose": "Luźny",
            "normal": "Normalny"
          }
        },
        "strategy": {
          "compliance": {
            "description": "Przypisuje szkolenie, aby spełnić udokumentowane wymagania ISO 27001, SOC 2 i powiązanych ram zgodności.",
            "glance": "aby spełnić wymagania zgodności Twojej organizacji",
            "title": "Szkolenie zgodnościowe"
          },
          "group": {
            "description": "Dostosowuje szkolenie na podstawie zagregowanych trendów zachowań w zespołach i działach, bez ukierunkowania na konkretne osoby.",
            "glance": "na podstawie zagregowanych sygnałów ryzyka behawioralnego",
            "title": "Szkolenie oparte na grupie"
          },
          "intervention": {
            "description": "Uruchamia ukierunkowane interwencje oparte na sygnałach behawioralnych pracowników. Zapewnia dopasowane szkolenia i działania korygujące, aby przeciwdziałać zidentyfikowanym wzorcom ryzyka i mierzalnie zmniejszać ekspozycję organizacji.",
            "title": "Strategia interwencyjna"
          },
          "risk": {
            "description": "Przypisuje szkolenie na podstawie roli zawodowej, poziomu dostępu i ryzyka wynikającego z odpowiedzialności, zgodnie z wymaganiami NIS2.",
            "glance": "na podstawie profilu ryzyka roli każdego pracownika",
            "title": "Szkolenie oparte na ryzyku"
          }
        },
        "summary_signals": {
          "impact": {
            "high": "Wysoki wpływ",
            "low": "Niski wpływ",
            "medium": "Średni wpływ"
          },
          "signal_labels": {
            "failed_simulation": "Nieudana symulacja phishingu",
            "low_score": "Niski wynik szkolenia"
          }
        }
      },
      "trend": {
        "down": "Spadek",
        "stable": "Stabilny",
        "up": "Wzrost"
      }
    },
    "indicators": {
      "A_10": "A.10",
      "A_11": "A.11",
      "A_13": "A.13",
      "A_14": "A.14",
      "A_15": "A.15",
      "A_16": "A.16",
      "A_17": "A.17",
      "A_19": "A.19",
      "A_21_2_A": "A.21(2)(a)",
      "A_21_2_B": "A.21(2)(b)",
      "A_21_2_C": "A.21(2)(c)",
      "A_21_2_D": "A.21(2)(d)",
      "A_21_2_F": "A.21(2)(f)",
      "A_21_2_G": "A.21(2)(g)",
      "A_21_2_I": "A.21(2)(i)",
      "A_23": "A.23",
      "A_24": "A.24",
      "A_26": "A.26",
      "A_28": "A.28",
      "A_30": "A.30",
      "A_32": "A.32",
      "A_33": "A.33",
      "A_34": "A.34",
      "A_39_1_B": "A.39(1)(b)",
      "A_4": "A.4",
      "A_5": "A.5",
      "A_5_15": "A.5.15",
      "A_5_17": "A.5.17",
      "A_5_1_C": "A.5(1)(c)",
      "A_5_1_E": "A.5(1)(e)",
      "A_5_1_F": "A.5(1)(f)",
      "A_5_23": "A.5.23",
      "A_5_24": "A.5.24",
      "A_5_25": "A.5.25",
      "A_5_26": "A.5.26",
      "A_5_27": "A.5.27",
      "A_5_28": "A.5.28",
      "A_5_31": "A.5.31",
      "A_5_34": "A.5.34",
      "A_5_7": "A.5.7",
      "A_6": "A.6",
      "A_6_3": "A.6.3",
      "A_6_7": "A.6.7",
      "A_7_1": "A.7.1",
      "A_7_2": "A.7.2",
      "A_7_3": "A.7.3",
      "A_7_4": "A.7.4",
      "A_8": "A.8",
      "A_8_1": "A.8.1",
      "A_8_2": "A.8.2",
      "A_8_23": "A.8.23",
      "A_8_5": "A.8.5",
      "A_8_7": "A.8.7",
      "A_8_9": "A.8.9",
      "A_9": "A.9",
      "CC1_1": "CC1.1",
      "CC2_1": "CC2.1",
      "CC3_2": "CC3.2",
      "CC4_1": "CC4.1",
      "CC5_2": "CC5.2",
      "CC6_1": "CC6.1",
      "CC7_2": "CC7.2",
      "CC8_1": "CC8.1",
      "CC9_2": "CC9.2",
      "C_10": "C.10",
      "C_6": "C.6",
      "C_7": "C.7",
      "C_8": "C.8",
      "C_9": "C.9",
      "administration": "Administracja",
      "ai_act": "AI Act",
      "customer-support-success": "Obsługa klienta i sukces klienta",
      "data-analytics": "Dane i analityka",
      "dora": "DORA",
      "education-training": "Edukacja i szkolenia",
      "elevated": "Podwyższony dostęp",
      "engineering-development": "Inżynieria i rozwój",
      "executive-leadership": "Kadra zarządzająca najwyższego szczebla",
      "facilities-services": "Infrastruktura i usługi",
      "finance": "Finanse",
      "human-resources": "Zasoby ludzkie",
      "individual_contributor": "Specjalista",
      "iso_27001": "ISO 27001",
      "iso_27005": "ISO 27005",
      "it-systems": "IT i systemy",
      "leadership": "Przywództwo",
      "legal-compliance": "Prawo i zgodność",
      "management-team-leadership": "Zarządzanie i prowadzenie zespołów",
      "managerial": "Kierowniczy",
      "marketing-communications": "Marketing i komunikacja",
      "nis2": "NIS2",
      "operations": "Operacje",
      "product-design": "Produkt i projektowanie",
      "project-program-management": "Zarządzanie projektami i programami",
      "quality-process": "Jakość i procesy",
      "research-science": "Badania i nauka",
      "sales": "Sprzedaż",
      "security": "Bezpieczeństwo",
      "soc_2": "SOC 2",
      "standard": "Standardowy dostęp",
      "supply-chain-logistics": "Łańcuch dostaw i logistyka"
    },
    "industries": {
      "aerospace_defence": "Lotnictwo i obronność",
      "automotive": "Motoryzacja",
      "banking": "Bankowość i rynki kapitałowe",
      "capital_infrastructure": "Projekty kapitałowe i infrastruktura",
      "consumer_markets": "Rynki konsumenckie",
      "energy_resources": "Energia, usługi komunalne i zasoby",
      "engineering_construction": "Inżynieria i budownictwo",
      "financial_services": "Usługi finansowe",
      "government_public": "Rząd i usługi publiczne",
      "healthcare": "Opieka zdrowotna",
      "hospitality_leisure": "Hotelarstwo i rekreacja",
      "industrial_manufacturing": "Przemysłowa produkcja",
      "insurance": "Ubezpieczenia",
      "media": "Media",
      "paper_packaging": "Drewno, papier i opakowania",
      "pharmaceuticals": "Farmaceutyka i biotechnologia",
      "private_equity": "Kapitał prywatny",
      "technology": "Technologia",
      "telecommunications": "Telekomunikacja",
      "transportation": "Transport i logistyka",
      "wealth_management": "Zarządzanie aktywami i majątkiem"
    },
    "integrations": {
      "conzentrate": {
        "description": "Synchronizuj dane treningowe z Learning Arena",
        "title": "Arena nauki"
      },
      "csv": {
        "description": "Importuj pracowników z pliku CSV",
        "title": "Import CSV"
      },
      "drata": {
        "description": "Zsynchronizuj dowód ukończenia kursu z Drata",
        "title": "Drata"
      },
      "google": {
        "description": "Synchronizuj pracowników i grupy z Google Workspace",
        "group_description": "Importuj grupy z Google Workspace",
        "title": "Google Workspace"
      },
      "google_scim": {
        "title": "Google"
      },
      "microsoft": {
        "description": "Synchronizuj pracowników i grupy z Microsoft Entra ID.",
        "group_description": "Importuj grupy z Microsoft Entra ID",
        "title": "Microsoft Entra ID"
      },
      "microsoft_scim": {
        "title": "Microsoft Entra ID"
      },
      "microsoft_teams": {
        "description": "Wysyłaj powiadomienia szkoleniowe bezpośrednio w Teams",
        "title": "Microsoft Teams"
      },
      "okta_scim": {
        "title": "Okta"
      },
      "sabacloud": {
        "description": "Synchronizuj dane treningowe z Saba Cloud",
        "title": "Saba Cloud"
      },
      "slack": {
        "description": "Synchronizuj pracowników i grupy ze Slacka",
        "group_description": "Importuj grupy ze Slacka",
        "title": "Slack"
      },
      "slack_notifications": {
        "description": "Wysyłaj powiadomienia szkoleniowe bezpośrednio w Slacku",
        "title": "Powiadomienia Slack"
      },
      "sync_failures": {
        "default": "Synchronizacja tej integracji nie powiodła się.",
        "unauthorized": "Synchronizacja nie powiodła się. Proszę zaktualizować ustawienia uwierzytelniania dla tej integracji."
      },
      "vanta": {
        "description": "Synchronizuj dowody ukończenia kursu z Vanta",
        "title": "Vanta"
      }
    },
    "invalid_user": "Obecne hasło jest nieprawidłowe.",
    "language": {
      "da_DK": "Duński",
      "de_DE": "Niemiecki",
      "en_US": "Angielski",
      "es_ES": "Hiszpański",
      "fi_FI": "Fiński",
      "fr_FR": "Francuski",
      "nb_NO": "Norweski",
      "nl_NL": "Holenderski",
      "pl_PL": "Polski",
      "pt_PT": "Portugalski",
      "sv_SE": "Szwedzki"
    },
    "learning_profile": {
      "data_privacy": {
        "description": "Zapewnienie prywatności i ochrony danych wrażliwych",
        "long": "Prywatność danych (RODO)",
        "short": "Prywatność danych"
      },
      "device_security": {
        "description": "Bezpieczeństwo urządzeń fizycznych i punktów końcowych",
        "long": "Bezpieczeństwo urządzenia",
        "short": "Bezpieczeństwo urządzenia"
      },
      "digital_threats": {
        "description": "Ochrona przed różnymi zagrożeniami online",
        "long": "Zagrożenia cyfrowe",
        "short": "Zagrożenia cyfrowe"
      },
      "hybrid_work": {
        "description": "Zagadnienia dotyczące bezpieczeństwa pracy zdalnej i biurowej",
        "long": "Praca hybrydowa",
        "short": "Praca hybrydowa"
      },
      "incidents_breaches": {
        "description": "Obsługa i zapobieganie incydentom bezpieczeństwa",
        "long": "Incydenty i Naruszenia",
        "short": "Incydenty i Naruszenia"
      },
      "passwords_accounts": {
        "description": "Siła i zarządzanie hasłami i kontami",
        "long": "Hasła i konta",
        "short": "Hasła i konta"
      },
      "phishing": {
        "description": "Świadomość i zapobieganie atakom phishingowym",
        "long": "Phishing",
        "short": "Phishing"
      },
      "physical_security": {
        "description": "Ochrona aktywów fizycznych i przestrzeni",
        "long": "Bezpieczeństwo fizyczne",
        "short": "Bezpieczeństwo fizyczne"
      },
      "secure_browsing": {
        "description": "Bezpieczne praktyki przeglądania internetu",
        "long": "Bezpieczne przeglądanie",
        "short": "Bezpieczne przeglądanie"
      }
    },
    "onboarding": {
      "data_privacy": {
        "category": "Prywatność danych (RODO)",
        "options": {
          "high": "Mamy jasne polityki i egzekwujemy surowe środki ochrony danych",
          "low": "Nie zarządzamy aktywnie zgodnością z zasadami ochrony danych osobowych",
          "medium": "Zbieramy dane, ale nie mamy formalnych zasad."
        },
        "question": "W jaki sposób Twoja firma przetwarza dane osobowe zgodnie z przepisami RODO?"
      },
      "device_security": {
        "category": "Zabezpieczenia urządzenia",
        "options": {
          "high": "Urządzenia są centralnie zarządzane, szyfrowane i monitorowane.",
          "low": "Pracownicy używają własnych urządzeń bez wymuszonych polityk bezpieczeństwa",
          "medium": "Niektóre środki bezpieczeństwa są stosowane, ale niekonsekwentnie"
        },
        "question": "Jakie środki bezpieczeństwa są stosowane w urządzeniach firmowych?"
      },
      "digital_threats": {
        "category": "Zagrożenia cyfrowe",
        "options": {
          "high": "Używamy zabezpieczeń punktów końcowych, zapór ogniowych i szkoleń dla pracowników",
          "low": "Polegamy na pracownikach w zarządzaniu ich własnym bezpieczeństwem",
          "medium": "Niektóre zabezpieczenia są wprowadzone, ale nie na terenie całej firmy."
        },
        "question": "W jaki sposób Twoja firma chroni się przed złośliwym oprogramowaniem i zagrożeniami cybernetycznymi?"
      },
      "hybrid_work": {
        "category": "Praca hybrydowa",
        "options": {
          "high": "Pracownicy korzystają z VPN-ów, bezpiecznego Wi-Fi i zatwierdzonych urządzeń firmowych",
          "low": "Pracownicy używają urządzeń osobistych i niezabezpieczonych sieci.",
          "medium": "Niektóre środki bezpieczeństwa są zalecane, ale nie wymagane."
        },
        "question": "Jak zarządzane jest bezpieczeństwo dla pracowników zdalnych?"
      },
      "incidents_breaches": {
        "category": "Incydenty i Naruszenia",
        "options": {
          "high": "Mamy plan reagowania na incydenty i regularnie go testujemy",
          "low": "Reagujemy na incydenty reaktywnie, bez formalnego planu.",
          "medium": "Mamy plan, ale nigdy go nie testowaliśmy."
        },
        "question": "Jakie jest podejście Twojej firmy do reagowania na incydenty?"
      },
      "passwords_accounts": {
        "category": "Hasła i konta",
        "options": {
          "high": "Menedżery haseł i MFA są wymagane dla wszystkich pracowników",
          "low": "Pracownicy zarządzają własnymi hasłami bez wymagań.",
          "medium": "MFA jest opcjonalna, a zasady dotyczące haseł nie są rygorystycznie egzekwowane"
        },
        "question": "Jak Twoja firma egzekwuje bezpieczeństwo haseł?"
      },
      "phishing": {
        "category": "Phishing",
        "options": {
          "high": "Pracownicy poddawani są regularnym szkoleniom z zakresu świadomości phishingowej.",
          "low": "Formalne szkolenie z zakresu phishingu nie jest dostępne",
          "medium": "Zapewniane jest pewne szkolenie, ale nie regularnie"
        },
        "question": "Jak Twoja firma przeciwdziała zagrożeniom związanym z phishingiem?"
      },
      "physical_security": {
        "category": "Bezpieczeństwo fizyczne",
        "options": {
          "high": "Kontrola dostępu, rejestry odwiedzających i bezpieczne przechowywanie są wdrożone",
          "low": "Nie ma formalnych środków bezpieczeństwa fizycznego",
          "medium": "Niektóre środki bezpieczeństwa istnieją, ale są stosowane niespójnie"
        },
        "question": "Jak zarządzana jest ochrona fizyczna w Twoim biurze?"
      },
      "secure_browsing": {
        "category": "Bezpieczne przeglądanie",
        "options": {
          "high": "Pracownicy używają bezpiecznych przeglądarek z filtrowaniem treści.",
          "low": "Brak ograniczeń lub zasad bezpieczeństwa dotyczących przeglądania",
          "medium": "Pewne środki bezpieczeństwa są wdrożone, ale nie egzekwowane."
        },
        "question": "Jak Twoja firma zapewnia bezpieczne przeglądanie internetu?"
      }
    },
    "organizational_role": {
      "access_level": {
        "elevated": "Podwyższony dostęp",
        "standard": "Standardowy dostęp"
      },
      "responsibility_tier": {
        "individual_contributor": "Specjalista",
        "leadership": "Przywództwo",
        "managerial": "Kierowniczy"
      }
    },
    "policies": {
      "audit_notifications_frequency": {
        "intense": "Intensywny",
        "loose": "Luźne",
        "normal": "Normalne"
      },
      "audit_status": {
        "completed": "Zakończono",
        "draft": "Nieaktywna",
        "expired": "Wygasły",
        "running": "Audytowanie"
      }
    },
    "report": {
      "labels": {
        "assignment": "Przypisanie",
        "assignment_completion": "Ukończenie zadań",
        "click_rate": "Współczynnik kliknięć",
        "clicked": "Kliknięto",
        "company_score": "Wynik firmy",
        "completed": "Ukończono",
        "course": "Kurs",
        "course_completed": "Ukończone kursy",
        "critical": "Krytyczny",
        "handling_rate": "Wskaźnik obsługi zagrożeń",
        "handling_time": "Czas obsługi zagrożeń",
        "high": "Wysoki",
        "in_progress": "W toku",
        "interventions": "Działania",
        "low": "Niski",
        "medium": "Średni",
        "missed_deadlines": "Przekroczone terminy",
        "negative": "Negatywny",
        "neutral": "Neutralny",
        "notify_admin": "Administrator powiadomiony",
        "notify_employee": "Pracownik powiadomiony",
        "notify_manager": "Menedżer powiadomiony",
        "onboarding": "Wskaźnik wdrożenia",
        "overdue": "Zaległe",
        "phishing_quizzes": "Quizy phishingowe",
        "phishing_susceptibility": "Podatność na phishing",
        "policy": "Polityka",
        "positive": "Pozytywny",
        "report_rate": "Współczynnik zgłoszeń",
        "reported": "Zgłoszono",
        "reporting_behavior": "Zachowanie przy zgłaszaniu",
        "resilience_score": "Wynik odporności",
        "score": "Wynik odporności",
        "sent": "Wysłane symulacje",
        "signals": "Sygnały",
        "simulations_received": "Otrzymane symulacje",
        "team_score": "Wynik zespołu",
        "video": "Wideo",
        "video_quizzes": "Quizy wideo",
        "videos_watched": "Obejrzane filmy"
      }
    },
    "reports": {
      "frequencies": {
        "bimonthly": "Co dwa miesiące",
        "monthly": "Miesięczny",
        "quarterly": "Kwartalnie",
        "weekly": "Tygodniowo",
        "yearly": "Rocznie"
      },
      "periods": {
        "prev_month": "Poprzedni miesiąc",
        "prev_quarter": "Poprzedni kwartał",
        "prev_week": "Poprzedni tydzień",
        "prev_year": "Ostatnie 12 miesięcy",
        "ytd": "Od początku roku"
      },
      "status": {
        "active": "Aktywny",
        "inactive": "Nieaktywna"
      },
      "types": {
        "manager": "Raport menedżera",
        "workspace": "Raport przestrzeni roboczej"
      }
    },
    "risk_categories": {
      "agentic_ai": "Agentyczna AI",
      "communication_security": "Bezpieczeństwo komunikacji",
      "data_protection": "Ochrona danych",
      "digital_exposure_risk": "Ryzyko ekspozycji cyfrowej",
      "endpoint_device_security": "Bezpieczeństwo urządzeń końcowych",
      "engagement_awareness": "Świadomość zaangażowania",
      "human_use_of_ai": "Ludzkie wykorzystanie AI",
      "identity_access_risk": "Ryzyko tożsamości i dostępu",
      "incident_response_readiness": "Gotowość reagowania na incydenty",
      "mobile_security": "Bezpieczeństwo mobilne",
      "physical_security": "Bezpieczeństwo fizyczne",
      "policy_regulatory_compliance": "Zgodność z politykami i przepisami",
      "remote_work_risk": "Ryzyko pracy zdalnej",
      "social_engineering_risks": "Ryzyka socjotechniczne",
      "third_party_risk": "Ryzyko stron trzecich",
      "web_cloud_usage": "Korzystanie z sieci i chmury"
    },
    "roles": {
      "administration": "Administracja",
      "customer-support-success": "Wsparcie klienta i sukces klienta",
      "data-analytics": "Dane i analityka",
      "education-training": "Edukacja i szkolenia",
      "engineering-development": "Inżynieria i rozwój",
      "executive-leadership": "Kadra kierownicza",
      "facilities-services": "Infrastruktura i usługi",
      "finance": "Finanse",
      "human-resources": "Zasoby ludzkie",
      "it-systems": "IT i systemy",
      "legal-compliance": "Prawo i zgodność",
      "management-team-leadership": "Zarządzanie i przywództwo zespołu",
      "marketing-communications": "Marketing i komunikacja",
      "operations": "Operacje",
      "product-design": "Produkt i projektowanie",
      "project-program-management": "Zarządzanie projektami i programami",
      "quality-process": "Jakość i procesy",
      "research-science": "Badania i nauka",
      "sales": "Sprzedaż",
      "security": "Bezpieczeństwo",
      "supply-chain-logistics": "Łańcuch dostaw i logistyka"
    },
    "saml": {
      "name_id_formats": {
        "emailAddress": "Adres e-mail",
        "persistent": "Persistent",
        "transient": "Transient",
        "unspecified": "Nieokreślony"
      },
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "scim": {
      "providers": {
        "auth0_scim": "Auth0",
        "google_scim": "Google",
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    },
    "services": {
      "category": {
        "authentication": "Uwierzytelnianie",
        "collaboration": "Współpraca",
        "crm": "CRM",
        "digital_signature": "Podpis cyfrowy",
        "document_management": "Zarządzanie dokumentami",
        "file_sharing": "Udostępnianie plików",
        "hrm": "Zasoby ludzkie",
        "marketing": "Marketing",
        "other": "Inne",
        "support": "Obsługa klienta",
        "survey": "Ankieta",
        "video_conferencing": "Wideokonferencje"
      },
      "target": {
        "all": "Wszyscy",
        "design": "Projektowanie",
        "engineering": "Inżynieria",
        "finance": "Finanse",
        "marketing": "Marketing",
        "sales": "Sprzedaż",
        "support": "Wsparcie"
      }
    },
    "signals": {
      "key": {
        "access_level": "Poziom dostępu",
        "ai_act_reference": "Odniesienie AI Act",
        "breach_found": "Wykryto naruszenie",
        "cybersecurity_culture_initiative_participated": "Uczestniczy w inicjatywach związanych z cyberbezpieczeństwem",
        "dora_reference": "Odniesienie DORA",
        "email_simulation_clicked": "Kliknięto symulację e-mail",
        "email_simulation_credentials_submitted": "Przesłano dane logowania w symulacji e-mail",
        "email_simulation_delivered": "Dostarczono symulację e-mail",
        "email_simulation_reported": "Zgłoszono symulację e-mail",
        "email_simulation_reported_without_clicking": "Zgłoszono symulację e-mail bez kliknięcia",
        "employee_imported": "Zaimportowano pracownika",
        "frameworks": "Ramy",
        "high_confidence_in_phishing_self_assessment": "Wielokrotnie poprawnie odpowiadał(a) na quizy phishingowe",
        "iso27001_reference": "Odniesienie ISO27001",
        "iso27005_reference": "Odniesienie ISO27005",
        "legitimate_email_reported_as_phishing": "Zgłasza legalne wiadomości e-mail jako phishing",
        "low_confidence_in_phishing_self_assessment": "Wielokrotnie niepoprawnie odpowiadał(a) na quizy phishingowe",
        "low_score": "Niski wynik",
        "missed_deadline_30_days": "Wymagane szkolenie 30 dni po terminie",
        "missed_deadline_60_days": "Wymagane szkolenie 60 dni po terminie",
        "missed_deadline_7_days": "Wymagane szkolenie 7 dni po terminie",
        "multiple_choice_answered_correctly": "Pytanie wielokrotnego wyboru rozwiązane poprawnie",
        "multiple_choice_answered_incorrectly": "Pytanie wielokrotnego wyboru rozwiązane niepoprawnie",
        "nis2_reference": "Odniesienie NIS2",
        "optional_training_engaged": "Ukończono opcjonalne szkolenie",
        "real_phishing_email_clicked": "Kliknięto prawdziwą wiadomość phishingową",
        "real_phishing_email_opened": "Otwarto prawdziwą wiadomość phishingową",
        "real_phishing_email_opened_attachment": "Otwarto załącznik prawdziwej wiadomości phishingowej",
        "real_phishing_email_reported": "Zgłoszono prawdziwą wiadomość phishingową",
        "real_phishing_email_targeted": "Objęto prawdziwymi wiadomościami phishingowymi",
        "responsibility_tier": "Poziom odpowiedzialności",
        "risk_level": "Poziom ryzyka",
        "risk_themes": "Tematy ryzyka",
        "risk_threshold": "Próg ryzyka",
        "role": "Rola",
        "role_fallback_used": "Użyto zastępczej roli",
        "simulation_not_reported_2_days": "Symulacja niezgłoszona po 2 dniach",
        "simulation_not_reported_7_days": "Symulacja niezgłoszona po 7 dniach",
        "sms_simulation_clicked": "Kliknięto symulację SMS",
        "sms_simulation_delivered": "Dostarczono symulację SMS",
        "sms_simulation_reported": "Zgłoszono symulację SMS",
        "soc2_reference": "Odniesienie do SOC2",
        "threat_reported": "Zgłoszono zagrożenie",
        "training_completed": "Ukończono przypisane szkolenie",
        "training_completed_after_deadline": "Ukończono po terminie",
        "training_completed_on_time": "Ukończono przypisane szkolenie na czas",
        "training_inactivity": "Brak aktywności szkoleniowej",
        "training_video_watched": "Obejrzano film szkoleniowy"
      },
      "sentiment": {
        "negative": "Negatywny",
        "neutral": "Neutralny",
        "positive": "Pozytywny"
      },
      "severity": {
        "critical": "Krytyczny",
        "high": "Wysoki",
        "low": "Niski",
        "medium": "Średni",
        "neutral": "Neutralny"
      }
    },
    "simulations": {
      "delivery_method": {
        "email": "E-mail",
        "sms": "SMS"
      },
      "delivery_rate": {
        "high": "Wysoki",
        "low": "Niski",
        "medium": "Średni"
      },
      "failures": {
        "failed_to_deliver": "Błąd dostarczania",
        "failed_to_send": "Błąd wysyłania",
        "invalid_receiver": "Błąd odbiorcy",
        "invalid_template": "Błąd szablonu",
        "no_template_available": "Błąd szablonu"
      },
      "preview": {
        "CampaignClick": "{name} kliknął(ęła) na link",
        "CampaignReport": "{name} zgłosił(a) symulację",
        "CampaignSent": "Symulacja została wysłana do {name}",
        "CampaignSubmission": "{name} przesłał(a) formularz logowania",
        "activity": "Aktywność",
        "title": "Podgląd"
      },
      "schedule_type": {
        "missing": "Brak metody dostawy",
        "one_off": "Jednorazowo",
        "recurring": "Powtarzające się"
      },
      "status": {
        "cancelled": "Anulowane",
        "completed": "Zakończono",
        "draft": "Wersja robocza",
        "paused": "Wstrzymano",
        "running": "W toku",
        "sending": "Wysyłanie"
      },
      "templates": {
        "editor": {
          "sidebar_blocks": {
            "button": "Przycisk",
            "columns": "Kolumny",
            "container": "Kontener",
            "divider": "Separator",
            "heading1": "Nagłówek 1",
            "heading2": "Nagłówek 2",
            "heading3": "Nagłówek 3",
            "image": "Obraz",
            "spacer": "Odstęp",
            "text": "Tekst"
          }
        }
      }
    },
    "statistics": {
      "activities_by_type": {
        "completed_courses": "Ukończone kursy",
        "phishing_quiz_correct_answers": "Poprawne odpowiedzi w quizie o phishingu",
        "phishing_quiz_incorrect_answers": "Niepoprawne odpowiedzi w quizie o phishingu",
        "quiz_answers": "Odpowiedzi na quizy",
        "quiz_correct_answers": "Prawidłowe odpowiedzi w quizie",
        "quiz_incorrect_answers": "Nieprawidłowe odpowiedzi w quizie",
        "simulations_delivered": "Dostarczone symulacje",
        "simulations_failed": "Symulacje zakończone niepowodzeniem",
        "simulations_passed": "Symulacje zaliczone",
        "simulations_reported": "Zgłoszone symulacje",
        "text": "Jak szkolą się Twoi pracownicy",
        "threats_reported": "Zgłoszone zagrożenia",
        "title": "Ukończone aktywności",
        "videos_watched": "Obejrzane filmy"
      },
      "benchmarks": {
        "above_benchmark_tooltip": "Wartość jest powyżej wartości odniesienia.",
        "below_benchmark_tooltip": "Wartość jest poniżej wartości odniesienia.",
        "benchmark_tooltip": "Punkt odniesienia"
      },
      "breaches": {
        "critical": "Krytyczne",
        "noncritical": "Niekrytyczne"
      },
      "employees": {
        "beginner": "Początkujący",
        "expert": "Ekspert",
        "intermediate": "Średnio zaawansowany"
      },
      "onboarding": {
        "not_onboarded": "Brak onboardingu",
        "onboarded": "Zakończony onboarding"
      },
      "participant_partition": {
        "active": "Aktywny",
        "completed": "Ukończono",
        "halted": "Wstrzymano"
      },
      "threats": {
        "status_partition": {
          "forwarded": "Przekazano",
          "fraudulent": "Złośliwy",
          "legitimate": "Autentyczny",
          "spam": "Spam"
        }
      },
      "time_units": {
        "days": "Dzień | Dni",
        "hours": "Godzina | Godziny",
        "minutes": "Minuta | Minuty",
        "seconds": "Sekunda | Sekundy",
        "weeks": "Tydzień | Tygodnie"
      },
      "training": {
        "quizzing": {
          "correct": "Poprawne",
          "incorrect": "Niepoprawne"
        }
      }
    },
    "tables": {
      "columns": {
        "actor": "Aktor",
        "app": "Aplikacja",
        "automation_status": "Status",
        "available_at": "Dostępne",
        "breached_at": "Naruszono dnia",
        "click_rate": "@:simulations.click_rate.title",
        "completed": "Ukończone",
        "completed_at": "Ukończone",
        "content_id": "Treść",
        "content_type": "Typ treści",
        "created_at": "Utworzono",
        "data_class": "Klasa danych",
        "deadline_at": "Termin",
        "delivery": "@:simulations.summary.schedule_type",
        "delivery_type": "@:tables.delivery_method",
        "deselect_all": "Odznacz wszystkie",
        "employee_id": "Pracownik",
        "employee_status": "Status",
        "event": "Zdarzenie",
        "group_id": "Grupa",
        "key": "Sygnał",
        "last_learning_interaction": "Ostatnia interakcja",
        "published_at": "Opublikowano",
        "report_rate": "@:simulations.report_rate.title",
        "risk_matrix": "Macierz ryzyka",
        "role": "Rola",
        "sentiment": "Sentyment",
        "severity": "Ważność",
        "signal_group": "Grupa sygnałów",
        "submission_rate": "@:simulations.submission_rate.title",
        "test": "@:simulations.summary.test",
        "translations": "Tłumaczenia",
        "type": "Typ",
        "zone": "Strefa"
      },
      "date_operators": {
        "<": "przed",
        "<=": "w dniu lub przed",
        "<>": "nie w dniu",
        "=": "w dniu",
        ">": "po",
        ">=": "w dniu lub po"
      },
      "enum_values": {
        "access": "Dostęp",
        "access_revoke": "Cofnięto dostęp",
        "active": "Aktywny",
        "admin": "Administrator",
        "all": "Wszystkie",
        "analyst": "Analityk",
        "api_token_create": "Utworzono token API",
        "api_token_delete": "Usunięto token API",
        "assignment": "Przypisanie",
        "auth_activity": "Aktywność uwierzytelniania",
        "authenticate": "Uwierzytelnianie",
        "authentication_activity": "Aktywność uwierzytelniania",
        "authorized_integration": "Autoryzowano integrację",
        "breach_config": "Zaktualizowano ustawienia naruszeń",
        "breach_exposure": "Ekspozycja na naruszenie",
        "breach_found": "Wykryto wyciek",
        "cancelled": "@:dynamic_keys.simulations.status.cancelled",
        "change": "Zmiana",
        "changed_data": "Zmieniono dane",
        "completed": "@:dynamic_keys.simulations.status.completed",
        "course": "Kurs",
        "course_delete": "Usunięto kurs",
        "created_campaign_domain": "Utworzono domenę kampanii",
        "created_integration": "Utworzono integrację",
        "created_warehouse_token": "Utworzono token hurtowni danych",
        "credential_update": "Zaktualizowano poświadczenia",
        "critical": "Krytyczny",
        "critical_phishing_interactions": "Podane dane logowania w phishingu",
        "cybersecurity_culture_initiative_participated": "Uczestniczy w inicjatywach związanych z cyberbezpieczeństwem",
        "data_change": "Zmieniono dane",
        "deleted_warehouse_token": "Usunięto token hurtowni danych",
        "domain_create": "Utworzono domenę",
        "draft": "@:dynamic_keys.simulations.status.draft",
        "email": "@:dynamic_keys.simulations.delivery_method.email",
        "email_simulation_clicked": "Kliknięto symulację e-maila",
        "email_simulation_credentials_submitted": "Przesłano dane logowania w symulacji e-maila",
        "email_simulation_delivered": "Dostarczono symulację e-maila",
        "email_simulation_reported": "Zgłoszono symulację e-maila",
        "email_simulation_reported_without_clicking": "Zgłoszono symulację e-maila bez kliknięcia",
        "employee_training_exclude": "Wykluczono pracownika ze szkolenia",
        "employee_training_exclusion_expire": "Wykluczenie pracownika ze szkolenia wygasło",
        "employee_training_include": "Uwzględniono pracownika w szkoleniu",
        "high": "Wysoki",
        "high-somewhat_likely": "Wysoki wpływ / Umiarkowanie prawdopodobne",
        "high-very_likely": "Wysoki wpływ / Bardzo prawdopodobne",
        "high-very_unlikely": "Wysoki wpływ / Bardzo mało prawdopodobne",
        "high_confidence_in_phishing_self_assessment": "Wielokrotnie poprawnie odpowiadał(a) na quizy phishingowe",
        "hub": "Hub",
        "inactive": "Nieaktywny",
        "integration_auth": "Autoryzowano integrację",
        "integration_config": "Zaktualizowano ustawienia integracji",
        "integration_create": "Utworzono integrację",
        "integration_delete": "Usunięto integrację",
        "integration_update": "Zaktualizowano integrację",
        "intel_config": "Zaktualizowano ustawienia human risk intelligence",
        "invited_user": "Zaproszono użytkownika",
        "legitimate_email_reported_as_phishing": "Zgłasza legalne wiadomości e-mail jako phishing",
        "login": "Zalogowano",
        "login_verify": "Zweryfikowano logowanie",
        "logout": "Wylogowano",
        "low": "Niski",
        "low-somewhat_likely": "Niski wpływ / Umiarkowanie prawdopodobne",
        "low-very_likely": "Niski wpływ / Bardzo prawdopodobne",
        "low-very_unlikely": "Niski wpływ / Bardzo mało prawdopodobne",
        "low_confidence_in_phishing_self_assessment": "Wielokrotnie niepoprawnie odpowiadał(a) na quizy phishingowe",
        "manage": "Zarządzanie",
        "med-somewhat_likely": "Umiarkowany wpływ / Umiarkowanie prawdopodobne",
        "med-very_likely": "Umiarkowany wpływ / Bardzo prawdopodobne",
        "med-very_unlikely": "Umiarkowany wpływ / Bardzo mało prawdopodobne",
        "medium": "Umiarkowany",
        "missed_deadline_30_days": "Wymagane szkolenie 30 dni po terminie",
        "missed_deadline_60_days": "Wymagane szkolenie 60 dni po terminie",
        "missed_deadline_7_days": "Wymagane szkolenie 7 dni po terminie",
        "multiple_choice_answered_correctly": "Pytanie wielokrotnego wyboru rozwiązane poprawnie",
        "multiple_choice_answered_incorrectly": "Pytanie wielokrotnego wyboru rozwiązane niepoprawnie",
        "negative": "Negatywne",
        "neutral": "Neutralny",
        "notification": "Powiadomienie",
        "notify_admin": "Powiadom administratorów",
        "notify_employee": "Powiadom pracownika",
        "notify_manager": "Powiadom przełożonego",
        "one_off": "@:dynamic_keys.simulations.schedule_type.one_off",
        "optional_training_engaged": "Ukończono opcjonalne szkolenie",
        "paused": "Wstrzymane",
        "phishing_interactions": "Interakcje z phishingiem",
        "policy": "Polityka",
        "positive": "Pozytywne",
        "privacy_config": "Zaktualizowano ustawienia prywatności",
        "quiz": "Quiz",
        "real_phishing_email_opened": "Otwarto prawdziwą wiadomość phishingową",
        "real_phishing_email_reported": "Zgłoszono prawdziwą wiadomość phishingową",
        "real_phishing_email_targeted": "Objęto prawdziwymi wiadomościami phishingowymi",
        "recurring": "@:dynamic_keys.simulations.schedule_type.recurring",
        "register": "Rejestracja",
        "removed_user_access": "Usunięto dostęp użytkownika",
        "running": "@:dynamic_keys.simulations.status.running",
        "sending": "@:dynamic_keys.simulations.status.sending",
        "signed_in": "Zalogowano",
        "signed_out": "Wylogowano",
        "simulation_config": "Zaktualizowano ustawienia symulacji",
        "simulation_non_reporting": "Niezgłoszenie symulacji",
        "simulation_not_reported_2_days": "Symulacja niezgłoszona po 2 dniach",
        "simulation_not_reported_7_days": "Symulacja niezgłoszona po 7 dniach",
        "sms": "@:dynamic_keys.simulations.delivery_method.sms",
        "sms_simulation_clicked": "Kliknięto symulację SMS",
        "sms_simulation_delivered": "Dostarczono symulację SMS",
        "started": "Rozpoczęto",
        "support": "Wsparcie",
        "switched_workspace": "Przełączono obszar roboczy",
        "threat_analyst": "Analityk zagrożeń",
        "threat_config": "Zaktualizowano ustawienia threat management",
        "threat_reported": "Zgłoszono zagrożenie",
        "training_completed": "Ukończono przypisane szkolenie",
        "training_completed_after_deadline": "Ukończenie po terminie",
        "training_completed_on_time": "Ukończono przypisane szkolenie na czas",
        "training_config": "Zaktualizowano ustawienia szkoleń",
        "training_inactivity": "Brak aktywności szkoleniowej",
        "training_video_watched": "Obejrzano wideo szkoleniowe",
        "updated_breach_settings": "Zaktualizowano ustawienia naruszeń",
        "updated_gdpr_settings": "Zaktualizowano ustawienia RODO",
        "updated_human_risk_intelligence_settings": "Zaktualizowano ustawienia human risk intelligence",
        "updated_integration": "Zaktualizowano integrację",
        "updated_integration_settings": "Zaktualizowano ustawienia integracji",
        "updated_integration_token": "Zaktualizowano token integracji",
        "updated_simulation_settings": "Zaktualizowano ustawienia symulacji",
        "updated_threat_management_settings": "Zaktualizowano ustawienia zarządzania zagrożeniami",
        "updated_training_settings": "Zaktualizowano ustawienia szkoleń",
        "updated_workspace_settings": "Zaktualizowano ustawienia obszaru roboczego",
        "user_invite": "Zaproszono użytkownika",
        "verified_sign_in": "Zweryfikowane logowanie",
        "video": "Wideo",
        "video_delete": "Usunięto wideo",
        "viewed_resource": "Wyświetlono zasób",
        "workspace_config": "Zaktualizowano ustawienia obszaru roboczego",
        "workspace_switch": "Przełączono obszar roboczy"
      },
      "operators": {
        "<>": "nie jest",
        "=": "jest"
      }
    },
    "threats": {
      "status": {
        "all": "Wszystkie",
        "forwarded": "Przekazano",
        "fraudulent": "Złośliwy",
        "legitimate": "Autentyczny",
        "spam": "Spam",
        "unhandled": "Nieobsłużone"
      }
    },
    "training": {
      "courses": {
        "video_card": {
          "types": {
            "quiz": "quiz",
            "text": "tekst",
            "video": "wideo"
          }
        }
      },
      "type": {
        "course-type": "Kurs",
        "policy-type": "Polityka",
        "quiz-type": "Quiz",
        "video-type": "Wideo"
      }
    },
    "types": {
      "boolean": "Logiczna",
      "date": "Data",
      "number": "Liczba",
      "string": "Ciąg znaków"
    },
    "users": {
      "roles": {
        "admin": {
          "text": "Administratorzy mogą zarządzać ustawieniami, zapraszać użytkowników i konfigurować produkty.",
          "title": "Administrator"
        },
        "analyst": {
          "text": "Analitycy mogą przeglądać i analizować dane.",
          "title": "Analityk"
        },
        "threat_analyst": {
          "text": "Analitycy zagrożeń mogą zarządzać zagrożeniami i przeglądać/analityzować dane.",
          "title": "Analityk zagrożeń"
        }
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "title": "Zaawansowane",
          "tooltip": "Zostań ekspertem od hakowania w mgnieniu oka"
        },
        "ai": {
          "title": "Sztuczna inteligencja i cyberbezpieczeństwo",
          "tooltip": "Poznaj złożoną rolę, jaką sztuczna inteligencja odgrywa w cyberbezpieczeństwie"
        },
        "compliance": {
          "title": "Certyfikacje i zgodność",
          "tooltip": "Zrozum znaczenie certyfikacji oraz zgodności"
        },
        "gdpr": {
          "title": "RODO",
          "tooltip": "Poznaj najważniejsze wymagania i zasady RODO oraz dowiedz się, jak stosować je na co dzień"
        },
        "hacking": {
          "title": "Życie hakera",
          "tooltip": "Poznaj ludzi stojących za cyberatakami, hakerów z całego świata"
        },
        "money_laundering": {
          "title": "Pranie pieniędzy",
          "tooltip": "Poznaj różne metody używane przez przestępców do prania pieniędzy oraz jak wykrywać i zapobiegać praniu pieniędzy"
        },
        "phishing": {
          "title": "Phishing",
          "tooltip": "Odkryj wszystkie aspekty najpowszechniejszego cyberataku na świecie"
        },
        "physical_security": {
          "title": "Bezpieczeństwo fizyczne",
          "tooltip": "Dowiedz się, dlaczego bezpieczeństwo fizyczne jest kluczowym elementem skutecznego cyberbezpieczeństwa"
        },
        "tips_and_tricks": {
          "title": "Porady i wskazówki",
          "tooltip": "Naucz się, jak wzmocnić swoje osobiste cyberbezpieczeństwo"
        },
        "types_of_hacking": {
          "title": "Rodzaje hakowania",
          "tooltip": "Poznaj różne metody stosowane przez hakerów"
        },
        "uploads": {
          "title": "Przesłane materiały",
          "tooltip": "Obejrzyj filmy przesłane przez Twoją organizację, dostosowane do waszych potrzeb w zakresie bezpieczeństwa"
        }
      }
    },
    "workspace_onboarding": {
      "kick_off": {
        "validation": {
          "employee_import": "Co najmniej 1 integracja AD jest poprawnie skonfigurowana",
          "invite_admins": "Zaproś administratorów",
          "reporting_add_in": "Skonfiguruj dodatek do zgłaszania",
          "simulation": "Skonfiguruj symulacje",
          "training": "Skonfiguruj szkolenie",
          "verify_domain": "Co najmniej 1 domena jest zweryfikowana",
          "whitelisting": "Allowlisting został ukończony"
        }
      }
    }
  },
  "editor": {
    "loading": "Wczytywanie"
  },
  "employees": {
    "active_directory": "Active Directory",
    "add_employees": "Dodaj pracowników",
    "anonymous_name": "Anonimowy",
    "bulk_actions": {
      "activate": "Aktywuj użytkownika | Aktywuj użytkowników",
      "deactivate": "Dezaktywuj użytkownika | Dezaktywuj użytkowników",
      "success": "Zaktualizowano statusy",
      "x_of_n_selected": "{x} z {n} wybranych"
    },
    "current_manager": "Obecny kierownik",
    "deleted_user": "Usunięty użytkownik",
    "department": "Dział",
    "filter": {
      "status": {
        "active": "Tylko aktywni pracownicy",
        "all": "Wszyscy pracownicy",
        "inactive": "Tylko nieaktywni pracownicy"
      }
    },
    "form": {
      "department": "Dział",
      "edit_title": "Ustawienia",
      "email": "Email",
      "first_name": "Imię",
      "language": "Język",
      "last_name": "Nazwisko",
      "manager": "Kierownik",
      "organisational_role": "Rola",
      "placeholder": {
        "manager": "Wybierz kierownika",
        "role": "Wybierz rolę",
        "timezone": "Wybierz strefę czasową"
      },
      "save_settings": "Zapisz ustawienia",
      "scim_enabled_info": "Nie możesz edytować ustawień pracownika, ponieważ SCIM jest włączony dla tego obszaru roboczego.",
      "timezone": "Strefa czasowa"
    },
    "manual": "Instrukcja obsługi",
    "no_email_found": "Nie znaleziono e-maila",
    "preview": {
      "close_edit": "Zamknij",
      "edit": "Edytuj",
      "email": "Email",
      "groups": "Grupy",
      "locale": "Język",
      "manager": {
        "active_directory": "Active Directory",
        "button": "Zobacz profil",
        "email": "Email",
        "manual": "Podręcznik",
        "name": "Imię",
        "source": "Źródło",
        "subtitle": "Przegląd szczegółów menedżera",
        "title": "Kierownik"
      },
      "phone_number": "Numer telefonu",
      "profile": "Zobacz profil",
      "provider": "Dostawca",
      "provider_id": "ID dostawcy",
      "source": "Źródło",
      "status": "Status",
      "tags": "Tagi",
      "title": "Podgląd"
    },
    "recent_activity": "Ostatnia aktywność",
    "resilience_score": {
      "text": "Aktualny wynik odporności na podstawie wyników z ostatnich 90 dni.",
      "title": "Wynik odporności"
    },
    "search": {
      "button": "Szukaj",
      "empty": "Wyszukaj pracowników...",
      "no_results": "Nie znaleziono pracowników"
    },
    "settings": {
      "settings_saved": "Ustawienia zapisane",
      "status": {
        "active": {
          "description": "Ten pracownik otrzyma symulacje i ćwiczenia szkoleniowe",
          "title": "Aktywny"
        },
        "inactive": {
          "description": "Ten pracownik NIE będzie otrzymywać symulacji i ćwiczeń szkoleniowych",
          "title": "Nieaktywny"
        }
      }
    },
    "simulations": {
      "click_rate": {
        "title": "Wskaźnik klikalności",
        "tooltip": "Procent symulacji klikniętych."
      },
      "email_validated": "Email zweryfikowany: {date}",
      "received": {
        "title": "Odebrane symulacje",
        "tooltip": "Łączna liczba otrzymanych symulacji.",
        "unit": "Symulacje"
      },
      "report_rate": {
        "title": "Wskaźnik raportu",
        "tooltip": "Procent zgłoszonych symulacji."
      },
      "submission_rate": {
        "title": "Wskaźnik logowania",
        "tooltip": "Procent wysłanych formularzy logowania.",
        "x_received": "{count} otrzymano"
      }
    },
    "status": "Status",
    "training": {
      "reminder": {
        "reminder_sent": "Przypomnienie wysłane",
        "subject": "Szkolenie z cyberbezpieczeństwa",
        "text": "Zagrożenie ze strony hakerów rośnie i musisz być na bieżąco, aby chronić siebie i swoją firmę.",
        "title": "Cześć!"
      }
    },
    "videos": {
      "title": "Filmy",
      "unit": "Obejrzane filmy"
    }
  },
  "empty": {
    "activity": {
      "title": "Brak aktywności"
    },
    "assigned_learning": {
      "description": "Użytkownik nie ma przypisanego żadnego szkolenia.",
      "title": "Brak przypisanego szkolenia"
    },
    "automations": {
      "button": "Utwórz sekwencję",
      "description": "Rozpocznij, tworząc sekwencję.",
      "title": "Brak automatyzacji"
    },
    "breaches": {
      "description": "Wszelkie naruszenia związane z adresami e-mail dodanymi do centrum będą widoczne tutaj.",
      "title": "Brak naruszeń"
    },
    "custom_uploads": {
      "button": "Utwórz wideo",
      "description": "Rozpocznij, tworząc wideo",
      "title": "Nie znaleziono filmów"
    },
    "domains": {
      "button": "Dodaj domenę",
      "description": "Rozpocznij, dodając domenę.",
      "title": "Brak domen"
    },
    "employee_simulations": {
      "button": "Przejdź do symulacji",
      "description": "Rozpocznij, dodając symulację.",
      "title": "Brak symulacji"
    },
    "employees": {
      "button": "Dodaj pracownika",
      "description_with_button": "Rozpocznij, dodając pracownika.",
      "description_without_button": "Nie znaleziono pracowników.",
      "title": "Brak pracowników"
    },
    "employees_activity": {
      "description": "Nie było żadnej aktywności dla tego pracownika.",
      "title": "Brak aktywności"
    },
    "employees_group": {
      "description": "Ta grupa nie ma powiązanych pracowników.",
      "title": "Brak pracowników"
    },
    "employees_training": {
      "description": "Ten {type} nie został ukończony przez żadnego pracownika.",
      "title": "Brak uczestników"
    },
    "generic": {
      "description": "Nie znaleziono rekordów.",
      "title": "Brak rekordów"
    },
    "groups": {
      "button": "Utwórz grupę",
      "description_with_button": "Rozpocznij, dodając grupę.",
      "description_without_button": "Nie znaleziono żadnych grup.",
      "title": "Brak grup"
    },
    "imports": {
      "description": "Są synchronizacje dla tej integracji.",
      "title": "Brak synchronizacji"
    },
    "participants": {
      "description": "Nie znaleziono uczestników.",
      "title": "Brak uczestników"
    },
    "policies": {
      "description": "Zacznij od utworzenia {policy}.",
      "title": "Brak polityk"
    },
    "reports": {
      "description": "Zacznij od utworzenia nowego zaplanowanego raportu",
      "title": "Brak zaplanowanych raportów"
    },
    "scim_connections": {
      "description": "Utwórz połączenie dla Microsoft Entra ID lub Okta.",
      "title": "Brak połączeń SCIM"
    },
    "scim_tokens": {
      "description": "Dla tego workspace nie utworzono jeszcze tokenów SCIM.",
      "title": "Brak tokenów SCIM"
    },
    "simulation_events": {
      "description": "Nie znaleziono żadnych zdarzeń dla tej symulacji.",
      "title": "Brak wydarzeń"
    },
    "simulations": {
      "description": "Rozpocznij, dodając symulację.",
      "title": "Brak symulacji"
    },
    "simulations_custom_templates": {
      "description": "Rozpocznij, dodając szablon.",
      "title": "Brak szablonów"
    },
    "simulations_sequence": {
      "button": "Edytuj sekwencję",
      "description": "Dodaj akcje, aby zbudować przepływ automatyzacji",
      "title": "Ta sekwencja jest pusta"
    },
    "threats": {
      "attachments": "Nie znaleziono załączników",
      "description": "Rozpocznij, zgłaszając podejrzane e-maile za pomocą dodatku do poczty e-mail Moxso.",
      "title": "Nie znaleziono zagrożeń"
    },
    "tokens": {
      "description": "Rozpocznij od utworzenia tokena.",
      "title": "Brak tokenów"
    },
    "training": {
      "button": "Wyczyść filtry",
      "description": "Nie znaleziono materiałów szkoleniowych pasujących do wyszukiwania.",
      "title": "Nie znaleziono materiałów szkoleniowych"
    },
    "training_deadlines": {
      "description": "Nie znaleziono terminów szkoleń.",
      "title": "Brak terminów szkoleń"
    },
    "user_courses": {
      "description": "Nie przypisano jeszcze żadnych kursów.",
      "title": "Brak kursów"
    },
    "users": {
      "description": "Nie znaleziono żadnych użytkowników.",
      "title": "Brak użytkowników"
    }
  },
  "error": {
    "button": "Wróć do strony głównej",
    "text": "Wystąpił nieznany błąd i nie mogliśmy zrealizować Twojego żądania. Przepraszamy za niedogodności. Proszę spróbować ponownie później.",
    "title": "Coś poszło nie tak"
  },
  "forgot_password": {
    "button": "Wyślij instrukcje",
    "heading": "Zresetuj swoje hasło",
    "instructions": {
      "heading": "E-mail wysłany",
      "text": "Instrukcje zostały wysłane na Twój e-mail"
    },
    "text": "Wpisz adres e-mail, którego użyłeś podczas rejestracji, a my wyślemy Ci instrukcje dotyczące zresetowania hasła."
  },
  "forms": {
    "employee": {
      "add_employees": "Dodaj pracowników",
      "buttons": {
        "add": "Dodaj pracownika | Dodaj pracowników",
        "add_row": "Dodaj wiersz",
        "send_reminder": "Wyślij przypomnienie o szkoleniu",
        "settings": "Ustawienia"
      },
      "delete_row": "Usuń wiersz",
      "employee_added": "Dodano pracownika | Dodano pracowników",
      "import": {
        "text": "Importuj pracowników z pliku CSV.",
        "title": "Importuj pracowników"
      },
      "labels": {
        "email": "Email",
        "first_name": "Imię",
        "language": "Język",
        "last_name": "Nazwisko",
        "phone_number": "Numer telefonu"
      },
      "manual": {
        "text": "Ręcznie twórz pracowników i ich szczegóły.",
        "title": "Ręcznie utwórz pracowników"
      },
      "placeholders": {
        "email": "name{'@'}company.com",
        "first_name": "Imię",
        "last_name": "Nazwisko",
        "phone_number": "Wpisz numer telefonu"
      }
    },
    "filters": {
      "all": "Wszyscy pracownicy",
      "completed": "Ukończone",
      "completed_default": "Wszyscy",
      "incomplete": "Nieukończone",
      "only_active": "Tylko aktywni pracownicy",
      "only_inactive": "Wszyscy nieaktywni pracownicy"
    },
    "group": {
      "adaptive": {
        "text": "Członkowie są zapisywani automatycznie na podstawie reguł.",
        "title": "Utwórz grupę adaptacyjną"
      },
      "add_group": "Dodaj grupę",
      "buttons": {
        "add": "Utwórz grupę",
        "back": "Wstecz",
        "import": "Importuj grupy",
        "next": "Następny krok",
        "save": "Zapisz ustawienia"
      },
      "group_added": "Dodano grupę",
      "group_updated": "Grupa zaktualizowana",
      "import": {
        "text": "Importuj grupy z integracji.",
        "title": "Importuj grupy"
      },
      "labels": {
        "groups": "Grupy",
        "import_from_provider": "Importuj od dostawcy",
        "name": "Imię",
        "provider": "Dostawca",
        "provider_id": "Identyfikator grupy dostawcy"
      },
      "manual": {
        "text": "Członkowie będą dodawani ręcznie.",
        "title": "Utwórz grupę ręcznie"
      },
      "placeholders": {
        "name": "Nazwa grupy",
        "provider": "Wybierz dostawcę",
        "provider_id": "ABC-123",
        "search_groups": "Wyszukaj grupy"
      },
      "scim_enabled_info": "Nie możesz edytować ustawień grupy, ponieważ SCIM jest włączony dla tego obszaru roboczego."
    },
    "login": {
      "buttons": {
        "reset_password": "Resetuj hasło"
      },
      "labels": {
        "email": "E-mail",
        "password": "Hasło",
        "password_repeat": "Powtórz hasło"
      },
      "placeholders": {
        "email": "name{'@'}company.com"
      }
    },
    "search": "Szukaj"
  },
  "general": {
    "locked_feature": "Ta funkcja jest zablokowana"
  },
  "go_back": "Wróć",
  "goals": {
    "actions": {
      "delete_are_you_sure": "Czy na pewno chcesz anulować ten cel?",
      "delete_goal": "Anuluj cel",
      "deleted": "Cel anulowany",
      "edit_goal": "Edytuj cel",
      "edit_goal_title": "Edytuj cel dla: {metric}",
      "new_goal": "Nowy cel dla: {metric}",
      "save_goal": "Zapisz cel",
      "target_description": "Ustaw wartość docelową i datę, do której chcesz ją osiągnąć."
    },
    "chart": {
      "lifetime": "Cały okres",
      "recent": "Ostatnie"
    },
    "detail": {
      "achieved": "Osiągnięty",
      "active_and_scheduled": "Aktywne i zaplanowane cele",
      "actual_at_date": "Rzeczywista wartość w dniu",
      "in_progress": "W toku",
      "missed": "Nieosiągnięty",
      "no_past_goals": "Brak wcześniejszych celów",
      "outcome": "Wynik",
      "past_goals": "Wcześniejsze cele",
      "scheduled": "Zaplanowany",
      "trajectory": "Przebieg",
      "trajectory_description": "Rzeczywiste postępy względem każdego celu ustawionego dla tego wskaźnika. Punkty są oznaczone kolorami według wyniku — zielony oznacza osiągnięty cel, czerwony nieosiągnięty, niebieski cel w toku, a szary zaplanowany."
    },
    "form": {
      "target": {
        "label": "Cel",
        "placeholder": "Cel"
      },
      "target_date": {
        "label": "Data docelowa",
        "placeholder": "Wybierz datę docelową"
      }
    },
    "legend": {
      "actual": "Rzeczywiste",
      "projected": "Prognozowane"
    },
    "no_data": "Brak danych",
    "overview": {
      "add_goal": "Dodaj cel",
      "current": "obecnie",
      "description": "Ustalaj terminowe cele dla każdego wskaźnika, aby tworzyć mierzalną ścieżkę poprawy.",
      "employees_behind_tooltip": "Pracownicy z co najmniej jednym zadaniem po terminie.",
      "from_now": "od teraz",
      "gap_from_previous_target": "Różnica względem poprzedniego celu",
      "next_target": "Następny cel",
      "no_goal_description": "Ten wskaźnik jest śledzony bez celu. Dodaj go, aby mierzyć postępy.",
      "no_goals": "Brak aktywnych celów",
      "time_elapsed": "Upłynęło czasu",
      "title": "Cele",
      "view": "Zobacz"
    }
  },
  "groups": {
    "adaptive_conditions": {
      "boolean_operators": {
        "and": "i",
        "or": "lub"
      },
      "empty": "Brak reguł. Dodaj regułę, aby określić, kto należy do tej grupy.",
      "preview_count_label": "pracowników pasuje do kryteriów",
      "subtitle": "Członkostwo jest określane przez reguły zamiast ręcznego ustawiania.",
      "title": "Grupa adaptacyjna"
    },
    "assign_manager": {
      "button": "Przypisz menedżera",
      "description": "Przypisz menedżera do wszystkich członków grupy jednocześnie",
      "form": {
        "overwrite_managers": {
          "help": "Jeśli włączone, pracownicy, którzy już mają menedżera, zostaną przypisani do wybranego menedżera.",
          "label": "Nadpisz istniejących menedżerów"
        },
        "select_manager": {
          "help": "Wybierz menedżera, który zostanie przypisany do wszystkich członków tej grupy.",
          "label": "Menedżer",
          "placeholder": "Wybierz menedżera"
        }
      },
      "manager_assigned": "Przydzielono menedżera do członków grupy",
      "message": "Ręczna aktualizacja menedżerów pracowników zatrzyma synchronizację Active Directory z ich aktualizacją.",
      "title": "Masowe przypisanie menedżera"
    },
    "assign_role": {
      "button": "Przypisz rolę",
      "form": {
        "overwrite_roles": {
          "help": "Jeśli włączone, pracownicy którzy już mają rolę zostaną przypisani ponownie do wybranej roli.",
          "label": "Nadpisz istniejące role"
        },
        "select_role": {
          "help": "Wybierz rolę, która zostanie przypisana wszystkim członkom tej grupy.",
          "label": "Rola",
          "placeholder": "Wybierz rolę"
        }
      },
      "role_assigned": "Rola przypisana członkom grupy",
      "title": "Masowe przypisanie roli"
    },
    "assign_timezone": {
      "button": "Przypisz strefę czasową",
      "description": "Przypisz strefę czasową wszystkim członkom grupy jednocześnie",
      "form": {
        "overwrite_timezones": {
          "help": "Jeśli włączone, pracownicy, którzy już mają przypisaną strefę czasową, zostaną przypisani do wybranej strefy czasowej.",
          "label": "Zastąp istniejące strefy czasowe"
        },
        "select_timezone": {
          "help": "Wybierz strefę czasową, którą chcesz przypisać wszystkim członkom tej grupy.",
          "label": "Strefa czasowa",
          "placeholder": "Wybierz strefę czasową"
        }
      },
      "timezone_assigned": "Strefa czasowa przypisana do członków grupy",
      "title": "Przypisz strefę czasową zbiorczo"
    },
    "average_resilience_score_text": "Średni wynik odporności dla pracowników w tej grupie",
    "average_resilience_score_title": "Średni wynik odporności",
    "buttons": {
      "add_rule": "Dodaj regułę",
      "assign_manager": "Przydziel menedżera",
      "assign_role": "Przypisz rolę",
      "assign_timezone": "Przypisz strefę czasową",
      "cancel": "Anuluj",
      "manage_group": "Zarządzaj członkami",
      "remove_managers": "Usuń menedżerów",
      "update_group": "Zaktualizuj członków"
    },
    "delete": {
      "are_you_sure": "Czy na pewno chcesz usunąć tę grupę? Tej operacji nie można cofnąć.",
      "button": "Usuń",
      "group_deleted": "Grupa usunięta"
    },
    "manage_members": "Edytuj członków grupy",
    "members_count": "Jeden członek | {count} członków",
    "membership_rules": "Reguły członkostwa",
    "provider": {
      "error": {
        "back": "Wybierz innego dostawcę",
        "button": "Skonfiguruj integrację",
        "text": "Nie można pobrać grup.",
        "title": "Nie można skontaktować się z dostawcą integracji"
      },
      "group_copied": "Identyfikator dostawcy skopiowany do schowka",
      "heading": "Dostawca",
      "hide_id": "Ukryj id",
      "id": "ID",
      "latest_sync": "Ostatnia synchronizacja",
      "never_synced": "Nigdy nie synchronizowano",
      "provider_id": "Identyfikator dostawcy",
      "refresh": "Odśwież dane",
      "show_id": "Pokaż id",
      "sync_started": "Synchronizacja dodana do kolejki",
      "synced": "Zsynchronizowano",
      "text": "Dane zsynchronizowane z dostawcą"
    },
    "remove_managers": {
      "button": "Usuń wszystkich menedżerów",
      "description": "Usuń menedżera z każdego członka tej grupy.",
      "managers_removed": "Menedżerowie usunięci z członków grupy",
      "message": "Zamierzasz usunąć menedżera ze wszystkich członków tej grupy. Czy na pewno chcesz kontynuować? Tej czynności nie można cofnąć.",
      "title": "Usuń wszystkich menedżerów"
    },
    "risk_level": {
      "calculated": "Odziedziczony poziom ryzyka",
      "country": "Kraj",
      "group": "Grupa",
      "organisation": "Organizacja",
      "text": "Przegląd poziomów ryzyka",
      "title": "Poziom Ryzyka"
    },
    "search": {
      "empty": {
        "title": "Nie znaleziono grup"
      }
    },
    "segment_members": "Segmentacja grup",
    "segmentation": "Segmentacja",
    "segments": {
      "create": "Utwórz segment",
      "create_success": "Segment utworzony",
      "empty": "Nie znaleziono segmentów",
      "form": {
        "all": "Wszystkie",
        "any": "Dowolny",
        "exclude": "Wyklucz członków z następującymi tagami:",
        "include": "Uwzględnij członków z następującymi tagami:",
        "name": "Nazwa",
        "operator": "Operator",
        "select": "Wybierz tagi"
      },
      "heading": "Segmenty",
      "members_count": "Jeden członek | {count} członków",
      "text": "Użyj segmentów do filtrowania członków",
      "update": "Aktualizuj segment",
      "update_success": "Zaktualizowano segment"
    },
    "settings": {
      "caution": "Uwaga",
      "provider_change_warning": "{caution}: Zmiana danych dostawcy dla tej grupy spowoduje uruchomienie nowej synchronizacji grupy. Pracownicy obecnie przypisani do tej grupy mogą zostać usunięci, jeśli nie są uwzględnieni w zaktualizowanej grupie Active Directory. Proszę postępować ostrożnie, aby zapobiec niezamierzonym zmianom.",
      "subtitle": "Skonfiguruj ustawienia grupy.",
      "title": "Ustawienia grupy"
    },
    "sync_failed": {
      "button": "Ustawienia",
      "recommended_action": "Zalecane działanie",
      "title": "Synchronizacja nie powiodła się",
      "tooltip": "Synchronizacja tej grupy nie powiodła się."
    },
    "tags": {
      "create": "Utwórz tag",
      "create_success": "Utworzono tag.",
      "delete_success": "Tag usunięty",
      "empty": "Nie znaleziono tagów",
      "heading": "Tagi",
      "text": "Użyj tagów, aby grupować członków"
    }
  },
  "human_risk_intelligence": {
    "assignment": {
      "associated_risk_categories": "Powiązane kategorie ryzyka",
      "available": "Dostępne od",
      "completed": "Ukończone",
      "contextual_risk_factors": "Kontekstowe czynniki ryzyka",
      "deadline": "Termin",
      "details": "Szczegóły",
      "details_title": "Szczegóły przypisania",
      "osint": "OSINT",
      "osint_sources_summary": {
        "label": "Przeanalizowane źródła: {count}",
        "results_count": "{count} wynik | {count} wyników"
      },
      "passed": "Zaliczone",
      "rules": "Zasady",
      "signals": "Sygnały",
      "signals_description": "Sygnały, które wywołały to przypisanie",
      "strategy": "Strategia",
      "title": "Przypisanie"
    },
    "common": {
      "powered_by": "Obsługiwane przez {risk_framework}"
    },
    "content_preview": {
      "title": "Podgląd treści"
    },
    "dashboard_card": {
      "assignments_90_days": "Przypisania",
      "enable_button": "Włącz inteligencję ryzyka ludzkiego",
      "interventions_90_days": "Interwencje",
      "score_90_days": "Wynik",
      "signals_90_days": "Sygnały",
      "title": "Inteligencja ryzyka ludzkiego"
    },
    "dashboard_signal_collection": {
      "average_day": "Średni dzień",
      "avg_daily": "Śr. dziennie",
      "last_90_days": "Ostatnie 90 dni",
      "less": "Mniej",
      "lowest_day": "Najniższy dzień",
      "more": "Więcej",
      "negative": "Negatywne",
      "negative_count": "Negatywne: {count}",
      "no_signals_in_range": "Brak sygnałów w tym zakresie",
      "peak_day": "Dzień szczytowy",
      "positive": "Pozytywne",
      "positive_count": "Pozytywne: {count}",
      "signal_count": "1 sygnał | {count} sygnałów",
      "signal_count_on_date": "{count} w dniu {date}",
      "signal_range": "{min}-{max} sygnałów",
      "signals_on_date": "Sygnały w dniu {date}",
      "title": "Napływ sygnałów",
      "total_signals": "łączne sygnały"
    },
    "employee_preview": {
      "access_level": "Poziom dostępu",
      "info": "Informacje",
      "organizational_role": "Rola organizacyjna",
      "resilience_score": "Wynik odporności",
      "responsibility_tier": "Poziom odpowiedzialności",
      "role": "Rola",
      "title": "Pracownik"
    },
    "filters": {
      "back": "Wstecz",
      "data": "Filtruj dane",
      "filter_by": "Filtruj według",
      "search": "Szukaj",
      "select_date": "Wybierz datę"
    },
    "group_breakdown": {
      "columns": {
        "assignments": "Przypisania",
        "avg_score": "Śr. wynik",
        "employees": "Pracownicy",
        "group": "Grupa",
        "interventions": "Interwencje",
        "signals": "Sygnały"
      },
      "description": "Zagregowane sygnały, przypisania i interwencje według grup",
      "signals_slideover": {
        "activity_links_title": "Aktywność",
        "links_title": "Sygnały",
        "member_count": "{count} członków",
        "title": "Podział sygnałów",
        "view_assignments": "Zobacz przypisania",
        "view_interventions": "Zobacz interwencje",
        "view_signals": "Zobacz sygnały: {sentiment}"
      },
      "title": "Podział według grup"
    },
    "intervention": {
      "details_title": "Interwencja",
      "preview_body": "W środowisku produkcyjnym ten e-mail zawiera kontekst behawioralny i wskazówki dotyczące kolejnych kroków.",
      "preview_cta": "Przejrzyj swoją aktywność związaną z bezpieczeństwem i ukończ wymagane szkolenie uzupełniające.",
      "preview_from_name": "Zespół bezpieczeństwa Moxso",
      "preview_greeting": "Cześć {name},",
      "preview_intro": "To jest przykładowy podgląd powiadomienia interwencyjnego.",
      "preview_subject": "Powiadomienie bezpieczeństwa",
      "sent_at": "Wysłano",
      "signals_description": "Sygnały, które wywołały tę interwencję",
      "title": "Interwencja"
    },
    "navigation": {
      "assignments": "Przypisania",
      "interventions": "Interwencje",
      "osint": "OSINT",
      "overview": "Przegląd",
      "risk_framework": "Ramy ryzyka",
      "signals": "Sygnały"
    },
    "notification_title": "Powiadomienie",
    "notification_type": "Typ powiadomienia",
    "onboarding": {
      "common": {
        "back": "Wstecz",
        "cancel": "Anuluj",
        "next": "Dalej"
      },
      "glance": {
        "assignment_limits": "Do {max} lekcji na pracownika, z co najmniej {cooldown} dniami między przypisaniami",
        "eligibility": "Pracownicy kwalifikują się do otrzymywania szkoleń po {min_days} dniach od rozpoczęcia pracy.",
        "lesson_selection": "Lekcje są przypisywane automatycznie: {selection}",
        "notifications_disabled": "Powiadomienia wyłączone",
        "notifications_enabled": "Powiadomienia włączone z częstotliwością {frequency}. {behavior}"
      },
      "interventions": {
        "heading": "Interwencje wyzwalane zachowaniem",
        "subheading": "Określ, które sygnały behawioralne wywołują natychmiastową reakcję poza regularnym harmonogramem: korygujące przypisanie szkolenia, powiadomienie przełożonego pracownika lub alert dla administratorów bezpieczeństwa."
      },
      "intro": {
        "benefits": {
          "better_outcomes": {
            "description": "Skup zasoby tam, gdzie mają największe znaczenie",
            "title": "Lepsze wyniki"
          },
          "continuous_adaptation": {
            "description": "System uczy się i dostosowuje na podstawie bieżących zachowań",
            "title": "Ciągła adaptacja"
          },
          "personalized_experience": {
            "description": "Każdy pracownik otrzymuje szkolenie dopasowane do swoich potrzeb",
            "title": "Spersonalizowane doświadczenie"
          }
        },
        "description": "Human Risk Intelligence przekształca sygnały behawioralne w indywidualne profile ryzyka, a następnie przypisuje szkolenia i symulacje, których każdy pracownik faktycznie potrzebuje. Treści są kalibrowane według miejsca danej osoby w Moxso Risk Framework i ponownie kalibrowane, gdy pojawiają się nowe sygnały. Ryzyko spada bez zwiększania liczby szkoleń.",
        "heading": "Czym jest Human Risk Intelligence?",
        "setup_button": "Skonfiguruj Human Risk Intelligence",
        "subheading": "Szkol każdego pracownika z ryzyk, które faktycznie go dotyczą, i przestań szkolić go z tych, które go nie dotyczą."
      },
      "review": {
        "at_a_glance": "W skrócie",
        "enable_button": "Włącz Human Risk Intelligence",
        "heading": "Gotowe do włączenia",
        "next": {
          "heading": "Co dalej",
          "items": {
            "analysis_starts_immediately": "Moxso natychmiast rozpocznie zbieranie sygnałów behawioralnych w całej organizacji.",
            "no_lessons_assigned_immediately_prefix": "Szkolenie zostanie dostarczone po 24 godzinach.",
            "no_lessons_assigned_immediately_suffix": "Do tego czasu system nauczy się wystarczająco dużo, aby zbudować wiarygodny profil ryzyka dla każdego pracownika.",
            "settings_can_be_changed_anytime": "Te ustawienia można zmienić, a Human Risk Intelligence wyłączyć, w dowolnym momencie."
          }
        },
        "settings_link": "Potrzebujesz większej kontroli? Dostosuj ustawienia zaawansowane",
        "subheading": "Oto co się stanie po włączeniu Human Risk Intelligence."
      },
      "selection": {
        "heading": "Strategia szkoleniowa",
        "subheading": "Wybierz, jak Moxso priorytetyzuje i przypisuje ciągłe szkolenia w całej organizacji."
      },
      "signals": {
        "heading": "Sygnały",
        "subheading": "Skonfiguruj, jak sygnały wpływają na decyzje inteligencji ryzyka ludzkiego"
      },
      "steps": {
        "interventions": "Interwencje",
        "introduction": "Wprowadzenie",
        "review": "Przegląd i włączenie",
        "training_strategy": "Strategia szkoleniowa"
      }
    },
    "osint_explanation": {
      "description": "Silnik Moxso OSINT stale monitoruje globalny krajobraz zagrożeń i przekształca publiczne dane o cyberbezpieczeństwie w praktyczne wnioski dotyczące ryzyka ludzkiego.",
      "title": "Silnik Moxso OSINT (Open-Source Intelligence)"
    },
    "osint_news": {
      "empty": {
        "description": "Nie znaleziono danych OSINT dla tego ryzyka",
        "heading": "Dane OSINT niedostępne"
      },
      "title": "Kanał wywiadu o zagrożeniach"
    },
    "pages": {
      "assignments": {
        "heading": "Adaptacyjne przypisania",
        "subheading": "Przeglądaj i zarządzaj przypisaniami inteligencji ryzyka ludzkiego."
      },
      "interventions": {
        "heading": "Interwencje",
        "subheading": "Interwencje wyzwalane przez zachowanie pracowników w działaniach związanych z bezpieczeństwem."
      },
      "osint": {
        "article": {
          "associated_risk_indicators": "Powiązane wskaźniki ryzyka",
          "hide": "Ukryj",
          "indicator_count": "{count} wskaźnik | {count} wskaźników",
          "neutral_count": "{count} neutralny | {count} neutralnych",
          "risky_count": "{count} ryzykowny | {count} ryzykownych",
          "show": "Pokaż",
          "vigilant_count": "{count} czujny | {count} czujnych"
        },
        "breaches": "Wycieki",
        "current": "Bieżący",
        "heading": "Kanał informacji o zagrożeniach",
        "indicators": {
          "description": "Najczęstsze z ostatnich 24 godzin",
          "empty": {
            "description": "Aktywność wskaźników pojawi się tutaj, gdy kanał będzie zawierał oznaczone ryzyka.",
            "heading": "Brak wskaźników"
          },
          "title": "Wskaźniki ryzyka"
        },
        "negative_neutral": "Wymaga uwagi: Aktywność sygnałów się pogarsza",
        "negative_risky": "Alert: Aktywność zagrożeń rośnie",
        "negative_vigilant": "Wymaga uwagi: Środki bezpieczeństwa słabną",
        "news": {
          "description": "Ostatnie 24 godziny",
          "title": "Aktualności"
        },
        "no_change": "Brak zmiany aktywności sygnałów",
        "positive_neutral": "Pozytywny trend: Aktywność sygnałów się poprawia",
        "positive_risky": "Pozytywny trend: Aktywność zagrożeń maleje",
        "positive_vigilant": "Pozytywny trend: Poziom bezpieczeństwa się poprawia",
        "previous": "Poprzedni",
        "risk_themes": "Motywy ryzyka",
        "signal_change": "Zmiana sygnału",
        "sources": {
          "description": "Aktywne źródła z ostatnich 24 godzin",
          "empty": {
            "description": "Aktywność źródeł pojawi się tutaj, gdy kanał będzie zawierał artykuły.",
            "heading": "Brak źródeł"
          },
          "title": "Źródła"
        },
        "subheading": "Śledź zewnętrzne sygnały powiązane z monitorowanymi motywami ryzyka."
      },
      "overview": {
        "subheading": "Przegląd aktywności i wniosków inteligencji ryzyka ludzkiego."
      },
      "risk_framework": {
        "heading": "Ramy ryzyka",
        "subheading": "Ramy Moxso do oceny i zarządzania ryzykiem ludzkim w obszarze bezpieczeństwa."
      },
      "signals": {
        "heading": "Sygnały behawioralne",
        "subheading": "Zobacz wszystkie sygnały zebrane na podstawie zachowań pracowników."
      }
    },
    "risk_category": {
      "change": "Zmiana",
      "consequences": "Konsekwencje",
      "details_title": "Szczegóły kategorii ryzyka",
      "importance": "Znaczenie",
      "indicators": "Wskaźniki",
      "overview_title": "Przegląd kategorii ryzyka",
      "relevance": "Istotność",
      "tabs": {
        "details": "Szczegóły",
        "indicators": "Wskaźniki"
      }
    },
    "risk_framework": {
      "change_tooltip": "Zmiana w ciągu ostatnich 90 dni",
      "description_1": "Ramy ryzyka Moxso to model oparty na danych służący do identyfikowania, kwantyfikowania i operacjonalizowania ludzkiego ryzyka cybernetycznego we współczesnych organizacjach.",
      "description_2": "Są zgodne ze standardami branżowymi, takimi jak MITRE ATT&CK i NIST Cybersecurity Framework, i rozszerzają tradycyjne modele oparte na kontrolach, koncentrując się konkretnie na zachowaniu człowieka jako wektorze ataku. Ramy przekształcają rzeczywiste dane behawioralne, sygnały ekspozycji na zagrożenia i strukturalne czynniki ryzyka w mierzalne i audytowalne wskaźniki ryzyka.",
      "description_3": "Ramy są zorganizowane wokół 16 kategorii ryzyka skoncentrowanych na człowieku (R.01-R.16) i zapewniają spójne punktacje, praktyczne wnioski oraz raportowanie zgodne z wymaganiami compliance.",
      "references": "Odniesienia do ram",
      "short_description": "Ramy ryzyka Moxso to model oparty na danych służący do identyfikowania, kwantyfikowania i operacjonalizowania ludzkiego ryzyka cybernetycznego we współczesnych organizacjach.",
      "title": "Ramy ryzyka"
    },
    "risk_matrix": {
      "axes": {
        "impact": "Wpływ",
        "likelihood": "Prawdopodobieństwo"
      },
      "legend": {
        "high": "Wysoki",
        "low": "Niski",
        "med": "Śr."
      },
      "title": "Macierz ryzyka sygnałów",
      "tooltip": {
        "change": "Zmiana",
        "current": "Bieżący",
        "high": "Sygnały wysokiego ryzyka",
        "low": "Sygnały niskiego ryzyka",
        "medium": "Sygnały średniego ryzyka",
        "previous": "Poprzedni"
      }
    },
    "sections": {
      "recent_assignments": "Ostatnie przypisania",
      "recent_interventions": "Ostatnie interwencje",
      "recent_signals": "Ostatnie sygnały"
    },
    "settings": {
      "common": {
        "days": "{days} dni",
        "disabled": "Wyłączone",
        "enabled": "Włączone",
        "every_days": "Co {days} dni",
        "no": "Nie",
        "none": "Brak",
        "yes": "Tak"
      },
      "eligibility": {
        "criteria_title": "Kryteria kwalifikowalności",
        "description": "Określ, kto kwalifikuje się do inteligencji ryzyka ludzkiego",
        "excluded_groups": "Wykluczone grupy",
        "excluded_groups_help": "Wyklucz określone grupy z automatycznych przepływów szkoleniowych",
        "excluded_roles": "Wykluczone role",
        "excluded_roles_help": "Wyklucz określone role organizacyjne z automatycznych przepływów szkoleniowych",
        "minimum_employment_duration_help": "Pracownicy muszą być zatrudnieni przez co najmniej tyle dni, aby się kwalifikować",
        "minimum_employment_duration_label": "Minimalny okres zatrudnienia (dni)",
        "targeting_title": "Targetowanie",
        "title": "Kwalifikowalność"
      },
      "interventions": {
        "actions": {
          "add_action": "Dodaj działanie",
          "assign_new_lesson": "Przypisz nową lekcję",
          "assignment_description": "Przypisz szkolenie korygujące do wskazanego pracownika.",
          "empty": "Nie ma jeszcze działań. Dodaj jedno, aby określić, co ma się wydarzyć po uruchomieniu tej grupy.",
          "heading": "Działania po wyzwoleniu",
          "notify_admin": "Powiadom administratorów",
          "notify_admin_description": "Wyślij e-mail do uprawnionego administratora obszaru roboczego Moxso.",
          "notify_employee": "Powiadom pracownika",
          "notify_employee_description": "Wyślij e-mail do wskazanego pracownika o wykrytym zachowaniu.",
          "notify_manager": "Powiadom przełożonego",
          "notify_manager_description": "Wyślij e-mail do aktywnego przełożonego pracownika.",
          "remove_action": "Usuń {action}"
        },
        "enable_subtitle": "Pozwól inteligencji ryzyka ludzkiego łamać standardowe zasady przypisań, gdy wykryte zostanie zachowanie wysokiego ryzyka, i eskalować do menedżerów i administratorów bezpieczeństwa.",
        "enable_title": "Włącz interwencje",
        "excluded_groups": "Wykluczone grupy",
        "excluded_groups_help": "Pracownicy w tych grupach nigdy nie są obejmowani nadpisaniami interwencji.",
        "excluded_roles": "Wykluczone role",
        "excluded_roles_description": "Pracownicy w tych rolach nigdy nie są obejmowani nadpisaniami interwencji.",
        "groups_description": "Wybierz grupy sygnałów do monitorowania i skonfiguruj reakcję dla każdej z nich.",
        "groups_title": "Grupy sygnałów interwencyjnych",
        "severity_label": "Poziom przeterminowania",
        "threshold_label": "Próg aktywacji",
        "threshold_occurrences": "{count} zdarzenie | {count} zdarzenia",
        "timeframe_days": "Co {days} dni",
        "timeframe_label": "Okres",
        "timeframe_within_90_days": "W ciągu 90 dni",
        "triggers": {
          "breach_exposure": {
            "description": "Zezwól na natychmiastowe przypisanie, gdy pracownik pojawi się w znanym naruszeniu.",
            "title": "Ekspozycja na naruszenie"
          },
          "phishing_failures": {
            "description": "Zezwól na natychmiastowe przypisanie po niepowodzeniu symulacji przez pracownika.",
            "title": "Niepowodzenia symulacji phishingu"
          },
          "training_non_compliance": {
            "description": "Zezwól na natychmiastowe przypisanie, gdy wymagane szkolenie jest przeterminowane.",
            "title": "Niezgodność szkoleniowa"
          }
        },
        "triggers_description": "Wybierz, które zdarzenia mogą wywołać natychmiastowe szkolenie i eskalację do menedżerów lub administratorów bezpieczeństwa, nawet jeśli pracownik niedawno otrzymał inne szkolenie.",
        "triggers_title": "Wyzwalacze interwencji"
      },
      "notifications": {
        "continuous_sending_subtitle": "Wysyłaj przypomnienia aż do ukończenia",
        "continuous_sending_title": "Ciągłe wysyłanie",
        "enable_subtitle": "Wysyłaj powiadomienia e-mail o nowych przypisaniach",
        "enable_title": "Włącz powiadomienia",
        "frequency": {
          "intense": "Intensywny",
          "loose": "Luźny",
          "normal": "Normalny (na przypisanie)",
          "per_assignment": "Na przypisanie"
        },
        "frequency_label": "Częstotliwość powiadomień",
        "title": "Powiadomienia"
      },
      "review": {
        "enable_subtitle": "Uruchom spersonalizowane przypisania szkoleń na podstawie zachowań pracowników",
        "enable_title": "Włącz inteligencję ryzyka ludzkiego",
        "frequency": "Częstotliwość",
        "max_assignments_per_run": "Maks. przypisań na uruchomienie: {value}",
        "notifications": "Powiadomienia",
        "reminders_until_completion": "Przypomnienia do ukończenia",
        "save_settings": "Zapisz ustawienia",
        "selection": "Wybór",
        "title": "Przegląd i włączenie"
      },
      "selection_strategy": {
        "avoid_repetition_help": "Nie przypisuj ponownie tej samej lekcji w tym okresie.",
        "avoid_repetition_label": "Unikaj powtarzania tego samego szkolenia (dni)",
        "cooldown_help": "Odczekaj przed przypisaniem nowego szkolenia z inteligencji ryzyka ludzkiego po dowolnym szkoleniu.",
        "cooldown_label": "Okres karencji (dni)",
        "enable_subtitle": "Pozwól Human Risk Intelligence przypisywać ciągłe szkolenia na podstawie profili ryzyka pracowników.",
        "enable_title": "Włącz Human Risk Intelligence",
        "excluded_videos": "Wykluczone filmy",
        "excluded_videos_description": "Te filmy nigdy nie są przypisywane przez Human Risk Intelligence.",
        "excluded_videos_placeholder": "Wybierz filmy",
        "frameworks_help": "Wybierz jedne lub więcej ram, aby priorytetyzować szkolenia powiązane z celami zgodności.",
        "frameworks_label": "Ramy",
        "frameworks_placeholder": "Wybierz ramy",
        "hide_advanced_settings": "Ukryj ustawienia zaawansowane",
        "interval_help": "Minimalna liczba dni między ukończonymi szkoleniami a nowymi przypisaniami.",
        "interval_label": "Interwał (dni)",
        "label": "Strategia wyboru",
        "max_assignments_per_run_help": "Maksymalna liczba nowych szkoleń na pracownika w jednej ocenie.",
        "max_assignments_per_run_label": "Maks. przypisań na uruchomienie",
        "show_advanced_settings": "Pokaż ustawienia zaawansowane"
      },
      "signals": {
        "failed_simulation": "Nieudana symulacja",
        "failed_simulation_help": "Waga stosowana, gdy pracownik kliknie symulację phishingową",
        "low_score": "Niski wynik",
        "low_score_help": "Waga stosowana, gdy wynik quizu szkoleniowego jest poniżej progu"
      },
      "summary_eligibility": {
        "description": "Określa, kto kwalifikuje się do inteligencji ryzyka ludzkiego",
        "excluded_roles": "Wykluczone role",
        "minimum_employment_duration": "Minimalny czas zatrudnienia",
        "title": "Kwalifikowalność"
      },
      "summary_selection": {
        "description": "Określa, jak wybierane są lekcje i jak powiadamiani są pracownicy",
        "email_notifications": "E-mail powiadomienia",
        "lesson_selection": "Wybór lekcji",
        "maximum_lessons_per_employee": "Maksymalna liczba lekcji na pracownika",
        "minimum_time_between_lessons": "Minimalny czas między lekcjami",
        "notification_settings": "Ustawienia powiadomień",
        "notification_style": "Styl powiadomień",
        "prioritize_mandatory_training": "Priorytetyzuj obowiązkowe szkolenie",
        "selection_approach": "Podejście do wyboru",
        "send_reminders_until_complete": "Wysyłaj przypomnienia do ukończenia",
        "standard_training_interval": "Standardowy interwał szkoleniowy",
        "title": "Wybór i powiadomienia"
      },
      "summary_signals": {
        "description": "Określa, jak sygnały wpływają na decyzje inteligencji ryzyka ludzkiego",
        "impact": {
          "high": "Wysoki wpływ",
          "low": "Niski wpływ",
          "medium": "Średni wpływ"
        },
        "signal_labels": {
          "failed_simulation": "Nieudana symulacja phishingu",
          "low_score": "Niski wynik szkolenia"
        },
        "title": "Sygnały"
      }
    },
    "signal": {
      "associated_risk_categories": "Powiązane kategorie ryzyka",
      "behaviour": "Zachowanie",
      "category": "Kategoria",
      "indicator": "Wskaźnik",
      "intel": "Wywiad",
      "no": "Nie",
      "polarity": "Polaryzacja",
      "sentiment": "Sentyment",
      "title": "Sygnał",
      "value": "Wartość",
      "yes": "Tak"
    },
    "signal_preview": {
      "breach": {
        "title": "Monitor dark webu"
      },
      "multiple_choice_quiz_answer": {
        "answer": "Odpowiedź",
        "question": "Pytanie",
        "title": "Odpowiedź w quizie"
      },
      "phishing_quiz_answer": {
        "correct": "Poprawna",
        "incorrect": "Niepoprawna",
        "question": "Pytanie",
        "result": "Wynik",
        "subject": "Temat",
        "time": "Czas",
        "title": "Odpowiedź w quizie phishingowym"
      }
    },
    "stats": {
      "assignments": "Przypisania",
      "completed_assignments": "Ukończone przypisania",
      "interventions": "Interwencje",
      "negative_signals": "Negatywne sygnały",
      "positive_signals": "Pozytywne sygnały",
      "risk_level": {
        "country_risk": "Ryzyko kraju",
        "industry_risk": "Ryzyko branży",
        "levels": {
          "high": "Wysoki",
          "loading": "Ładowanie",
          "low": "Niski",
          "medium": "Umiarkowany"
        },
        "title": "Poziom ryzyka"
      },
      "signals": "Sygnały"
    },
    "tables": {
      "negative": "Negatywny",
      "neutral": "Neutralny",
      "sentiment": "Sentyment",
      "severity": "Dotkliwość",
      "signal_count": "1 sygnał | {count} sygnałów",
      "signal_type": "Sygnał"
    },
    "title": "Human Risk Intelligence",
    "tooltips": {
      "compared_to_prior_period": "W porównaniu z poprzednim okresem o tej samej długości.",
      "previous_value": "Poprzednia wartość"
    },
    "trending_risk_indicators": "Trendujące wskaźniki ryzyka"
  },
  "image_library": {
    "empty_button": "Prześlij obraz",
    "empty_description": "Prześlij pierwszy obraz, aby zacząć budować bibliotekę wielokrotnego użytku.",
    "empty_title": "Brak obrazów",
    "image_format": "JPG/JPEG/PNG · Do 1MB",
    "image_uploaded": "Obraz został pomyślnie przesłany",
    "insert_button": "Wstaw obraz",
    "library_tab": "Biblioteka obrazów",
    "refresh": "Odśwież",
    "show_more": "Pokaż więcej",
    "title": "Wstaw obraz",
    "upload_tab": "Prześlij",
    "upload_title": "Prześlij nowy obraz"
  },
  "locale": {
    "current": "Polski",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "french": "Français",
    "norwegian": "Norwegian",
    "polish": "Polski",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "back_to_login": "Powrót do logowania",
    "button": "Zaloguj się",
    "change_email": "Zmień e-mail?",
    "continue": "Kontynuuj",
    "forgot_password": {
      "link": "Zresetuj teraz",
      "text": "Zapomniałeś hasła?"
    },
    "heading": "Witamy ponownie",
    "loading": "Ładowanie",
    "preparing_session": "Przygotowywanie sesji",
    "sso": {
      "provider_found": "SSO jest dostępne dla {provider}. Kontynuuj, aby zalogować się przez dostawcę tożsamości.",
      "redirecting": "Przekierowanie do SSO",
      "redirecting_text": "Przygotowujemy żądanie logowania.",
      "validating": "Weryfikowanie SSO",
      "validating_text": "Kończymy logowanie."
    },
    "text": "Zaloguj się do swojego miejsca pracy"
  },
  "manager_report": {
    "assignment": "Zadanie",
    "assignments": "Zadania",
    "company_average": "Średnia firmy",
    "compared_against": "W porównaniu z {period}",
    "completed": "Ukończono",
    "date": "Data",
    "days_overdue": "Dni po terminie",
    "deadline": "Termin",
    "deadlines_description": "Liczba zadań po terminie w okresie {period}: {count}.",
    "department": "Dział",
    "employee": "Pracownik",
    "employees_affected": "Pracownicy, których dotyczy",
    "employees_at_risk": "Pracownicy narażeni na ryzyko",
    "gap_to_company": "Różnica względem firmy",
    "generated": "Wygenerowano {date}",
    "human_risk_intelligence": "Human Risk Intelligence",
    "individual_reports": "Indywidualne raporty szkoleń i ryzyka · {count} pracowników | Indywidualny raport szkoleń i ryzyka · {count} pracownik | Indywidualne raporty szkoleń i ryzyka · {count} pracowników",
    "interventions": "Ostatnie interwencje uruchomione przez Moxso",
    "loading": "Wczytywanie raportu menedżera…",
    "missed_deadlines": "Przekroczone terminy",
    "missed_team_deadlines": "Przekroczone terminy zespołu",
    "most_dangerous_signals": "3 najgroźniejsze sygnały w tym okresie",
    "no_assignments": "Brak zadań",
    "no_dangerous_signals": "Brak niebezpiecznych sygnałów",
    "no_employees_at_risk": "Brak pracowników narażonych na ryzyko",
    "no_interventions": "Nie uruchomiono interwencji",
    "no_missed_deadlines": "Brak przekroczonych terminów",
    "no_recent_signals": "Brak ostatnich sygnałów",
    "no_sentiment_data": "Brak danych o wydźwięku",
    "no_severity_data": "Brak danych o poziomie zagrożenia",
    "oldest_deadline": "Najstarszy termin",
    "overdue_assignments": "Zadania po terminie",
    "period_over_period": "W porównaniu z poprzednim okresem",
    "points": "{points} pkt",
    "recent_signals": "Ostatnie sygnały",
    "risk_indicator": "Wskaźnik ryzyka",
    "score": "Wynik",
    "sentiment": "Wydźwięk",
    "severity": "Poziom zagrożenia",
    "signal": "Sygnał",
    "signals": "Sygnały",
    "signals_by_sentiment": "Sygnały według wydźwięku",
    "signals_by_severity": "Sygnały według poziomu zagrożenia",
    "sorted_by_deadline": "Sortowanie według terminu",
    "status": "Status",
    "summary": "Podsumowanie",
    "team_average": "Średnia zespołu",
    "threshold": "Próg {value}% · od najniższego",
    "title": "Raport menedżera",
    "total": "Łącznie: {count}",
    "training_report": "Raport szkoleniowy",
    "trend_title": "Odporność, współczynnik kliknięć i zgłoszeń",
    "type": "Typ",
    "unavailable": "Raport jest niedostępny",
    "unavailable_description": "Nie udało się wczytać raportu. Sprawdź, czy link jest prawidłowy i nie wygasł."
  },
  "navigation": {
    "assigned_learning": "Przypisane szkolenia",
    "at_risk": "Pracownicy zagrożeni",
    "audit": {
      "index": "Audyt",
      "settings": "Ustawienia"
    },
    "automation": {
      "flow_builder": "Kreator sekwencji",
      "index": "Automatyzacja",
      "sequence": "Sekwencja",
      "settings": "Ustawienia"
    },
    "breaches": "Naruszenia",
    "configuration": "Konfiguracja",
    "custom_upload": {
      "edit": "Edytuj",
      "quiz": "Quiz"
    },
    "custom_uploads": "Niestandardowe pliki",
    "dashboard": "Analityka",
    "employees": "Pracownicy",
    "goals": "Cele",
    "groups": {
      "index": "Grupy",
      "settings": "Ustawienia",
      "single": "Grupa"
    },
    "human_risk_intelligence": "Inteligencja ryzyka ludzkiego",
    "integration": {
      "activity": "Aktywność",
      "settings": "Ustawienia"
    },
    "integrations": "Integracje",
    "knowledge_base": "Baza wiedzy",
    "lessons_courses": "Kursy",
    "lessons_deadlines": "Terminy",
    "lessons_videos": "Filmy wideo",
    "no_workspaces": "Nie znaleziono przestrzeni roboczych",
    "overview": "Przegląd",
    "policies": "Polityki",
    "policy": {
      "edit": "Edytuj",
      "quiz": "Quiz"
    },
    "resilience": "Odporność",
    "search_workspaces": "Szukaj przestrzeni roboczych",
    "settings": {
      "administration": "Administracja",
      "admins": "Administratorzy",
      "apis_and_data": "API i dane",
      "audit_logs": "Dzienniki audytu",
      "authentication": "Uwierzytelnianie",
      "back_to_app": "Wróć do aplikacji",
      "breaches": "Naruszenia",
      "close_navigation": "Zamknij nawigację",
      "compliance": "Zgodność",
      "domains": "Domeny",
      "e_learning": "Szkolenia",
      "export": "Raporty",
      "exports": "Eksport",
      "goals": "Cele",
      "human_risk_intelligence": "Inteligencja ryzyka ludzkiego",
      "import": "Importuj",
      "index": "Ustawienia",
      "interventions": "Interwencje",
      "personal": "Osobiste",
      "reporting": "Raportowanie",
      "risk": "Ryzyko",
      "simulations": "Symulacje",
      "threats": "Zagrożenia",
      "workspace": "Obszar roboczy"
    },
    "sign_out": "Wyloguj się",
    "simulations": {
      "custom_templates": "Niestandardowe szablony",
      "index": "Symulacje",
      "scheduled": "Zaplanowane",
      "single": "Aktywność",
      "single_settings": "Ustawienia"
    },
    "team": "Pracownicy",
    "threats": "Zagrożenia",
    "training": "Szkolenia",
    "user_settings": "Bezpieczeństwo i dostęp",
    "your_workspaces": "Twoje przestrzenie robocze"
  },
  "oauth": {
    "back_to_home": "Powrót do strony głównej",
    "error": "Nie można było skonfigurować integracji",
    "login": "Zaloguj się",
    "success": "Dostawca został pomyślnie zapisany"
  },
  "onboarding": {
    "building_training_paths": "Budowanie ścieżek szkoleniowych",
    "calculating_risk_score": "Obliczanie wyniku ryzyka",
    "choose_provider": "Wybierz dostawcę tożsamości",
    "continue_button": "Kontynuuj",
    "exit": "Wyjście",
    "gmail_integration": "Integracja z Gmail",
    "google_manual_setup": {
      "access_google_admin_console_heading": "Uzyskaj dostęp do konsoli administracyjnej Google",
      "access_google_admin_console_text": "Zaloguj się do konsoli administracyjnej Google Workspace: {google_admin_console_link}",
      "allow_moxso_ip_addresses_bullet_1": "Rozwiń sekcję {email_allowlist}.",
      "allow_moxso_ip_addresses_bullet_2": "Wprowadź następujące adresy IP Moxso: {ip_1} {ip_2}",
      "allow_moxso_ip_addresses_bullet_3": "Kliknij {save_button}.",
      "allow_moxso_ip_addresses_heading": "Zezwalaj na adresy IP Moxso",
      "configure_inbound_gateway_bullet_1": "Rozwiń sekcję {inbound_gateway}.",
      "configure_inbound_gateway_bullet_2": "Włącz bramkę, przełączając przełącznik.",
      "configure_inbound_gateway_bullet_3": "Wprowadź następujące adresy IP Moxso pod {gateway_ips}: {ip_1} {ip_2}",
      "configure_inbound_gateway_bullet_4": "Włącz {require_tls}.",
      "configure_inbound_gateway_bullet_5": "W sekcji {message_tagging_section} włącz {message_spam_eval_header}.",
      "configure_inbound_gateway_bullet_6": "Wprowadź następującą wartość w polu {regexp_field}: {uuid}",
      "configure_inbound_gateway_bullet_7": "Włącz {disable_gmail_spam_eval}.",
      "configure_inbound_gateway_bullet_8": "Kliknij {save_button}, aby zastosować ustawienia.",
      "configure_inbound_gateway_heading": "Skonfiguruj bramę przychodzącą",
      "configure_spam_rule_bullet_1": "Przejdź do {spam_settings}: W tym samym menu {menu_path} znajdź sekcję Spam.",
      "configure_spam_rule_bullet_2": "Dodaj nową regułę: Kliknij {add_rule} (lub edytuj istniejącą regułę Moxso) i nadaj jej nazwę, np. {rule_name}.",
      "configure_spam_rule_bullet_3": "Skonfiguruj pomijanie: Wybierz {bypass_option}",
      "configure_spam_rule_bullet_4": "Ukryj ostrzeżenia (krytyczne): Upewnij się, że zaznaczysz {hide_warnings_option}",
      "configure_spam_rule_bullet_5": "Upewnij się, że domeny symulacyjne zostaną dodane do listy adresów tej reguły, pobierając plik CSV:",
      "configure_spam_rule_bullet_6": "Zapisz regułę.",
      "configure_spam_rule_heading": "Skonfiguruj regułę spamu (pomijanie ostrzeżeń)",
      "disable_gmail_spam_eval": "Wyłącz ocenę spamu Gmaila dla poczty z tej bramy; używaj tylko wartości nagłówka.",
      "email_allowlist": "Lista dozwolonych adresów e-mail",
      "gateway_ips": "Adresy IP bramy",
      "google_admin_console": "Konsola administracyjna Google",
      "inbound_gateway": "Brama przychodząca",
      "inbound_gateway_warning_not_checked": "niezaznaczona",
      "inbound_gateway_warning_text": "Upewnij się, że opcja {reject_option} jest {not_checked}. Jeśli ta opcja pozostanie włączona, będziesz otrzymywać e-maile tylko od Moxso, a nie od zewnętrznych nadawców.",
      "message_spam_eval_header": "Wiadomość jest uznawana za spam, jeśli pasuje następujące wyrażenie regexp nagłówka",
      "message_tagging": "Tagowanie wiadomości",
      "navigate_spam_phishing_malware_heading": "Przejdź do ustawień spamu, phishingu i złośliwego oprogramowania",
      "navigate_spam_phishing_malware_text": "Przejdź do ustawień Gmaila dotyczących spamu, phishingu i złośliwego oprogramowania: {spam_phishing_link}",
      "regexp": "Regexp",
      "require_tls": "Wymagaj TLS dla połączeń z bram e-mail wymienionych powyżej.",
      "save": "Zapisz",
      "spam_phishing_malware_settings": "Ustawienia spamu, phishingu i złośliwego oprogramowania",
      "whitelisting_moxso_ip_addresses_in_gw": "Dodawanie adresów IP Moxso do listy dozwolonych w Google Workspace"
    },
    "import_employees": "Importuj pracowników",
    "integration_error": "Wystąpił błąd podczas konfigurowania integracji z {provider}.",
    "integration_error_title": "Wystąpił błąd",
    "invite": {
      "button": "Zaproś użytkownika",
      "text": "Wyślemy im e-mail, aby zacząć.",
      "title": "Zaproś członków zespołu do twojego panelu sterowania"
    },
    "microsoft_bypass_junk_by_header": {
      "bypass_junk_by_header": "Omijanie spamu według nagłówka",
      "finish": "zakończ",
      "step_1_heading": "Centrum administracyjne Exchange",
      "step_1_text": "Przejdź do reguł przepływu poczty w centrum administracyjnym Exchange, odwiedzając następujący URL: {url}",
      "step_2_heading": "Utwórz nową regułę",
      "step_2_text": "Utwórz nową regułę i nadaj jej nazwę. Na przykład: {copyField}",
      "step_2b_heading": "Skonfiguruj regułę",
      "step_2b_list_1": "Wybierz \"Nagłówki wiadomości...\"",
      "step_2b_list_2": "Następnie wybierz \"pasuje do tych wzorców tekstu\".",
      "step_2b_p1": "Kliknij pierwszy link „Wprowadź tekst” i wpisz klucz nagłówka: {copyField}",
      "step_2b_p2": "Kliknij następny link \"Wprowadź tekst\" i wprowadź następującą wartość nagłówka: {copyField}",
      "step_2b_text": "W menu rozwijanym „Zastosuj tę regułę, jeśli”:",
      "step_3_heading": "Skonfiguruj nagłówek wiadomości",
      "step_3_list_1": "Wybierz \"Zmodyfikuj właściwości wiadomości\"",
      "step_3_list_2": "Następnie wybierz „Ustaw nagłówek wiadomości”.",
      "step_3_list_3": "Kliknij pierwszy link „Wprowadź tekst” i ustaw nagłówek na: {copyField}",
      "step_3_list_4": "Kliknij drugi link \"Wprowadź tekst\" i ustaw wartość na: {copyField}",
      "step_3_text": "W menu rozwijanym \"Wykonaj następujące czynności\":",
      "step_4_heading": "Ustawienia reguły",
      "step_4_list_1": "Kliknij \"dalej\" i kontynuuj ustawienia reguł.",
      "step_4_list_2": "Pod \"Tryb reguły\" wybierz \"Egzekwuj\".",
      "step_4_list_3": "Kliknij „dalej” i przejrzyj konfigurację reguły.",
      "step_5_heading": "Zapisz regułę",
      "step_5_text": "Kliknij {finish}, aby zapisać i zastosować regułę."
    },
    "microsoft_bypass_junk_by_ip": {
      "bypass_junk_by_ip": "Ominięcie spamu według IP",
      "configure_message_header_heading": "Skonfiguruj nagłówek wiadomości",
      "configure_message_header_text_bullet_1": "Wybierz {modify_message_props}",
      "configure_message_header_text_bullet_2": "Następnie wybierz {set_msg_header}",
      "configure_message_header_text_bullet_3": "Kliknij pierwszy link „Wpisz tekst” i ustaw nagłówek na: {header}",
      "configure_message_header_text_bullet_4": "Kliknij drugi link \"Wprowadź tekst\" i ustaw wartość na: {value}",
      "configure_message_header_text_intro": "W menu rozwijanym „Wykonaj następujące kroki”:",
      "configure_rule_heading": "Skonfiguruj regułę",
      "configure_rule_text_bullet_1": "Wybierz {the_sender}",
      "configure_rule_text_bullet_2": "Następnie wybierz {ip_range}",
      "configure_rule_text_bullet_3": "Wprowadź następujące adresy IP jeden po drugim w wyskakującym okienku i kliknij „Dodaj”. Gdy skończysz, kliknij „Zapisz”.",
      "configure_rule_text_intro": "W menu rozwijanym \"Zastosuj tę regułę, jeśli\":",
      "create_new_rule_heading": "Utwórz nową regułę",
      "create_new_rule_text": "Utwórz nową regułę i nadaj jej nazwę. Na przykład: {example}",
      "exchange_admin_center_heading": "Centrum administracyjne Exchange",
      "exchange_admin_center_text": "Przejdź do reguł przepływu poczty w centrum administracyjnym Exchange, odwiedzając następujący adres URL: {url}",
      "rule_settings_bullet_1": "Kliknij „dalej” i kontynuuj ustawienia reguły.",
      "rule_settings_bullet_2": "Pod \"Tryb reguły\" wybierz \"Wymuś\".",
      "rule_settings_bullet_3": "Kliknij \"dalej\" i sprawdź konfigurację reguły.",
      "rule_settings_heading": "Ustawienia reguły",
      "save_the_rule_heading": "Zapisz regułę",
      "save_the_rule_text": "Kliknij {finish}, aby zapisać i zastosować regułę."
    },
    "microsoft_bypass_safe_links_by_header": {
      "bypass_safe_links_by_header": "Omijanie bezpiecznych linków przez nagłówek",
      "configure_message_header_heading": "Konfiguruj nagłówek wiadomości",
      "configure_message_header_text_bullet_1": "Wybierz {modify_message_properties}",
      "configure_message_header_text_bullet_2": "Następnie wybierz {set_a_message_header}",
      "configure_message_header_text_bullet_3": "Kliknij pierwszy link „Wprowadź tekst” i ustaw nagłówek na: {header}",
      "configure_message_header_text_bullet_4": "Kliknij drugi link „Wprowadź tekst” i ustaw wartość na: {value}",
      "configure_message_header_text_intro": "W menu rozwijanym „Wykonaj następujące czynności”:",
      "configure_rule_heading": "Skonfiguruj regułę",
      "configure_rule_text_bullet_1": "Wybierz {the_message_headers}",
      "configure_rule_text_bullet_2": "Następnie wybierz {matches_text_patterns}",
      "configure_rule_text_intro": "W menu rozwijanym \"Zastosuj tę regułę, jeśli\":",
      "configure_rule_text_paragraph_1": "Kliknij pierwszy link „Wprowadź tekst” i wprowadź klucz nagłówka: {header_key}",
      "configure_rule_text_paragraph_2": "Kliknij następny link „Wprowadź tekst” i wprowadź następującą wartość nagłówka: {header_value}",
      "create_new_rule_heading": "Utwórz nową regułę",
      "create_new_rule_text": "Utwórz nową regułę i nadaj jej nazwę. Na przykład: {example}",
      "exchange_admin_center_heading": "Centrum administracyjne Exchange",
      "exchange_admin_center_text": "Przejdź do reguł przepływu poczty w centrum administracyjnym Exchange, odwiedzając następujący URL: {url}",
      "rule_settings_bullet_1": "Kliknij \"dalej\" i kontynuuj ustawienia reguły.",
      "rule_settings_bullet_2": "W sekcji „Tryb reguły” wybierz „Wymuś”.",
      "rule_settings_bullet_3": "Kliknij \"dalej\" i przejrzyj konfigurację reguły.",
      "rule_settings_heading": "Ustawienia reguły",
      "save_the_rule_heading": "Zapisz regułę",
      "save_the_rule_text": "Kliknij {finish}, aby zapisać i zastosować regułę."
    },
    "microsoft_bypass_safe_links_by_ip": {
      "bypass_safe_links_by_ip": "Omiń bezpieczne linki według adresu IP",
      "configure_message_header_heading": "Konfiguruj nagłówek wiadomości",
      "configure_message_header_text_bullet_1": "Wybierz {modify_message_props}",
      "configure_message_header_text_bullet_2": "Następnie wybierz {set_msg_header}",
      "configure_message_header_text_bullet_3": "Kliknij pierwszy link „Wprowadź tekst” i ustaw nagłówek na: {header}",
      "configure_message_header_text_bullet_4": "Kliknij drugi link \"Wprowadź tekst\" i ustaw wartość na: {value}",
      "configure_message_header_text_intro": "W menu rozwijanym „Wykonaj następujące czynności”:",
      "configure_rule_heading": "Skonfiguruj regułę",
      "configure_rule_text_bullet_1": "Wybierz {the_sender}",
      "configure_rule_text_bullet_2": "Następnie wybierz {ip_range}",
      "configure_rule_text_bullet_3": "Wprowadź następujące adresy IP jeden po drugim w oknie wyskakującym i kliknij „Dodaj”. Po zakończeniu kliknij „Zapisz”.",
      "configure_rule_text_intro": "W menu rozwijanym „Zastosuj tę regułę, jeśli”:",
      "create_new_rule_heading": "Utwórz nową regułę",
      "create_new_rule_text": "Utwórz nową regułę i nadaj jej nazwę. Na przykład: {example}",
      "exchange_admin_center_heading": "Centrum administracyjne Exchange",
      "exchange_admin_center_text": "Przejdź do reguł przepływu poczty w centrum administracyjnym Exchange, odwiedzając następujący adres URL: {url}",
      "rule_settings_bullet_1": "Kliknij „dalej” i kontynuuj ustawienia reguły.",
      "rule_settings_bullet_2": "Wybierz „Wymuś” w polu „Tryb reguły”.",
      "rule_settings_bullet_3": "Kliknij „Dalej” i przejrzyj konfigurację reguły.",
      "rule_settings_heading": "Ustawienia reguły",
      "save_the_rule_heading": "Zapisz regułę",
      "save_the_rule_text": "Kliknij {finish}, aby zapisać i zastosować regułę."
    },
    "microsoft_integration": "Umieszczenie na białej liście Microsoft",
    "microsoft_tenant_allow_block": {
      "add_moxso_ips_to_tabl": "Dodaj adresy IP Moxso do listy dozwolonych/zablokowanych organizacji.",
      "add_new_entry_bullet_1": "Kliknij przycisk {add_button}.",
      "add_new_entry_bullet_2": "W sekcji par domen, wprowadź następujące: {domain_pair_1} {domain_pair_2}",
      "add_new_entry_bullet_3": "Ustaw typ Spoof na {spoof_internal}.",
      "add_new_entry_bullet_4": "Ustaw działanie na {allow_action}.",
      "add_new_entry_heading": "Dodaj nowy wpis",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Przejdź do list Dozwól/Zablokuj dzierżawy w Microsoft Defender, odwiedzając następujący adres URL: {url}",
      "save_the_domain_pair_heading": "Zapisz parę domenową",
      "save_the_domain_pair_text": "Kliknij {add}, aby zapisać nową parę domen."
    },
    "microsoft_third_party": {
      "add_moxso_ips_domains_title": "Dodaj adresy IP i domeny Moxso do symulacji phishingu stron trzecich w Microsoft Defender.",
      "download_simulation_heading": "Pobierz domeny/IP do symulacji",
      "download_simulation_text": "Pobierz domeny/IP symulacji, klikając przycisk poniżej: {csv_export_button}",
      "edit_entries_bullet_1": "Kliknij przycisk {edit_button}.",
      "edit_entries_bullet_2": "W sekcji {domain_section} wprowadź każdą domenę wymienioną jako {domain_text} w pobranym pliku CSV.",
      "edit_entries_bullet_3": "W sekcji {sending_ip_section} wprowadź następujące dane: {ip_1} {ip_2}",
      "edit_entries_heading": "Edytuj wpisy",
      "microsoft_defender_heading": "Microsoft Defender",
      "microsoft_defender_text": "Przejdź do ustawień Symulacji Phishingu od Dostawcy Zewnętrznego w Microsoft Defender, odwiedzając następujący URL: {url}",
      "save_the_domain_pair_heading": "Zapisz parę domen",
      "save_the_domain_pair_text": "Kliknij {save_button}, aby zapisać ustawienia symulacji phishingu firm trzecich."
    },
    "redirecting": "Przekazano",
    "results": {
      "button": "Przejdź do pulpitu nawigacyjnego",
      "text": "Witamy na pokładzie! Na podstawie Twoich odpowiedzi, przypisaliśmy poziomy treningowe, które najlepiej Ci odpowiadają. Możesz je w każdej chwili dostosować w ustawieniach.",
      "title": "Twoje podsumowanie"
    },
    "risk": {
      "approx_training_time_per_month": "Przybliżony czas szkolenia w miesiącu",
      "more_training_more_time": "Większe cele odpornościowe wykładniczo wydłużają czas szkolenia.",
      "targeted_resilience_score": "Wynik ukierunkowanej odporności",
      "text": "Za pomocą suwaka wskaż ogólną ekspozycję na ryzyko i tolerancję Twojej firmy. Wybierając poziom ryzyka, weź pod uwagę swoją branżę, charakter działalności oraz wrażliwość informacji, którymi się zajmujesz.",
      "title": "Ustaw poziom ryzyka organizacji"
    },
    "select_your_email_provider": "Wybierz swojego dostawcę poczty e-mail, aby uzyskać instrukcje dotyczące krok po kroku włączenia na białą listę.",
    "setting_up_workspace": "Konfigurowanie przestrzeni roboczej",
    "skip_button": "Pomiń dodawanie do listy dozwolonych",
    "skip_this_step": "Pomiń ten krok",
    "sync_started": "Rozpoczęto synchronizację",
    "toggle_gmail_api_integration": "Użyj integracji Gmail API",
    "try_integration_again": "Spróbuj ponownie",
    "use_powershell": "Użyj Powershell",
    "verifying_integration": "Weryfikacja integracji",
    "we_are_now_importing_employees": "Synchronizujemy pracowników z {provider}.",
    "welcome": {
      "graphic": {
        "text": "Możesz także pominąć ten krok na razie.",
        "title": "Wybierz swojego dostawcę tożsamości, aby rozpocząć"
      },
      "text": "Aby w pełni wykorzystać możliwości Moxso, zalecamy przejście przez ten proces wprowadzania.",
      "title": "Witamy w Moxso"
    }
  },
  "pagination": "Strona {page} z {lastPage}",
  "policies": {
    "approve_button": "Zatwierdź politykę",
    "approve_warning": "Sfinalizowanie tej polityki uniemożliwi jej przyszłą edycję. Czy chcesz kontynuować?",
    "approve_warning_title": "Zatwierdź politykę",
    "audit": {
      "cancel": {
        "audit_canceled": "Audyt anulowany",
        "button": "Anuluj audyt",
        "title": "Anuluj audyt",
        "warning": "Wszystkie oczekujące powiadomienia zostaną natychmiast wstrzymane, a przypisani użytkownicy stracą dostęp do tej polityki. Czy chcesz kontynuować?"
      },
      "details": {
        "all_completed_tooltip": "Wszyscy {count} pracownicy potwierdzili audyt",
        "completed_tooltip": "Żaden pracownik nie potwierdził audytu | {count} z {total} pracowników potwierdziło audyt | {count} z {total} pracowników potwierdziło audyt | {count} z {total} pracowników potwierdziło audyt",
        "created_at": "Utworzono w",
        "end_date": "Data zakończenia",
        "enrolling_participants_heading": "Rejestrowanie uczestników",
        "enrolling_participants_text": "Uczestnicy są zapisywani. Proszę czekać.",
        "group": "Grupa",
        "groups_heading": "Odbiorcy",
        "groups_text": "Szczegóły dotyczące odbiorców",
        "heading": "Audyt",
        "included_members_count_new_members_tooltip": "Nowi członkowie dodani do grupy po rozpoczęciu tego audytu nie są uwzględniani.",
        "included_members_count_tooltip": "Pracownicy, którzy już potwierdzili tę politykę, oraz nowi członkowie dodani do grupy po rozpoczęciu tego audytu są wykluczeni.",
        "members": "Członkowie",
        "no_participants_text": "Brak uczestników tej kontroli.",
        "no_participants_title": "Brak uczestników",
        "not_active_yet_text": "Rozpocznij audyt, aby zarejestrować uczestników.",
        "not_active_yet_title": "Audyt nieaktywny",
        "start_date": "Data rozpoczęcia",
        "status": "Status",
        "text": "Szczegóły audytu"
      },
      "filters": {
        "acknowledged": "Potwierdzone",
        "acknowledged_at": "Potwierdzono o",
        "acknowledged_default": "Wszyscy",
        "acknowledged_label": "Potwierdzenie",
        "not_acknowledged": "Oczekujące"
      },
      "launch": {
        "audit_started": "Rozpoczęto audyt",
        "button": "Rozpocznij audit",
        "input_label": "Liczba odbiorców",
        "title": "Rozpocznij audyt",
        "warning": "Zaraz rozpoczniesz audyt, który rozdystrybuuje politykę do członków następujących grup. Czy chcesz kontynuować?"
      },
      "single": {
        "settings": "Ustawienia",
        "title": "Audyt"
      }
    },
    "audit_draft": "Nieaktywna",
    "audit_running": "Audytowanie",
    "audits": {
      "create": {
        "buttons": {
          "back": "Wróć",
          "continue": "Kontynuuj",
          "submit": "Utwórz audyt"
        },
        "date_range": "Okres audytu",
        "date_range_placeholder": "Wybierz datę rozpoczęcia i zakończenia audytu",
        "error": "Wystąpił błąd podczas tworzenia audytu",
        "select_groups": "Wybierz grupy",
        "title": "Utwórz audyt"
      },
      "create_new_button": "Dodaj audyt",
      "created": "Pomyślnie utworzono audyt",
      "edit_button": "Edytuj",
      "empty": "Brak audytów dostępnych dla tej polityki",
      "help": {
        "include_previously_signed": "Pracownicy, którzy już potwierdzili tę politykę, zostaną uwzględnieni w audycie.",
        "notification_flow_enabled": "Włącz automatyczne powiadomienia dla pracowników, którzy jeszcze nie potwierdzili polityki.",
        "notification_prelude_enabled": "Wyślij powiadomienie do pracowników, gdy zostanie im przypisana nowa polityka."
      },
      "labels": {
        "include_previously_signed": "Uwzględnij pracowników, którzy już potwierdzili",
        "notification_flow_enabled": "Włącz przepływ powiadomień",
        "notification_frequency": "Częstotliwość powiadomień",
        "notification_prelude_enabled": "Włącz powiadomienie wstępne"
      },
      "policy_not_approved_yet": "Zatwierdź politykę, aby rozpocząć audyt.",
      "save_settings": "Zapisz ustawienia",
      "title": "Historia audytów",
      "updated": "Kontrola została zaktualizowana"
    },
    "create": {
      "create_button": "Utwórz politykę",
      "duplicate": "Zduplikowany",
      "duplicated": "Zasada zduplikowana!",
      "from_template": {
        "text": "Wybierz z biblioteki typowych zasad.",
        "title": "Utwórz politykę z szablonu"
      },
      "labels": {
        "locale": "Język",
        "title": "Tytuł"
      },
      "manual": {
        "text": "Utwórz polisę bez wypełniania czegokolwiek.",
        "title": "Utwórz politykę od podstaw"
      },
      "placeholders": {
        "locale": "Wybierz główny język polityki",
        "title": "Tytuł polityki"
      },
      "success": "Polisa utworzona!",
      "title": "Utwórz politykę"
    },
    "delete": {
      "are_you_sure": "Czy na pewno chcesz usunąć tę polisę? Tej operacji nie można cofnąć.",
      "button": "Usuń",
      "policy_deleted": "Polisa została usunięta."
    },
    "edit": {
      "subtitle": "Edytuj treść i szczegóły polityki",
      "title": "Edytuj politykę",
      "title_updated": "Tytuł pomyślnie zmieniony"
    },
    "editor": {
      "add_column_after": "Dodaj kolumnę po",
      "add_column_before": "Dodaj kolumnę przed",
      "add_row_after": "Dodaj wiersz poniżej",
      "add_row_before": "Dodaj wiersz powyżej",
      "delete_column": "Usuń kolumnę",
      "delete_image": "Usuń obraz",
      "delete_row": "Usuń wiersz",
      "delete_table": "Usuń tabelę",
      "insert_image": "Wstaw obraz",
      "insert_table": "Wstaw tabelę",
      "merge_cells": "Scal komórki",
      "split_cell": "Podziel komórkę",
      "table": "Tabela",
      "toggle_header_row": "Włącz/wyłącz wiersz nagłówka"
    },
    "list": {
      "create_new": "Utwórz politykę",
      "subtitle": "Przegląd wszystkich polityk",
      "title": "Polityki"
    },
    "policy_approved": "Polityka zatwierdzona.",
    "quiz": {
      "create_button": "Utwórz quiz",
      "done_translate_button": "Gotowe",
      "edit_button": "Edytuj quiz",
      "empty": "Brak quizów",
      "other_translations_have_quizzes": "Inne tłumaczenia mają quizy",
      "other_translations_have_quizzes_want_to_translate": "Inne tłumaczenia już mają quizy. Czy chcesz automatycznie przetłumaczyć ten quiz na te języki?",
      "processing_n_languages": "Przetwarzanie jednego języka | Przetwarzanie {count} języków",
      "quiz": "Quiz",
      "quiz_now_available_in": "Twój quiz jest teraz dostępny w jednym dodatkowym języku | Twój quiz jest teraz dostępny w {count} dodatkowych językach",
      "quiz_translate_success": "Sukces!",
      "quizzes_translated": "Przetłumaczone quizy.",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Wybierz języki, na które chcesz przetłumaczyć swój quiz",
      "some_translations_have_no_quizzes": "Niektóre tłumaczenia nie mają obecnie quizów. Przetłumaczyć teraz?",
      "subtitle": "Dostępne quizy",
      "this_translation_has_quizzes_in_other_languages_translate_automatically": "To tłumaczenie zawiera quizy w innych językach. Czy przetłumaczyć automatycznie?",
      "title": "Quizy",
      "translate_button": "Przetłumacz",
      "translate_from": "Przetłumacz z",
      "translate_multiple_choice_quiz": "Przetłumacz quiz wielokrotnego wyboru",
      "translate_quiz": "Przetłumacz",
      "translating_your_quiz": "Tłumaczenie Twojego quizu",
      "update_this_quiz_and_translate_others": "Zaktualizuj ten quiz i przetłumacz inne quizy",
      "update_this_quiz_only": "Zaktualizuj tylko ten quiz",
      "view_button": "Zobacz quiz"
    },
    "single": {
      "audits": "Audyty",
      "audits_subtitle": "Historia audytów",
      "details": {
        "heading": "Szczegóły",
        "text": "Szczegóły polisy"
      },
      "labels": {
        "acknowledgement_rate": "Wskaźnik potwierdzeń",
        "approval": "Status zatwierdzenia",
        "approved_at": "Zatwierdzono dnia {approved_at}",
        "approved_by": "Zatwierdzone przez {user}",
        "created_at": "Utworzono dnia",
        "edit": "Edytuj",
        "id": "ID",
        "latest_audit_status": "Najnowszy status audytu",
        "not_approved": "Nie zatwierdzony",
        "updated_at": "Zaktualizowano dnia"
      },
      "subtitle": "Dostępne tłumaczenia",
      "title": "Polisa"
    },
    "tables": {
      "approved_at": "Zatwierdzono dnia",
      "created_at": "Utworzono w",
      "has_active_audit": "Status audytu",
      "status_approved": "Zatwierdzona",
      "status_draft": "Szkic",
      "title": "Tytuł"
    },
    "translations": {
      "ai": {
        "done_translate_button": "Gotowe",
        "policy_now_available_in": "Twoja polisa jest teraz dostępna w jednym dodatkowym języku | Twoja polisa jest teraz dostępna w {count} dodatkowych językach",
        "policy_translate_success": "Sukces!",
        "processing_n_languages": "Przetwarzanie jednego języka | Przetwarzanie {count} języków",
        "text": "Użyj DeepL, aby automatycznie przetłumaczyć politykę na wybrany język.",
        "title": "Przetłumacz politykę za pomocą AI",
        "translate_button": "Przetłumacz",
        "translate_from": "Przetłumacz z",
        "translating_your_policy": "Tłumaczenie twojej polityki"
      },
      "create": "Przetłumacz",
      "create_deepl_new_button": "Przetłumacz z AI",
      "create_new_button": "Dodaj tłumaczenie",
      "create_success": "Tłumaczenie utworzone pomyślnie",
      "create_title": "Dodaj tłumaczenie",
      "created_at": "Utworzono",
      "default_badge": "Domyślna",
      "delete_are_you_sure": "Czy na pewno chcesz usunąć to tłumaczenie? Tej operacji nie można cofnąć.",
      "delete_button": "Usuń",
      "edit_button": "Edytuj",
      "edit_views": {
        "edit": "Edytuj",
        "preview": "Podgląd"
      },
      "empty": "Brak tłumaczeń dla tej polityki",
      "empty_sections_overview": {
        "subtitle": "Dodaj Nagłówek 1, aby utworzyć nową sekcję",
        "title": "Nie dodano sekcji"
      },
      "language": "Język",
      "last_updated": "Ostatnia aktualizacja",
      "locked": "Edycja zablokowana, ponieważ polityka została zatwierdzona.",
      "make_default": "Ustaw jako domyślny",
      "manual": {
        "first_translation_text": "Rozpocznij od utworzenia tłumaczenia od podstaw.",
        "first_translation_title": "Utwórz tłumaczenie polityki",
        "text": "Przepisz tłumaczenie od podstaw w nowym języku.",
        "title": "Ręcznie przetłumacz politykę"
      },
      "save": "Zapisz zmiany",
      "save_success": "Tłumaczenie zostało pomyślnie zapisane",
      "save_success_title": "Tytuł pomyślnie zmieniony",
      "select_locale": "Język docelowy",
      "select_locale_placeholder": "Wybierz język dla swojego tłumaczenia",
      "subtitle": "Zarządzaj tłumaczeniami dla tej polityki",
      "title": "Tłumaczenia",
      "title_label": "Tytuł tłumaczenia",
      "title_placeholder": "Wprowadź tytuł tłumaczenia",
      "translation_deleted": "Tłumaczenie usunięte.",
      "view_button": "Zobacz"
    }
  },
  "quiz_builder": {
    "ai_prompt": {
      "button": "AI prompt",
      "generate": "Generuj",
      "no_previous_steps": "Dodaj krok wideo lub tekstowy wcześniej w kursie, aby wykorzystać go jako kontekst.",
      "placeholder": "Opisz quiz, który chcesz wygenerować przy pomocy AI...",
      "select_helper": "Wybierz wcześniejsze kroki, aby dać AI więcej kontekstu.",
      "select_label": "Uwzględnij wcześniejsze treści",
      "step_number": "Krok {order}",
      "step_type": {
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Wideo"
      },
      "title": "Wygeneruj quiz za pomocą AI",
      "untitled": "Bez tytułu"
    },
    "buttons": {
      "add_ai_question": "Dodaj pytanie AI",
      "add_option": "Dodaj opcję",
      "add_question": "Dodaj pytanie",
      "close": "Zamknij",
      "edit": "Edytuj",
      "save_quiz": "Zapisz quiz"
    },
    "delete_question_confirmation": {
      "are_you_sure": "Czy na pewno chcesz usunąć to pytanie?",
      "button": "Usuń pytanie"
    },
    "empty": {
      "ai_create_button": "Użyj Moxso Intelligence",
      "ai_description": "Rozpocznij, dodając pierwsze pytanie lub używając Moxso AI do wygenerowania quizu.",
      "create_button": "Utwórz quiz",
      "description": "Zacznij od dodania pierwszego pytania.",
      "manually_create_button": "Ręcznie utwórz quiz",
      "title": "Brak pytań"
    },
    "labels": {
      "answer_options": "Opcje odpowiedzi",
      "question": "Pytanie"
    },
    "placeholders": {
      "answer_option": "Wprowadź opcję",
      "question": "Wpisz pytanie"
    },
    "quiz_saved": "Quiz zapisany",
    "quizzes_translated": "Przetłumaczone quizy.",
    "titles": {
      "question": "Pytanie {number}"
    }
  },
  "report": {
    "click_rate": "Wskaźnik kliknięć",
    "from_value": "z {value}",
    "last_12_months": "Ostatnie 12 miesięcy",
    "last_six_months": "Ostatnie sześć miesięcy",
    "no_data": "Brak danych",
    "polarity": "Polaryzacja",
    "report_rate": "Wskaźnik zgłoszeń",
    "resilience": "Odporność",
    "simulations": "Symulacje",
    "training": "Szkolenie",
    "vs_previous_period": "względem poprzedniego okresu"
  },
  "reset_password": {
    "heading": "Zresetuj hasło",
    "success_message": "Hasło zapisane pomyślnie",
    "text": "Proszę wybrać nowe hasło."
  },
  "seo_titles": {
    "automation": {
      "action": "Uczestnicy automatyzacji",
      "edit": "Edytuj automatyzację",
      "index": "Automatyzacje",
      "single": "Sekwencja"
    },
    "breach": {
      "index": "Naruszenia",
      "single": "Naruszenie"
    },
    "campaign": {
      "index": "Symulacje",
      "single": "Symulacja",
      "templates": "Niestandardowe szablony"
    },
    "dashboard": {
      "breaches": "Pulpit nawigacyjny – Naruszenia",
      "human_risk_intelligence": "Pulpit - Inteligencja ryzyka ludzkiego",
      "overview": "Panel sterowania",
      "resilience": "Pulpit – Odporność",
      "simulations": "Pulpit nawigacyjny – Symulacje",
      "threats": "Pulpit nawigacyjny – Zagrożenia",
      "training": "Dashboard – Szkolenie"
    },
    "employee": {
      "index": "Pracownicy",
      "single": "Pracownik"
    },
    "forgot_password": "Zresetuj hasło",
    "group": {
      "index": "Grupy",
      "single": "Grupa"
    },
    "impersonate": "Podszywanie się",
    "integration": "Integracja",
    "invite": {
      "id": "Zaakceptuj zaproszenie",
      "index": "Zaakceptuj zaproszenie"
    },
    "login": "Zaloguj się",
    "policies": {
      "audit": "Audyt",
      "index": "Zasady",
      "single": "Edycja polityki tłumaczenia",
      "translations": "Tłumaczenia polityki"
    },
    "reset_password": "Zresetuj hasło",
    "settings": {
      "breaches": "Ustawienia – Naruszenia",
      "domains": "Ustawienia – Domeny",
      "e_learning": "Ustawienia – Szkolenia",
      "export": "Ustawienia – Eksportuj dane do CSV",
      "import": "Ustawienia – Importuj z CSV",
      "index": "Ustawienia – Obszar roboczy",
      "integrations": {
        "index": "Ustawienia – Integracje",
        "single": "Ustawienia – Edytuj integrację"
      },
      "risk": "Ustawienia – Ryzyko",
      "simulations": "Ustawienia – Symulacje",
      "threats": "Ustawienia – Zagrożenia"
    },
    "threat": {
      "index": "Zagrożenia",
      "single": "Zagrożenie"
    },
    "training": {
      "deadlines": "Terminy",
      "index": "Szkolenia",
      "participation": "Uczestnictwo"
    },
    "two_factor": "Uwierzytelnianie dwuskładnikowe",
    "user_settings": "Ustawienia użytkownika",
    "validate_domain": "Sprawdź domenę"
  },
  "settings": {
    "breaches": {
      "enable_breaches": {
        "help": "Włącz naruszenia dla tej przestrzeni roboczej.",
        "title": "Włącz naruszenia"
      },
      "enable_notifications": {
        "help": "Powiadamiaj pracowników bezpośrednio, gdy są zaangażowani w nowe naruszenia.",
        "title": "Włącz powiadomienia"
      },
      "subtitle": "Skonfiguruj ustawienia związane z naruszeniami.",
      "title": "Naruszenia"
    },
    "buttons": {
      "add_domain": "Dodaj domenę",
      "add_report": "Dodaj raport",
      "add_user": "Dodaj użytkownika",
      "resend_invitation": "Wyślij ponownie e-mail",
      "revoke_access": "Cofnij dostęp",
      "save_settings": "Zapisz ustawienia",
      "verify_domain": "Zweryfikuj"
    },
    "data": {
      "subtitle": "Po włączeniu tych funkcji, dane będą anonimizowane po upływie 90 dni od ostatniej istotnej akcji.",
      "title": "Anonimizacja danych"
    },
    "domains": {
      "domain_added": "Domena utworzona",
      "domain_required": "Proszę wprowadzić domenę",
      "subtitle": "Zarządzaj nazwami domen, które są własnością twojej przestrzeni roboczej.",
      "title": "Zweryfikowane domeny",
      "verification_email_sent": "E-mail weryfikacyjny wysłany",
      "verification_required": "Oczekuje na weryfikację",
      "verified": "Zweryfikowany",
      "verified_on": "Zweryfikowano dnia:",
      "verify_new_domain": "Zweryfikuj nową domenę"
    },
    "e_learning": {
      "alert": {
        "not_allowed": "Niedozwolone",
        "optional_courses": "Opcjonalne kursy",
        "optional_courses_description": "Kursy poza obowiązkowym szkoleniem",
        "optional_quiz_questions": "Pytania quizowe",
        "optional_quiz_questions_description": "Opcjonalne pytania quizu phishingowego",
        "optional_videos": "Opcjonalne wideo",
        "optional_videos_description": "Wideo poza obowiązkowym szkoleniem",
        "quiz_limit_value": "15 tygodniowo",
        "title": "Ograniczenia stosowane po włączeniu",
        "video_limit_value": "2 tygodniowo"
      },
      "modes": {
        "automatic": {
          "description": "Moxso automatycznie prowadzi cały program szkoleniowy.",
          "recommended": "Zalecane",
          "title": "Szkolenia automatyczne"
        },
        "confirmation": {
          "automatic": {
            "description": "Moxso zacznie automatycznie przydzielać szkolenia.",
            "title": "Przełączyć na szkolenia automatyczne?"
          },
          "manual": {
            "description": "Moxso przestanie przydzielać szkolenia. Istniejące przydziały zostaną zachowane.",
            "title": "Przełączyć na zaplanowane szkolenia?"
          },
          "switch": "Przełącz"
        },
        "help": "Wybierz, jak szkolenia są przydzielane w Twojej organizacji.",
        "label": "Tryb szkolenia",
        "manual": {
          "description": "Administratorzy sami planują i przydzielają szkolenia.",
          "title": "Zaplanowane szkolenia"
        },
        "will_be_hidden": "Zostaną ukryte po przełączeniu"
      },
      "subtitle": "Skonfiguruj ustawienia szkoleń.",
      "title": "Szkolenia"
    },
    "exports": {
      "custom": "Niestandardowy",
      "default": "Domyślny",
      "download_export": "Pobierz eksport",
      "export_type": {
        "automation": "Raport automatyzacji",
        "employee": "Raport pracownika",
        "text": "Wybierz typ eksportu, który chcesz wygenerować.",
        "title": "Typ eksportu",
        "training": "Raport szkoleniowy"
      },
      "form": {
        "deselect_all": "Odznacz wszystkie pola",
        "select_all": "Zaznacz wszystkie pola"
      },
      "reports": {
        "delete_button": "Usuń",
        "deleted_success": "Raport usunięty",
        "download_button": "Pobierz",
        "edit_button": "Edytuj",
        "search": "Szukaj",
        "subtitle": "Skonfiguruj zaplanowane raporty dla twojej przestrzeni roboczej {workspace}.",
        "title": "Zaplanowane raporty"
      },
      "selected_columns": "Pola({count}): {columns}",
      "subtitle": "Wybierz dane, które chcesz eksportować.",
      "title": "Pobierz eksport"
    },
    "forms": {
      "company": {
        "label": "Firma",
        "placeholder": "Firma"
      },
      "custom_deeplink_url": {
        "description": "Użyj ::content_id:: jako wymaganego symbolu zastępczego dla identyfikatora treści.",
        "label": "Niestandardowy URL treści",
        "placeholder": "https://example.com/launch/something-::content_id::"
      },
      "custom_lms_url": {
        "label": "Niestandardowy URL LMS",
        "placeholder": "https://example.com/launch/"
      },
      "data_enrichment": {
        "subtitle": "Przypisuj role pracownikom na podstawie ich danych.",
        "title": "Wzbogacanie danych pracowników",
        "tooltip": "Wzbogacanie danych pracowników wykorzystuje AI do przypisywania ról pracownikom na podstawie ich działu i grup."
      },
      "enhanced_scoring": {
        "subtitle": "Ważenie resilience scores w oparciu o role pracowników",
        "title": "Ulepszona punktacja",
        "tooltip": "Ulepszona punktacja stosuje różne wagi w zależności od tego, jak krytyczna dla bezpieczeństwa jest dana rola, co oznacza, że osoby z większym dostępem lub odpowiedzialnością muszą zrobić więcej, aby osiągnąć ten sam resilience score."
      },
      "gdpr": {
        "employees": {
          "help": "Automatycznie anonimizuj nieaktywnych pracowników.",
          "title": "Anonimizuj nieaktywnych pracowników"
        },
        "threats": {
          "help": "Automatycznie anonimizuj dane o zagrożeniach.",
          "title": "Anonimizuj obsługiwane zagrożenia"
        }
      },
      "hotline": {
        "description": "Będzie to główny kontakt dla Twojego zespołu w przypadku potencjalnych zagrożeń lub zapytań ze strony pracowników.",
        "label": "Wsparcie",
        "placeholder": "it{'@'}company.com"
      },
      "industry": {
        "label": "Branża"
      },
      "labels": {
        "active_status": "Status",
        "automation": "Automatyzacja",
        "custom_fields": "Pola",
        "date_range": "Wybierz daty",
        "domain": "Domena",
        "email": "E-mail",
        "first_name": "Imię",
        "group": "Grupa",
        "last_name": "Nazwisko",
        "report_frequency": "Częstotliwość",
        "report_period": "Okres",
        "report_recipient": "Odbiorca",
        "report_status": "Status",
        "report_type": "Typ raportu",
        "role": "Rola",
        "training_type": "Typ"
      },
      "leaderboard": {
        "enabled": {
          "subtitle": "Pokaż tablicę wyników w hubie i wybierz, według czego pracownicy są klasyfikowani.",
          "title": "Tablica wyników"
        },
        "options": {
          "point_leaderboard": "Tablica punktów",
          "score_leaderboard": "Ranking wyniku odporności"
        },
        "setting": {
          "label": "Typ tablicy wyników"
        }
      },
      "placeholders": {
        "date_range": "Wybierz daty",
        "domain": "company.com",
        "email": "imię{'@'}firma.com",
        "first_name": "Imię",
        "last_name": "Nazwisko",
        "report_recipient": "Wyszukaj pracownika",
        "search_employee": "Szukaj pracownika"
      },
      "reports": {
        "add_scheduled_report": "Dodaj zaplanowany raport",
        "choose_report_type": "Wybierz inny typ raportu",
        "description": "Skonfiguruj zaplanowane raporty, aby były wysyłane automatycznie.",
        "edit_scheduled_report": "Edytuj zaplanowany raport",
        "hierarchy_level": {
          "description": "Po włączeniu raport obejmuje także pracowników niżej w hierarchii, a nie tylko bezpośrednich podwładnych.",
          "label": "Uwzględnij członków zespołu niższych szczebli"
        },
        "manager_report": {
          "text": "Raport dla menedżerów o ich pracownikach.",
          "title": "Raport menedżera"
        },
        "workspace_report": {
          "text": "Raport dla całej przestrzeni roboczej.",
          "title": "Raport przestrzeni roboczej"
        }
      },
      "scim": {
        "add_title": "Utwórz token SCIM",
        "connection_add_title": "Utwórz połączenie SCIM",
        "connection_created": "Utworzono połączenie SCIM.",
        "connection_deleted": "Usunięto połączenie SCIM.",
        "connection_name_label": "Nazwa połączenia",
        "connection_name_placeholder": "Microsoft Entra ID",
        "connection_saved": "Zapisano połączenie SCIM.",
        "connection_token_name_placeholder": "Provisioning {name}",
        "create_connection_button": "Utwórz połączenie",
        "create_token_button": "Utwórz token",
        "create_token_header": "Utwórz token",
        "created_title": "Utworzono token SCIM",
        "default_mapping_marker": "Domyślne",
        "delete_connection_body": "Spowoduje to usunięcie połączenia i unieważnienie wszystkich powiązanych z nim tokenów SCIM. Provisioning od tego dostawcy zostanie natychmiast zatrzymany.",
        "delete_connection_button": "Usuń połączenie",
        "delete_connection_title": "Usunąć połączenie SCIM?",
        "done": "Gotowe",
        "edit_connection_button": "Edytuj połączenie",
        "enabled_label": "Włączone",
        "name_help": "Nadaj tokenowi opisową nazwę, aby łatwo rozpoznać go później.",
        "name_label": "Nazwa tokenu",
        "name_placeholder": "Provisioning Microsoft Entra",
        "note_cannot_view": "Ten token jest wyświetlany tylko raz. Zapisz go u dostawcy tożsamości przed zamknięciem tego okna.",
        "provider_label": "Dostawca",
        "reset_mapping_button": "Przywróć domyślne",
        "revoke_body": "Żądania provisioningu używające tego tokenu zostaną natychmiast zatrzymane. Istniejący pracownicy i grupy nie zostaną usunięci.",
        "revoke_button": "Unieważnij token",
        "revoke_title": "Unieważnij token SCIM",
        "save_connection_button": "Zapisz połączenie",
        "save_mapping_button": "Zapisz mapowanie",
        "secret_token_label": "Tajny token",
        "show_mapping_details": "Szczegóły mapowania",
        "success_token_added": "Dodano token SCIM.",
        "success_token_revoked": "Unieważniono token SCIM.",
        "sync_type_employee": "Pracownik",
        "sync_type_employee_description": "Provisioning pracowników i grup pracowników od tego dostawcy tożsamości.",
        "sync_type_label": "Typ provisioningu",
        "sync_type_user": "Użytkownik admin",
        "sync_type_user_description": "Provisioning użytkowników admin, którzy mogą uzyskać dostęp do panelu administracyjnego."
      },
      "select_automation": "Wybierz automatyzację",
      "select_group": "Wybierz grupę",
      "settings_saved": "Ustawienia zapisane",
      "success": {
        "invitation_resent": "Potwierdzenie e-mail zostało wysłane ponownie",
        "report_added": "Raport został pomyślnie dodany",
        "report_edited": "Raport zapisany",
        "user_added": "Użytkownik dodany"
      },
      "timezone": {
        "label": "Strefa czasowa",
        "placeholder": "Wybierz strefę czasową"
      },
      "tokens": {
        "add_title": "Utwórz token",
        "are_you_sure_you_want_to_delete": "Czy na pewno chcesz usunąć ten token? Tego działania nie można cofnąć.",
        "close": "Zamknij",
        "create_token_button": "Utwórz token",
        "documentation": "Dokumentacja",
        "name_help": "Nadaj swojemu tokenowi opisową nazwę, aby ułatwić jego późniejszą identyfikację.",
        "name_label": "Imię",
        "name_placeholder": "Nazwa tokenu",
        "note_cannot_view": "Ten token zostanie wyświetlony tylko raz. Zapisz go w bezpiecznym miejscu.",
        "success_token_added": "Token dodany.",
        "success_token_deleted": "Token został usunięty.",
        "token_created": "Token utworzony"
      },
      "training_restrictions": {
        "enabled": {
          "subtitle": "Ogranicz, ile nieprzypisanego szkolenia pracownicy mogą ukończyć samodzielnie.",
          "title": "Ograniczenia szkoleniowe",
          "tooltip": "Włącz domyślne ograniczenia dla opcjonalnych szkoleń w hubie."
        },
        "unassigned_quiz_limit": {
          "help": "Maksymalna liczba nieprzypisanych quizów, które pracownik może ukończyć.",
          "label": "Limit quizów"
        },
        "unassigned_video_limit": {
          "help": "Maksymalna liczba nieprzypisanych filmów, które pracownik może ukończyć.",
          "label": "Limit filmów"
        }
      },
      "training_type": {
        "course": "Kurs",
        "video": "Wideo"
      },
      "users": {
        "add_employee": "Dodaj użytkownika"
      }
    },
    "imports": {
      "back": "Powrót",
      "button": "{kliknij} lub przeciągnij i upuść",
      "click_to_upload": "Kliknij, aby przesłać",
      "completed": "Ukończono",
      "done": "Zrobione",
      "failed": "Niepowodzenie",
      "file_requirements": "Plik musi zawierać następujące kolumny: <b>first_name</b>, <b>last_name</b>, <b>email</b> oraz <b>locale</b> (np. da_DK, en_US, de_DE).<br/>Opcjonalnie plik może zawierać <b>timezone</b> (np. Europe/Copenhagen), <b>phone_number</b> oraz <b>phone_country_code</b>.<br/><b>Pliki CSV muszą używać przecinków jako separatorów.</b><br/>Akceptowane formaty: .csv lub .txt (Plik powinien być zapisany w formacie UTF-8, aby zapewnić poprawne kodowanie znaków)",
      "formats": "CSV lub TXT do 10MB",
      "import_type": {
        "employees": "{count} pracownik | {count} pracowników",
        "groups": "{count} grupa | {count} grupy"
      },
      "pending": "Synchronizowanie",
      "upload_another": "Prześlij inny plik"
    },
    "integrations": {
      "account": {
        "subtitle": "Synchronizuj konta użytkowników z Moxso.",
        "title": "Użytkownicy i komunikacja"
      },
      "add_our_domains_and_setup_guides": "Dodaj nasze domeny i postępuj zgodnie z przewodnikami Gmail/Outlook.",
      "addin_setup_guide": "Przewodnik konfiguracji",
      "coming_soon": "Już wkrótce",
      "compliance": {
        "subtitle": "Synchronizuj z narzędziami zgodności.",
        "title": "Narzędzia zgodności"
      },
      "connected": {
        "subtitle": "Obecnie połączone integracje.",
        "title": "Aktywne integracje"
      },
      "delete": {
        "button": "Usuń integrację",
        "confirmation": "Czy na pewno chcesz usunąć tę integrację? Tej czynności nie można cofnąć.",
        "description": "Usunięcie tej integracji zatrzyma przyszłą synchronizację. Tej czynności nie można cofnąć.",
        "subtitle": "Usuń tę integrację z obszaru roboczego.",
        "success": "Integracja usunięta",
        "title": "Usuń integrację"
      },
      "edit": {
        "auth_settings": {
          "subtitle": "Zaktualizuj ustawienia uwierzytelniania",
          "title": "Ustawienia uwierzytelniania"
        },
        "filtering": {
          "text": "Filtrowanie e-maili automatycznie usuwa udostępnione adresy e-mail z Twojej integracji, takie jak: admin{'@'}domain.com, contact{'@'}domain.com itp.",
          "title": "Filtrowanie wiadomości e-mail ogólne i oparte na rolach"
        },
        "groups": {
          "text": "Wybierz, czy synchronizować grupy za każdym razem, gdy integracja jest aktualizowana.",
          "title": "Grupy"
        },
        "managers": {
          "text": "Wybierz, czy synchronizować menedżerów za każdym razem, gdy twoja integracja jest aktualizowana.",
          "title": "Menedżerowie"
        },
        "offboarding": {
          "text": "Wybierz, czy automatycznie dezaktywować pracowników, którzy zostali usunięci z twojej integracji.",
          "title": "Offboarding"
        },
        "settings": {
          "enable_notifications": {
            "title": "Włącz powiadomienia o szkoleniach"
          },
          "enable_sync": "Włącz synchronizację",
          "select_sync_frequency": "Wybierz, jak często ma być synchronizowana Twoja integracja.",
          "subtitle": "Zaktualizuj konfigurację integracji",
          "sync_frequency": "Częstotliwość synchronizacji",
          "title": "Edytuj integrację"
        },
        "sync_phone_numbers": {
          "text": "Wybierz, czy numery telefonów mają być importowane podczas synchronizacji z tą integracją.",
          "title": "Importuj numery telefonów"
        },
        "title": "Ostatnie synchronizacje"
      },
      "enabled": "Włączona",
      "first_sync": "Pierwsza synchronizacja",
      "form": {
        "access_token": {
          "help": "Klucz API służy do uwierzytelniania integracji.",
          "label": "Klucz API"
        },
        "api_route": {
          "label": "Trasa API",
          "placeholder": "Wprowadź trasę API"
        },
        "password": {
          "help": "Hasło jest używane do uwierzytelniania integracji.",
          "label": "Hasło",
          "placeholder": "Wprowadź hasło"
        },
        "region": {
          "help": "Wybierz, z którego regionu danych korzystasz dla tego dostawcy.",
          "label": "Region danych",
          "options": {
            "eu": "UE",
            "global": "Globalny"
          }
        },
        "username": {
          "help": "Nazwa użytkownika służy do uwierzytelniania integracji.",
          "label": "Nazwa użytkownika",
          "placeholder": "Wprowadź nazwę użytkownika"
        }
      },
      "frequency": {
        "daily": {
          "description": "Twoje dane będą synchronizowane codziennie.",
          "title": "Codziennie"
        },
        "monthly": {
          "description": "Twoje dane będą synchronizowane co miesiąc, pierwszego dnia.",
          "title": "Miesięcznie"
        },
        "realtime": {
          "description": "Twoje dane będą synchronizowane co minutę.",
          "title": "Czas rzeczywisty"
        },
        "weekly": {
          "description": "Twoje dane będą synchronizowane co tydzień w poniedziałek.",
          "title": "Cotygodniowo"
        }
      },
      "gmail_addin": {
        "apps_marketplace_apps": "Aplikacje → Aplikacje z Google Workspace Marketplace",
        "click_install_review_deploy": "Kliknij {install}, przejrzyj żądane uprawnienia i wybierz {deploy_to_organisation} (lub grupę testową), aby udostępnić dodatek użytkownikom.",
        "deploy_to_organisation": "Wdrażaj do swojej organizacji",
        "find_moxso_add_in": "Znajdź dodatek „Moxso Report”",
        "in_admin_console_navigate_to": "W konsoli administracyjnej Google Workspace przejdź do {marketplace_apps}.",
        "install": "Zainstaluj",
        "install_and_deploy": "Zainstaluj i wdroż dodatek",
        "moxso_report": "Raport Moxso",
        "open_workspace_marketplace": "Otwórz Google Workspace Marketplace",
        "report_threats_directly_from_gmail": "Zgłoś zagrożenia bezpośrednio do Moxso z Gmail.",
        "search_to_locate": "Użyj paska wyszukiwania, aby zlokalizować {moxso_report} i otworzyć jego stronę szczegółów.",
        "title": "Skonfiguruj dodatek do Gmaila"
      },
      "gmail_whitelisting_guide": "Przewodnik po dodawaniu do listy dozwolonych w Gmailu",
      "hri": {
        "connected": "Połączono",
        "directory_description": "Połącz Microsoft Entra lub Google Workspace, aby dopasować identyfikatory pracowników i odblokować inne integracje HRI. To połączenie HRI jest niezależne od standardowej integracji.",
        "directory_title": "Najpierw połącz katalog pracowników",
        "enable": "Włącz",
        "explore_description": "Możesz zapoznać się z poniższymi integracjami. Konfiguracja wymaga aktywnego połączenia HRI z Microsoft Entra lub Google Workspace.",
        "explore_title": "Poznaj integracje",
        "recommended": "Zalecane",
        "recommended_tooltip": "Już korzystasz z tego katalogu",
        "setup_locked": "Konfiguracja zablokowana",
        "setup_prerequisite": "Najpierw skonfiguruj połączenie HRI z Microsoft Entra lub Google Workspace."
      },
      "integration_stored": "Integracja zapisana",
      "last_sync": "Ostatnia synchronizacja",
      "last_update": "Ostatnia aktualizacja: {time}",
      "lms": {
        "subtitle": "Synchronizuj z systemami zarządzania nauką.",
        "title": "Systemy zarządzania nauką"
      },
      "never": "Nigdy",
      "not_connected": "Niezłączono",
      "notifications": {
        "subtitle": "Wysyłaj powiadomienia przez narzędzia do współpracy.",
        "title": "Powiadomienia"
      },
      "open_guide": "Otwórz przewodnik",
      "outlook_addin": {
        "accept_permissions": "Zaakceptuj uprawnienia",
        "add_ins": "Dodatki",
        "app_type": "Typ aplikacji",
        "assign_access": "Przydziel dostęp",
        "assign_users": "Przypisz użytkowników",
        "choose_who_get_add_in": "Pod {assign_users} wybierz, kto powinien otrzymać dodatek. Zalecamy wybranie {specific_users} i wybranie odpowiednich grup.",
        "chose_manifest_url": "Wybierz {provide_link} i wklej adres URL manifestu:",
        "click": "Kliknij {next}.",
        "click_next_then_finish": "Kliknij {next}, a następnie {finish}.",
        "click_you_should_see_message": "Kliknij {validate}. Powinieneś zobaczyć wiadomość \"{file_validated}\".",
        "complete": "Zakończ",
        "confirm_slot_is_selected": "Na liście {app_type} potwierdź, że {add_in} jest wybrany.",
        "done": "Gotowe",
        "examine_permissions": "Przejrzyj żądane uprawnienia. Jeśli wszystko wygląda poprawnie, wybierz {accept_permissions} i potwierdź komunikaty.",
        "finalize_deployment": "Zakończ wdrażanie",
        "finish_deployment": "Zakończ wdrażanie",
        "integrated_apps": "Zintegrowane aplikacje",
        "manifest_file_validated": "Plik manifestu został zweryfikowany",
        "navigate_to_admin_center": "Przejdź do centrum administracyjnego Microsoft 365 > Ustawienia > {link}",
        "next": "Dalej",
        "office_add-in": "Dodatek Office",
        "open_integrated_apps": "Otwórz zintegrowane aplikacje",
        "proceed_to_assignment": "Przejdź do przypisania",
        "process_indicator_then_complete": "Zobaczysz wskaźnik postępu; ten krok rzadko przekracza jedną minutę. Następnie naciśnij {done}, aby zakończyć konfigurację.",
        "provide_link_to_manifest_file": "Podaj link do pliku manifestu",
        "provide_manifest": "Udostępnij manifest",
        "report_threats_directly_from_outlook": "Zgłaszaj zagrożenia do Moxso bezpośrednio z Outlooka.",
        "restart_outlook": "Aby upewnić się, że dodatek zostanie zainicjowany, uruchom ponownie Outlook, a następnie prześlij testowy raport e-mail. Zwróć uwagę, że dodatek może się pojawić do 24 godzin po wdrożeniu.",
        "review_permissions": "Przejrzyj uprawnienia",
        "select_upload_custom_apps": "Wybierz {bold}.",
        "specific_users_groups": "Określeni użytkownicy/grupy",
        "specify_app_type": "Określ typ aplikacji",
        "start_the_upload": "Rozpocznij proces przesyłania",
        "title": "Skonfiguruj dodatek do Outlooka",
        "upload_custom_apps": "Prześlij własne aplikacje",
        "use_powershell": "Użyj Powershella",
        "validate": "Sprawdź",
        "validate_manifest": "Zatwierdź manifest",
        "verify_add_in": "Zweryfikuj dodatek w Outlooku"
      },
      "outlook_whitelisting_guide": "Przewodnik dotyczący dodawania do listy dozwolonych w Outlooku",
      "overview": {
        "active": "Aktywne",
        "active_subtitle": "Obecnie połączone integracje.",
        "active_title": "Aktywne integracje",
        "all": "Wszystkie",
        "all_subtitle": "Połącz usługi, aby gromadzić dane o aktywności pracowników w Human Risk Intelligence.",
        "all_title": "Wszystkie integracje",
        "attention": "Wymagają uwagi",
        "attention_subtitle": "Integracje wymagające uwagi przed rozpoczęciem synchronizacji.",
        "attention_title": "Wymagają uwagi",
        "empty": "Nie znaleziono integracji.",
        "hri": "Human risk intelligence",
        "search": "Szukaj integracji...",
        "sections": {
          "compliance": "Zgodność",
          "lms": "LMS",
          "notifications": "Powiadomienia",
          "signals": "Sygnały",
          "user_sync": "Synchronizacja użytkowników"
        }
      },
      "refresh": "Odśwież dane",
      "refresh_data": "Odśwież dane",
      "report_threats_directly_from_inbox": "Zgłaszaj zagrożenia bezpośrednio z poziomu skrzynki odbiorczej.",
      "settings_saved": "Ustawienia zapisane",
      "setup": "Połącz",
      "setup_integration": "Skonfiguruj integrację",
      "setup_text": "Używamy jednokrotnego logowania (SSO) do bezpiecznego połączenia z {provider}. Zostaniesz przekierowany na stronę logowania dostawcy w celu uwierzytelnienia. Pamiętaj, że do skonfigurowania integracji wymagane jest konto administratora.",
      "simulation_deliverability": "Dostarczalność symulacji",
      "single": {
        "provider_title": "Edytuj {provider}",
        "subtitle": "Zaktualizuj konfigurację integracji",
        "title": "Edytuj integrację"
      },
      "status": "Status integracji",
      "step_by_step": "Przewodnik krok po kroku, jak przepuszczać e-maile.",
      "sync_already_enabled_tooltip": "Synchronizacja pracowników jest już włączona w innej integracji. Wyłącz ją, aby skorzystać z tej opcji.",
      "sync_started": "Synchronizacja dodana do kolejki",
      "tags": {
        "all": "Wszystkie tagi",
        "compliance": {
          "description": "Udostępniaj dane dotyczące świadomości bezpieczeństwa na swojej platformie zarządzania zgodnością.",
          "headline": "Zgodność"
        },
        "filter": "Filtruj według tagu",
        "learning_management": {
          "description": "Połącz szkolenia z zakresu świadomości bezpieczeństwa ze swoim systemem zarządzania nauczaniem.",
          "headline": "Zarządzanie nauczaniem"
        },
        "notifications": {
          "description": "Wysyłaj powiadomienia Moxso za pośrednictwem swojej platformy komunikacyjnej.",
          "headline": "Powiadomienia"
        },
        "user_sync": {
          "description": "Synchronizuj użytkowników z katalogu lub obszaru roboczego z Moxso.",
          "headline": "Synchronizacja użytkowników"
        }
      },
      "teams_guide": {
        "description": "Postępuj zgodnie z przewodnikiem konfiguracji w naszym {help_center}, aby dowiedzieć się, jak dodać Moxso do Microsoft Teams.",
        "download_zip": "Pobierz plik ZIP",
        "help_center": "centrum pomocy"
      },
      "title": "Integracje",
      "token_error": "Nie udało nam się nawiązać połączenia z {provider}. Nasza ostatnia próba miała miejsce: {date}. Proszę ponownie potwierdzić dane uwierzytelniające Twojego konta.",
      "whitelisting_guide": "Przewodnik po dodawaniu do listy dozwolonych"
    },
    "magic_links": {
      "description": "Zezwalaj pracownikom na automatyczne logowanie przez linki do Hub w powiadomieniach. Po wyłączeniu tej opcji linki otwierają stronę logowania do Hub i zachowują pierwotne miejsce docelowe.",
      "label": "Włącz magiczne linki",
      "title": "Magiczne linki do Hub"
    },
    "risk": {
      "organisation_risk_subtitle": "Ogólny poziom ryzyka dla {organisation}",
      "organisation_risk_text": "Im wyższy poziom ryzyka, tym więcej szkoleń otrzymają pracownicy. Zachowaj równowagę między potrzebami szkoleniowymi a obciążeniem pracowników.",
      "organisation_risk_title": "Ryzyko organizacji",
      "subtitle": "Dostosuj poziom szkolenia dla każdej kategorii.",
      "title": "Poziomy szkolenia"
    },
    "saml": {
      "acs_url": "ACS URL",
      "add_provider": "Dodaj providera",
      "attribute_mapping": {
        "description": "Mapuj atrybuty asercji SAML na pola profilu administratora wymagane przez Moxso.",
        "title": "Mapowanie atrybutów asercji"
      },
      "cancel_edit": "Anuluj edycję",
      "create": {
        "manual": {
          "description": "Skonfiguruj providera ręcznie",
          "title": "Utwórz ręcznie"
        },
        "metadata": {
          "description": "Importuj ustawienia IdP z providera",
          "title": "Utwórz z adresu URL metadanych"
        }
      },
      "delete": {
        "cancel": "Anuluj",
        "confirm": "Usuń połączenie",
        "description": "Użytkownicy nie będą już mogli logować się przez tego dostawcę tożsamości. Istniejące powiązane tożsamości SAML dla tego dostawcy również zostaną usunięte.",
        "title": "Usuń połączenie SAML"
      },
      "deleted": "Połączenie SAML usunięte",
      "disabled": "Wyłączony",
      "edit_provider": "Edytuj providera",
      "empty": {
        "description": "Dodaj providera SAML, aby zaproszeni administratorzy mogli uruchomić SSO ze strony logowania.",
        "title": "Brak providerów SAML"
      },
      "enabled": "Włączony",
      "entity_id": "Entity ID",
      "entity_id_instruction": "Użyj wartości entityID z adresu URL metadanych.",
      "existing_users_only": "Logowanie SAML działa tylko dla istniejących zaproszonych administratorów w tym workspace.",
      "form": {
        "app_federation_metadata_url": "App federation metadata URL",
        "app_federation_metadata_url_placeholder": "https://example.com/federationmetadata.xml",
        "email_attribute": "Atrybut e-mail",
        "email_attribute_placeholder": "email",
        "enabled": "Włącz providera",
        "enabled_help": "Włączeni providerzy mogą być używani ze strony logowania.",
        "first_name_attribute": "Atrybut imienia",
        "first_name_attribute_placeholder": "firstName",
        "idp_entity_id": "IdP entity ID",
        "idp_entity_id_placeholder": "https://idp.example.com/entity",
        "idp_login_url": "IdP login URL",
        "idp_logout_url": "IdP logout URL",
        "idp_x509_certificate": "Certyfikat IdP X.509",
        "idp_x509_certificate_help": "Obecnego certyfikatu nie można ponownie wyświetlić. Zostaw to pole puste, aby go zachować, albo wklej nowy certyfikat, aby go zaktualizować.",
        "idp_x509_certificate_placeholder": "Wklej certyfikat od dostawcy tożsamości",
        "idp_x509_certificate_update": "Zaktualizuj certyfikat",
        "last_name_attribute": "Atrybut nazwiska",
        "last_name_attribute_placeholder": "lastName",
        "login_type": "Wymagaj SAML dla",
        "login_type_employee": "Użytkownicy huba",
        "login_type_employee_description": "Używaj SAML do logowania pracowników w hubie szkoleniowym.",
        "login_type_user": "Administratorzy",
        "login_type_user_description": "Używaj SAML do logowania administratorów w panelu administracyjnym.",
        "name": "Nazwa",
        "name_id_format": "Format Name ID",
        "name_placeholder": "Microsoft Entra ID",
        "provider": "Provider",
        "url_placeholder": "https://idp.example.com/sso"
      },
      "idp_entity_id": "IdP entity ID",
      "login_url": "Login URL",
      "metadata_url": "Metadata URL",
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      },
      "read": {
        "description": "Skopiuj te wartości do konfiguracji swojego dostawcy tożsamości.",
        "title": "Konfiguracja SAML"
      },
      "save_provider": "Zapisz providera",
      "saved": "Provider SAML zapisany",
      "subtitle": "Skonfiguruj dostawców tożsamości dla SSO.",
      "table": {
        "delete": "Usuń",
        "edit": "Edytuj",
        "name": "Nazwa",
        "provider": "Provider",
        "provider_id": "Provider ID",
        "status": "Status"
      },
      "title": "SAML single sign-on"
    },
    "simulation": {
      "ceo_fraud": {
        "ceo": {
          "text": "Wprowadź dane kontaktowe swojego CEO (lub odpowiednika)",
          "title": "Dyrektor generalny (CEO)"
        },
        "cfo": {
          "text": "Wprowadź dane kontaktowe swojego CFO (lub odpowiednika)",
          "title": "Dyrektor finansowy (CFO)"
        },
        "cto": {
          "text": "Wprowadź dane kontaktowe swojego CTO (lub odpowiednika)",
          "title": "Dyrektor ds. technologii (CTO)"
        },
        "info": "Używamy poniższych informacji, aby dostosować symulacje oszustw CEO dla Twojej organizacji. Jeśli informacje nie są dostępne, użyjemy wartości domyślnych.",
        "subtitle": "Ustawienia dla oszustw na dyrektora generalnego w symulacjach.",
        "title": "Oszustwo CEO"
      },
      "dmi": {
        "google": {
          "alert_text": "Upewnij się, że skonfigurujesz DMI w Google Workspace przed włączeniem go tutaj.",
          "subtitle": "Skonfiguruj DMI w Google Workspace, aby wstrzyknąć e-maile symulacyjne bezpośrednio do skrzynek odbiorczych Gmail.",
          "title": "DMI for Google Workspace",
          "toggle": {
            "help": "Skonfiguruj DMI w Google Workspace, a następnie włącz tutaj po zakończeniu konfiguracji.",
            "label": "Aktywuj DMI"
          }
        }
      },
      "search": {
        "placeholder": "Szukaj usług",
        "results": "Wyniki wyszukiwania dla: {query}"
      },
      "services": {
        "credential_harvest": "Strona danych uwierzytelniających",
        "selector": {
          "dialog_title": "Edytuj usługi",
          "edit_button": "Edytuj dostępne usługi",
          "title": "Brak aktywowanych usług | Jedna usługa aktywowana | {count} usługi aktywowane",
          "update_services": "Aktualizuj usługi"
        },
        "subtitle": "Ustawienia dotyczące targetowania na podstawie oprogramowania.",
        "title": "Targetowanie oprogramowania"
      },
      "training": {
        "download": {
          "subtitle": "Pobierz domeny używane w naszych symulacjach phishingowych.",
          "title": "Pobierz domeny symulacji"
        },
        "local_ratio": {
          "help": "Przy 70% pracownik niemieckojęzyczny otrzymuje 70% szablonów w języku niemieckim i 30% w języku angielskim.",
          "subtitle": "Określ, jak szablony są dzielone między język każdego pracownika a język angielski. Po wyłączeniu nie obowiązują żadne ustalone proporcje.",
          "title": "Szablony w językach pracowników"
        },
        "subtitle": "Skonfiguruj czułość i ustawienia śledzenia dla twoich symulacji.",
        "title": "Ogólne",
        "toggle": {
          "subtitle": "Wyślij szkolenie naprawcze, gdy pracownik zostanie uznany za podatnego.",
          "title": "Szkolenia"
        }
      }
    },
    "simulations": {
      "ceo_fraud": {
        "ceo_email": {
          "label": "E-mail"
        },
        "ceo_name": {
          "label": "Imię"
        },
        "cfo_email": {
          "label": "Email"
        },
        "cfo_name": {
          "label": "Imię"
        },
        "cto_email": {
          "label": "Email"
        },
        "cto_name": {
          "label": "Imię"
        }
      },
      "enable_ceo_fraud": "Włącz oszustwa CEO",
      "enable_module_help": "Włącz ten moduł dla przestrzeni roboczej.",
      "enable_software_targeting": "Włącz targetowanie oprogramowania"
    },
    "tables": {
      "reports": {
        "frequency": "Częstotliwość",
        "period": "Okres",
        "recipient": "Odbiorca",
        "status": "Status",
        "type": "Typ"
      },
      "scim": {
        "actions": "Akcje",
        "created": "Utworzono",
        "default_mapping": "Mapowanie domyślne",
        "effective_mapping": "Mapowanie wynikowe",
        "last_used": "Ostatnio użyty",
        "name": "Nazwa",
        "provider": "Dostawca",
        "status": "Status",
        "sync_type": "Typ"
      },
      "tokens": {
        "created": "Utworzono",
        "last_used": "Ostatnio używane",
        "name": "Nazwa"
      },
      "users": {
        "created": "Utworzono",
        "role": "Rola",
        "status": "Status",
        "two_factor": "2FA",
        "user": "Użytkownik"
      }
    },
    "threats": {
      "advanced_settings": {
        "hide": "Ukryj ustawienia zaawansowane",
        "show": "Pokaż ustawienia zaawansowane"
      },
      "alias_email": {
        "help": "Sugerujemy utworzenie bardziej przyjaznej dla użytkownika wersji aliasu adresu e-mail przychodzącego. Na przykład security{'@'}example.com",
        "label": "Email aliasowy",
        "placeholder": "security{'@'}example.com"
      },
      "clustering": {
        "title": "Grupowanie zagrożeń"
      },
      "enable_defender_integration": {
        "help": "Przekazuj zgłoszone wiadomości phishingowe do Microsoft Defender.",
        "label": "Włącz integrację z Microsoft Defender",
        "title": "Microsoft Defender"
      },
      "enable_forwarding": {
        "help": "Włącz przesyłanie zagrożeń na określony adres e-mail.",
        "title": "Włącz przesyłanie zagrożeń"
      },
      "enable_grouped_threat_status_transitions": {
        "help": "Po włączeniu nowo utworzone zagrożenia otrzymają taki sam status jak powiązane zagrożenie",
        "title": "Włącz automatyczną zmianę statusu zagrożeń w klastrach"
      },
      "enable_notifications": {
        "help": "Otrzymuj powiadomienie za każdym razem, gdy zgłoszone zostanie potencjalne zagrożenie",
        "title": "Włącz powiadomienia"
      },
      "enable_third_party_submission": {
        "help": "Włącz zgłaszanie ataków phishingowych przez strony trzecie do Microsoft i Google.",
        "title": "Włącz przesyłanie przez strony trzecie"
      },
      "enable_threat_management": {
        "help": "Włącz zarządzanie zagrożeniami dla tej przestrzeni roboczej.",
        "title": "Włącz zarządzanie zagrożeniami"
      },
      "forward_reported_emails_to": {
        "label": "Przekazuj zgłoszone wiadomości e-mail do:",
        "placeholder": "reported{'@'}company.com"
      },
      "forward_to": {
        "label": "Przekaż do:",
        "placeholder": "phishing{'@'}company.com"
      },
      "forwarding": {
        "defender": {
          "description": "Przekazuj zgłoszone wiadomości phishingowe do Microsoft Defender.",
          "title": "Przekaż do Defender"
        },
        "disabled": {
          "description": "Nie przekazuj zgłoszonych zagrożeń.",
          "title": "Wyłącz przekazywanie"
        },
        "email": {
          "description": "Wysyłaj zgłoszone zagrożenia na określony adres e-mail.",
          "title": "Przekaż na e-mail"
        },
        "title": "Przekazywanie zagrożeń"
      },
      "forwarding_warning": "Po włączeniu przekazywania zagrożeń, zgłoszone zagrożenia będą tylko do odczytu w panelu administracyjnym. Firma Moxso nie będzie przeprowadzać analizy.",
      "inbound_email": {
        "help": "Ten adres e-mail jest Twoim osobistym adresem do zgłaszania. Każdy e-mail wysłany na ten adres zostanie przeanalizowany przez Moxso.",
        "label": "Przychodzący e-mail"
      },
      "save_forwarded_emails": {
        "help": "Po włączeniu przekazane e-maile będą przechowywane.",
        "label": "Zapisz przekazane zagrożenia"
      },
      "subtitle": "Skonfiguruj swoje ustawienia zarządzania zagrożeniami.",
      "threat_grouping_confidence": {
        "help": "Określa stopień podobieństwa wymagany przed połączeniem zagrożeń w klaster.",
        "label": "Poziom pewności klastrowania zagrożeń",
        "options": {
          "high": "Wysoki",
          "low": "Niski",
          "medium": "Średni"
        }
      },
      "title": "Zarządzanie zagrożeniami"
    },
    "two_factor": {
      "actions": {
        "disable": "Wyłącz uwierzytelnianie dwuskładnikowe",
        "enable": "Włącz uwierzytelnianie dwuskładnikowe",
        "regenerate_recovery_codes": "Wygeneruj kody odzyskiwania ponownie",
        "view_recovery_codes": "Pokaż kody odzyskiwania"
      },
      "disabled": {
        "badge": "Wył.",
        "text": "Chroń to konto administratora kodem z aplikacji uwierzytelniającej lub menedżera haseł.",
        "title": "Uwierzytelnianie dwuskładnikowe jest wyłączone"
      },
      "enabled": {
        "badge": "Wł.",
        "text": "To konto administratora wymaga drugiego składnika podczas logowania.",
        "title": "Uwierzytelnianie dwuskładnikowe jest włączone"
      },
      "password_dialog": {
        "cancel": "Anuluj",
        "cancel-setup": {
          "button": "Anuluj konfigurację",
          "description": "Potwierdź obecne hasło, aby anulować trwającą konfigurację uwierzytelniania dwuskładnikowego.",
          "title": "Anuluj konfigurację 2FA"
        },
        "current_password": "Obecne hasło",
        "disable": {
          "button": "Wyłącz",
          "description": "Potwierdź obecne hasło, aby wyłączyć uwierzytelnianie dwuskładnikowe dla tego konta.",
          "title": "Wyłącz uwierzytelnianie dwuskładnikowe"
        },
        "enable": {
          "button": "Kontynuuj",
          "description": "Potwierdź obecne hasło przed konfiguracją uwierzytelniania dwuskładnikowego.",
          "title": "Włącz uwierzytelnianie dwuskładnikowe"
        },
        "regenerate-recovery-codes": {
          "button": "Wygeneruj kody ponownie",
          "description": "Potwierdź obecne hasło, aby zastąpić istniejące kody odzyskiwania.",
          "title": "Wygeneruj kody odzyskiwania ponownie"
        },
        "show-recovery-codes": {
          "button": "Pokaż kody",
          "description": "Potwierdź obecne hasło, aby zobaczyć swoje kody odzyskiwania.",
          "title": "Pokaż kody odzyskiwania"
        }
      },
      "recovery_codes": {
        "copied": "Skopiowano",
        "copy": "Kopiuj kody",
        "text": "Zapisz te jednorazowe kody w menedżerze haseł. Nie zostaną tu ponownie pokazane po ich zamknięciu.",
        "title": "Kody odzyskiwania"
      },
      "setup": {
        "cancel": "Anuluj konfigurację",
        "code_label": "Kod uwierzytelniający",
        "code_placeholder": "123456",
        "confirm": "Potwierdź",
        "manual_key": "Ręczny klucz konfiguracji",
        "qr_alt": "Kod QR konfiguracji 2FA",
        "text": "Zeskanuj kod QR aplikacją uwierzytelniającą lub menedżerem haseł, a następnie wpisz wygenerowany 6-cyfrowy kod.",
        "title": "Skonfiguruj aplikację uwierzytelniającą"
      },
      "subtitle": "Wymagaj drugiego składnika podczas logowania do konta administratora.",
      "title": "Uwierzytelnianie dwuskładnikowe"
    },
    "workspace": {
      "lms": {
        "subtitle": "Skonfiguruj niestandardowy URL treści, aby przekierować użytkowników do zewnętrznej platformy edukacyjnej.",
        "title": "Zewnętrzny LMS"
      },
      "logging": {
        "activity": "Aktywność",
        "columns": {
          "action_time": "Czas działania",
          "action_type": "Typ działania",
          "actor": "Aktor",
          "zone": "Strefa"
        },
        "moxso_support": "Moxso support",
        "partner": "Partner",
        "slideover": {
          "actor": "Aktor",
          "app": "Aplikacja",
          "audit_log": "Dziennik audytu",
          "created": "Utworzono",
          "email": "E-mail",
          "event": "Zdarzenie",
          "impersonated_by_support": "Podszywanie przez wsparcie",
          "ip_address": "Adres IP",
          "name": "Nazwa",
          "no": "Nie",
          "path": "Ścieżka",
          "request": "Żądanie",
          "summary": "Podsumowanie",
          "tabs": {
            "request": "Żądanie",
            "summary": "Podsumowanie i aktor"
          },
          "title": "Zdarzenie",
          "type": "Typ",
          "user_agent": "User agent",
          "yes": "Tak"
        },
        "subtitle": "Zobacz historię zmian dokonanych na tym koncie.",
        "title": "Dzienniki audytu"
      },
      "scim": {
        "attribute_mapping": {
          "subtitle": "Nadpisz obsługiwane cele atrybutów SCIM dla tego połączenia. Puste wiersze używają domyślnego mapowania backendu.",
          "title": "Mapowanie atrybutów"
        },
        "connection_settings": {
          "subtitle": "Zarządzaj dostawcą, nazwą i stanem włączenia wybranego połączenia SCIM.",
          "title": "Ustawienia połączenia"
        },
        "connections": {
          "disabled": "Wyłączone",
          "enabled": "Włączone",
          "subtitle": "Skonfiguruj połączenia dostawców tożsamości do automatycznego provisioningu użytkowników i grup przez SCIM.",
          "title": "Połączenia SCIM"
        },
        "endpoint": {
          "label": "Adres URL tenant",
          "subtitle": "Użyj tego bazowego adresu URL u dostawcy tożsamości. Nie dodawaj Users, Groups ani ServiceProviderConfig do adresu URL.",
          "title": "Endpoint provisioningu"
        },
        "tokens": {
          "subtitle": "Utwórz bearer tokeny dla Microsoft Entra ID, Okta lub innego dostawcy tożsamości SCIM v2.",
          "title": "Tokeny provisioningu SCIM"
        }
      },
      "subtitle": "Skonfiguruj ustawienia swojej przestrzeni roboczej.",
      "title": "Ustawienia przestrzeni roboczej",
      "tokens": {
        "subtitle": "Uzyskaj bezpieczny dostęp do zbioru danych Moxso z poziomu swoich aplikacji i usług.",
        "title": "Zbiór danych"
      },
      "user": {
        "two_factor_disabled": "Wyłączone",
        "two_factor_enabled": "Włączone",
        "verification_required": "Oczekuje na weryfikację",
        "verified": "Zweryfikowany"
      },
      "users": {
        "subtitle": "Zarządzaj użytkownikami w przestrzeni roboczej",
        "title": "Użytkownicy"
      }
    }
  },
  "simulations": {
    "audience_missing_phone_numbers_all": "Żaden z pracowników w wybranej grupie docelowej nie ma numeru telefonu. Zmień grupę docelową lub dodaj numery telefonów, a następnie spróbuj ponownie.",
    "audience_missing_phone_numbers_some": "Jeden pracownik z {total} w wybranej grupie nie ma numeru telefonu. | {count} pracowników z {total} w wybranej grupie nie ma numerów telefonów.",
    "click_rate": {
      "title": "Wskaźnik klikalności"
    },
    "clicked": "Kliknięto",
    "count": {
      "title": "Przetworzone symulacje",
      "unit": "Symulacje"
    },
    "create": {
      "button": "Utwórz symulację",
      "configuration": {
        "choose_type": "Wstecz",
        "text": "Zdefiniuj grupę odbiorców i ustawienia tej symulacji.",
        "title": "Skonfiguruj swoją symulację",
        "token": "Ustaw niestandardowy nagłówek e-mail w celu dodania do listy dozwolonych. Twój token zostanie przesłany jako nagłówek {token} w każdej wiadomości e-mail wysłanej z tej symulacji."
      },
      "credential_harvest": {
        "description": "Po włączeniu, pracownicy będą otrzymywać wyłącznie symulacje zawierające strony logowania. Moxso monitoruje przesyłanie formularzy, ale nigdy nie przechowuje wprowadzonych danych uwierzytelniających.",
        "enable_label": "Włącz zbieranie danych uwierzytelniających",
        "title": "Kradzież poświadczeń"
      },
      "delivery_rate": {
        "high": {
          "email_description": "1-2 tygodnie między e-mailami",
          "sms_description": "1-2 dni między sms-ami",
          "title": "Wysoki"
        },
        "low": {
          "email_description": "1-6 tygodni między e-mailami",
          "sms_description": "1-6 dni między sms-ami",
          "title": "Niski"
        },
        "medium": {
          "email_description": "1-4 tygodnie między e-mailami",
          "sms_description": "1-4 dni między sms-ami",
          "title": "Średnia"
        }
      },
      "help": {
        "audience": "Zdecyduj, która grupa odbiorców ma otrzymać tę symulację.",
        "email_delivery_rate": "Określa czas pomiędzy wiadomościami e-mailami symulacji. Częstotliwość dostosowuje się w ramach zakresu wskaźnika dostarczania w zależności od reakcji pracownika.",
        "sms_delivery_rate": "Określa czas pomiędzy wiadomościami sms-ami symulacji. Częstotliwość dostosowuje się w ramach zakresu wskaźnika dostarczania w zależności od reakcji pracownika.",
        "staggered_delivery": "Symulacje są dostarczane losowo w dni robocze w ramach wybranej liczby dni.",
        "test": "Symulacje testowe nie wpływają na dane szkoleniowe użytkownika ani metryki raportowania."
      },
      "labels": {
        "audience": "Publiczność",
        "delivery_rate": "Wskaźnik dostawy",
        "name": "Nazwa",
        "preview": "Podgląd",
        "schedule_type": "Typ harmonogramu",
        "staggered_delivery": "Dostawa rozłożona w czasie",
        "template": "Szablon",
        "test": "Oznacz jako symulację testową",
        "token": "Token",
        "token_header": "Ustaw niestandardowy nagłówek tokenu symulacji",
        "use_template": "Użyj niestandardowego szablonu"
      },
      "placeholders": {
        "audience": "Proszę wybrać {audience}.",
        "name": "Nazwa symulacji",
        "token": "ABC-123"
      },
      "random_template": "Losowy szablon",
      "remove_template": "Usuń szablon",
      "step_current_of_last": "Krok {current_step} z {last_step}",
      "title": "Utwórz symulację",
      "type": {
        "button": "Dalej",
        "email": {
          "text_plural": "Wyślij symulacje jako e-mail",
          "text_singular": "Wyślij symulację jako e-mail",
          "title": "E-mail"
        },
        "help": {
          "delivery_method": "Wybierz sposób dostarczenia symulacji",
          "schedule_type": "Wybierz, jak często ta symulacja ma być uruchamiana"
        },
        "labels": {
          "delivery_method": "Metoda dostarczenia",
          "schedule_type": "Typ harmonogramu"
        },
        "one_off": {
          "text": "Wszystkie ataki zostaną wysłane po uruchomieniu symulacji.",
          "title": "Jednorazowa symulacja"
        },
        "recurring": {
          "text": "Ataki będą wysyłane co miesiąc, dopóki symulacja nie zostanie dezaktywowana.",
          "title": "Zautomatyzowana symulacja"
        },
        "sms": {
          "text_plural": "Wyślij symulacje jako SMS",
          "text_singular": "Wyślij symulację jako SMS",
          "title": "SMS"
        },
        "text": "Wybierz harmonogram i metodę dostarczenia dla tej symulacji.",
        "title": "Ustaw dostarczanie symulacji"
      }
    },
    "delete": {
      "are_you_sure": "Czy na pewno chcesz usunąć tę symulację? Tej czynności nie można cofnąć.",
      "button": "Usuń symulację",
      "simulation_deleted": "Symulacja usunięta"
    },
    "details": {
      "heading": "Podsumowanie",
      "text": "Podsumowanie symulacji"
    },
    "edit": {
      "button": "Edytuj ustawienia",
      "button_save": "Zapisz ustawienia",
      "campaign_updated": "Symulacja zaktualizowana",
      "title": "Edytuj symulację"
    },
    "filter": {
      "status": {
        "all": "Status: Wszystkie",
        "click": "Status: Kliknięto",
        "report": "Status: Zgłoszono",
        "submission": "Status: Zaloguj się"
      }
    },
    "launch": {
      "button": "Uruchom symulację",
      "input_label": "Wpisz całkowitą liczbę odbiorców",
      "launched": "Symulacja uruchomiona",
      "no_recipients": "Wybrana grupa odbiorców nie ma członków. Proszę dostosować grupę odbiorców i spróbować ponownie.",
      "no_recipients_title": "Brak członków",
      "title": "Uruchom symulację",
      "warning": "Zaraz uruchomisz symulację, która zostanie wysłana do {count} odbiorców. Czy na pewno chcesz kontynuować?"
    },
    "opened": "Otwórz",
    "pause": "Wstrzymaj symulację",
    "pause_confirmation": {
      "results": "Wyniki już wysłanych symulacji zostaną zachowane.",
      "title": "Wstrzymać symulację?",
      "warning": "Zaplanowane wysyłki do anulowania po wstrzymaniu symulacji: {count}. Po wznowieniu nowy harmonogram zastępuje pierwotne daty wysyłek. Pracownicy mogą przez to dłużej czekać na kolejną symulację."
    },
    "play": "Wznów symulację",
    "received": "Odebrano",
    "report_rate": {
      "title": "Częstotliwość raportowania"
    },
    "reported": "Zgłoszono",
    "scheduled": "Zaplanowane",
    "send_test": "Wyślij test",
    "send_test_tooltip": "Wyślij email testowy do {userEmail}",
    "staggered_delivery": {
      "days": "{count} dzień | {count} dni | {count} dni",
      "off": "Wyłączone"
    },
    "stop": {
      "button": "Zatrzymaj symulację",
      "simulation_stopped": "Symulacja zatrzymana",
      "title": "Zatrzymać symulację?",
      "warning": "Zatrzymanie symulacji anuluje wszystkie pozostałe zaplanowane wysyłki. Wyniki już wysłanych symulacji zostaną zachowane. Czy na pewno chcesz kontynuować?"
    },
    "submission_disabled": "Wyłączone",
    "submission_enabled": "Włączone",
    "submission_rate": {
      "title": "Wskaźnik logowania"
    },
    "submitted": "Próba logowania",
    "summary": {
      "credential_harvest": "Pozyskiwanie poświadczeń",
      "delivery_method": "Metoda dostarczenia",
      "delivery_rate": "Wskaźnik dostawy",
      "group": "Grupa",
      "schedule_type": "Typ harmonogramu",
      "staggered_delivery": "Dostawa rozłożona w czasie",
      "test": "Symulacja testowa",
      "type": "Typ"
    },
    "templates": {
      "create": {
        "button": "Utwórz szablon",
        "success_text": "Szablon utworzony",
        "title": "Utwórz szablon symulacji"
      },
      "duplicate": {
        "button": "Duplikuj",
        "subject": "Kopia",
        "success_text": "Szablon zduplikowany",
        "title": "Duplikuj szablon symulacji"
      },
      "edit": {
        "button": "Zapisz szablon",
        "success_text": "Szablon zapisany",
        "title": "Edytuj szablon symulacji"
      },
      "editor": {
        "ai_modal": {
          "button": "Generuj",
          "placeholder": "Opisz szablon symulacji, który chcesz zbudować...",
          "title": "Wygeneruj szablon przy użyciu AI"
        },
        "attack_link": "Link ataku",
        "attack_link_already_applied": "Linki ataku są automatycznie stosowane do przycisków.",
        "buttons": {
          "generate": "Generuj",
          "send_preview": "Wyślij mi podgląd"
        },
        "change_image": "Zmień obraz",
        "default_block_content": {
          "button": "Sprawdź teraz",
          "container_text": "Dodaj tutaj swoją treść.",
          "footer_text": "Otrzymujesz tę wiadomość e-mail, ponieważ jesteś pracownikiem ::workspace.name::.",
          "heading_1": "Nagłówek 1",
          "heading_2": "Nagłówek 2",
          "heading_3": "Nagłówek 3",
          "image_alt": "Obraz",
          "text": "Wpisz tutaj swoją wiadomość.",
          "unsubscribe": "Wypisz się"
        },
        "generating_template": "Generowanie szablonu",
        "google_dmi_enabled": "Direct message injection jest włączone",
        "insert_image": "Wstaw obraz",
        "labels": {
          "custom_domain": "Domena niestandardowa",
          "email": "E-mail",
          "select_domain": "Wybierz domenę",
          "sender": "Nadawca",
          "string_templates": {
            "date_last_month": "Ten sam dzień w ubiegłym miesiącu",
            "date_last_week": "Ten sam dzień w ubiegłym tygodniu",
            "date_last_year": "Ten sam dzień w ubiegłym roku",
            "date_next_month": "Ten sam dzień w przyszłym miesiącu",
            "date_next_week": "Ten sam dzień w przyszłym tygodniu",
            "date_next_year": "Ten sam dzień w przyszłym roku",
            "date_today": "Dzisiaj",
            "date_tomorrow": "Jutro",
            "date_yesterday": "Wczoraj",
            "department": "Dział",
            "email": "E-mail",
            "first_name": "Imię",
            "last_name": "Nazwisko",
            "manager_email": "Manager e-mail",
            "manager_first_name": "Manager imię",
            "manager_last_name": "Manager nazwisko",
            "workspace_address": "Adres firmy",
            "workspace_city": "Miasto firmy",
            "workspace_name": "Nazwa firmy",
            "workspace_postal_code": "Kod pocztowy firmy"
          },
          "subject": "Temat"
        },
        "no_image_selected": "Nie wybrano obrazu",
        "placeholders": {
          "custom_domain": "example.com",
          "email": "Nazwa nadawcy",
          "sender_name": "Alice Smith",
          "subject": "Wpisz temat tutaj"
        },
        "preview_sent_success": "Podgląd e-maila został pomyślnie wysłany.",
        "qr_code": "Kod QR",
        "sidebar": {
          "blocks": "Bloki",
          "no_tags_found": "Nie znaleziono tagów",
          "settings": "Ustawienia",
          "settings_title": "Ustawienia wybranego bloku",
          "style": "Projekt",
          "style_title": "Projekt szablonu",
          "tags": "Tagi",
          "variables_title": "Tagi scalania"
        },
        "sidebar_field_options": {
          "center": "Do środka",
          "fixed": "Stała szerokość",
          "full_width": "Pełna szerokość",
          "left": "Do lewej",
          "right": "Do prawej"
        },
        "sidebar_fields": {
          "alt_text": "Tekst alternatywny",
          "auto": "Automatycznie",
          "background_color": "Kolor tła",
          "border_radius": "Promień rogów",
          "button_dimensions_hint": "Wymiary są podane w pikselach. Ustaw szerokość lub wysokość na 0, aby dopasować do tekstu.",
          "button_min_height": "Minimalna wysokość",
          "color": "Kolor",
          "column_width": "Szerokość kolumny {column} (%)",
          "columns": "Kolumny",
          "content_alignment": "Wyrównanie",
          "content_width_mode": "Szerokość",
          "font_size": "Rozmiar czcionki",
          "gap": "Odstęp",
          "height": "Wysokość",
          "image_url": "Obraz",
          "padding": "Wypełnienie",
          "text_color": "Kolor tekstu",
          "thickness": "Grubość",
          "width": "Szerokość"
        },
        "sidebar_placeholders": {
          "alt_text": "Describe the image",
          "button_label": "Review now",
          "legal_copy": "You are receiving this email because you are an employee of ::workspace.name::."
        },
        "tooltip_fill_out_all_fields": "Wypełnij wszystkie pola, aby wysłać podgląd",
        "tooltip_this_will_save_the_template": "Zapisz szablon",
        "unsaved_changes": {
          "confirm_exit": "Masz niezapisane zmiany. Czy na pewno chcesz wyjść?"
        },
        "unsaved_changes_badge": "Niezapisane zmiany"
      }
    },
    "test_sent": "E-mail testowy wysłany do {userEmail}",
    "tooltip": {
      "click": "Kliknięto odnośnik",
      "open": "Ta symulacja została otwarta",
      "report": "Symulacja została zgłoszona",
      "submit": "Podjęto próbę logowania"
    },
    "updated": "Symulacja zaktualizowana"
  },
  "statistics": {
    "activities_by_type": {
      "completed_courses": "Ukończone kursy",
      "phishing_quiz_correct_answers": "Prawidłowe odpowiedzi na quiz phishingowy",
      "phishing_quiz_incorrect_answers": "Niepoprawne odpowiedzi w quizie o phishingu",
      "quiz_answers": "Odpowiedzi na quiz",
      "quiz_correct_answers": "Poprawne odpowiedzi w quizie",
      "quiz_incorrect_answers": "Niepoprawne odpowiedzi w quizie",
      "simulations_delivered": "Dostarczone symulacje",
      "simulations_failed": "Nierozpoznane symulacje",
      "simulations_passed": "Rozpoznane symulacje",
      "simulations_reported": "Zgłoszone symulacje",
      "text": "Jak szkolą się Twoi pracownicy",
      "threats_reported": "Zgłoszone zagrożenia",
      "title": "Ukończone aktywności",
      "videos_watched": "Obejrzane filmy"
    },
    "benchmarks": {
      "above_benchmark_tooltip": "Wartość jest powyżej punktu odniesienia.",
      "average": "Średnia sieciowa",
      "below_benchmark_tooltip": "Wartość jest poniżej punktu odniesienia.",
      "benchmark_tooltip": "Punkt odniesienia",
      "peer_avg": "Średnia rówieśników.",
      "score": "Aktualny wynik",
      "text_higher": "% lepszy niż porównywalne firmy",
      "text_lower": "% niższy niż porównywalne firmy",
      "title": "Wskaźniki wydajności"
    },
    "breaches": {
      "title": "Naruszenia"
    },
    "competence": {
      "text": "Jak dobrze Twoi pracownicy radzą sobie w szkoleniu",
      "title": "Kompetencja"
    },
    "culture": {
      "text": "Zaangażowanie twoich pracowników w ich szkolenie z zakresu bezpieczeństwa",
      "title": "Kultura"
    },
    "employee_activity": {
      "title": "Aktywność pracowników"
    },
    "employees": {
      "title": "Aktywni pracownicy"
    },
    "onboarding": {
      "title": "Postęp wdrożenia użytkowników"
    },
    "overdue": {
      "change": "{points} p.p. względem {date}",
      "security_program_text": "Odsetek pracowników, którzy nie realizują swojego programu bezpieczeństwa (szkolenia, polityki)",
      "security_program_title": "Pracownicy z zaległościami w programie bezpieczeństwa",
      "text": "Odsetek aktywnych pracowników z niedotrzymanymi terminami szkoleń",
      "title": "Niedotrzymane terminy",
      "unit": "Niedotrzymane terminy"
    },
    "recent_activity": "Ostatnia aktywność",
    "resilience_score": {
      "change_last_90_days": "{value}% w ciągu ostatnich 90 dni",
      "text": "Wynik obliczony na podstawie tego, jak wszyscy aktywni pracownicy szkolą się i wykonują symulacje.",
      "title": "Obecny wynik odporności"
    },
    "resilience_score_progression": {
      "title": "Wynik odporności w czasie"
    },
    "risk_level": {
      "country": "Kraj",
      "text": "Poziom ryzyka jest określany przez kraj, organizację i zsyntetyzowany poziom ryzyka, dostarczając wglądu w obecny krajobraz zagrożeń.",
      "title": "Poziom ryzyka",
      "workspace": "Miejsce pracy"
    },
    "show_more": "Pokaż więcej",
    "simulation_coverage": {
      "title": "Zasięg symulacji"
    },
    "simulations": {
      "campaign_overview": "Przegląd kampanii",
      "click_count": {
        "text": "Liczba razy, kiedy symulacja została kliknięta.",
        "title": "Łączna liczba kliknięć",
        "unit": "Kliknięcia"
      },
      "click_rate": {
        "text": "Wynik obliczony na podstawie procentu pracowników, którzy kliknęli w link w symulacji.",
        "title": "Wskaźnik klikalności",
        "unit": "%"
      },
      "count": {
        "text": "Łączna liczba wysłanych symulacji.",
        "title": "Symulacje wysłane",
        "unit": "Symulacje"
      },
      "performance_metrics": "Metryki wydajności",
      "reporting_count": {
        "text": "Łączna liczba zgłoszonych symulacji",
        "title": "Łączna liczba raportów",
        "unit": "Raporty"
      },
      "reporting_rate": {
        "text": "Wynik obliczony na podstawie odsetka pracowników, którzy zgłosili symulację.",
        "title": "Wskaźnik raportowania",
        "unit": "%"
      },
      "submission_count": {
        "text": "Łączna liczba przesłanych symulacji.",
        "title": "Łączna liczba zgłoszeń",
        "unit": "Zgłoszenia"
      },
      "submission_rate": {
        "text": "Wynik obliczony na podstawie procentu pracowników, którzy zalogowali się do symulacji.",
        "title": "Wskaźnik logowania",
        "unit": "%"
      },
      "submission_sent_count": "Łączna liczba przesłanych zgłoszeń"
    },
    "simulations_sent": {
      "title": "Wysłane symulacje"
    },
    "threats": {
      "count": {
        "text": "Liczba zagrożeń zgłoszonych przez pracowników.",
        "title": "Zgłoszone zagrożenia"
      },
      "fraud_count": {
        "text": "Liczba realnych zagrożeń zidentyfikowanych przez pracowników.",
        "title": "Zidentyfikowane zagrożenia"
      },
      "handle_rate": {
        "text": "Wynik obliczony na podstawie procentu zagrożeń obsłużonych przez administratora.",
        "title": "Wskaźnik obsługi zagrożeń"
      },
      "reporting_rate": {
        "title": "Zgłoszone zagrożenia"
      },
      "status_partition": {
        "title": "Status zagrożenia"
      },
      "text": "Jak dobrze Twoi pracownicy reagują na zagrożenia",
      "time_to_handle": {
        "text": "Średni czas, jaki zajmuje twoim pracownikom obsługa zagrożenia.",
        "title": "Czas obsługi"
      },
      "title": "Wykrywanie zagrożeń"
    },
    "timeframe_nienty_days": "W ciągu ostatnich 90 dni",
    "training": {
      "courses": {
        "title": "Kursy",
        "unit": "Ukończone kursy"
      },
      "phishing_quizzes": {
        "title": "Quizy phishingowe"
      },
      "quizzes": {
        "title": "Quizy"
      },
      "video_quizzes": {
        "title": "Quizy wideo"
      },
      "videos": {
        "title": "Filmy",
        "unit": "Ukończone wideo"
      }
    },
    "training_coverage": {
      "text": "Wynik obliczony na podstawie odsetka pracowników, którzy ukończyli szkolenie z zakresu bezpieczeństwa.",
      "title": "Zasięg szkolenia"
    }
  },
  "tables": {
    "anonymized_at": "Zanonimizowano o",
    "audience": "Publiczność",
    "audit_completed_status": "Potwierdzono o",
    "available_at": "Dostępne od",
    "breached_at": "Data utworzenia",
    "completed_at": "Zakończono o",
    "created": "Utworzony",
    "created_at": "Utworzono dnia",
    "deadlines": {
      "deadline": "Termin realizacji",
      "employee": "Pracownik",
      "last_learning_interaction": "Ostatnia interakcja",
      "lesson": "Lekcja",
      "reminder_sent": "Ostatnie przypomnienie"
    },
    "delivery_method": "Metoda dostarczenia",
    "domain": "Domena",
    "employee": "Pracownik",
    "employees": "Pracownicy",
    "enrolled_at": "Zapisany na",
    "error_count": "Pominięto",
    "filters": {
      "back": "Wstecz",
      "boolean": "{column} to {toggle}",
      "data": "Filtruj dane",
      "false": "Fałsz",
      "filter_by": "Filtruj według",
      "group": "Filtruj według grupy",
      "numberRange": "{column} od {minValue} do {maxValue}",
      "search": "Szukaj",
      "select_date": "Wybierz datę",
      "status": "Status",
      "training_type": "Rodzaj",
      "true": "Prawda"
    },
    "group": "Grupa",
    "groups": "Grupy",
    "invited": "Zaproszony",
    "languages": "Języki",
    "last_sent_at": "Ostatnio wysłano",
    "lesson_status": "Status lekcji",
    "locale": "Język",
    "name": "Nazwa",
    "overdue": "Zaległe",
    "published_at": "Opublikowano dnia",
    "report_count": "Liczba raportów",
    "reports": "Zgłoszenia",
    "scheduled_at": "Zaplanowano na",
    "score": "Wynik",
    "sensitivity": "Poziom wrażliwości",
    "sent_to_count": "Symulacje",
    "status": "Status",
    "synced_count": "Zsynchronizowano",
    "title": "Tytuł",
    "unique_click_count": "Kliknięcia",
    "unique_submission_count": "Logowania",
    "updated_at": "Zaktualizowano o"
  },
  "threats": {
    "analysis": {
      "attachments": {
        "files": "Pliki",
        "subtitle": "Załączniki e-mailowe",
        "title": "Załączniki"
      },
      "indicators": {
        "common": {
          "heading": "Powszechne zagrożenia",
          "help": "Treść e-maila wspomina o nazwach firm powszechnie używanych w phishingu."
        },
        "credentials": {
          "heading": "Poświadczenia",
          "help": "Treść e-maila wspomina o poświadczeniach lub hasłach."
        },
        "detected": "Wykryto",
        "homoglyphs": {
          "heading": "Homoglify",
          "help": "Nazwa nadawcy lub e-mail zawiera homoglify."
        },
        "inconsistency": {
          "heading": "Niespójność",
          "help": "Niespójności w linkach i/lub informacjach o nadawcy."
        },
        "no_data": "Brak danych",
        "not_detected": "Niewykryty",
        "subtitle": "Wskaźniki zagrożeń",
        "title": "Wskaźniki",
        "urgency": {
          "heading": "Pilność",
          "help": "Pilność jest używana, aby wywierać presję na odbiorcę do podjęcia działania."
        }
      },
      "links": {
        "button": "Izolacja przeglądarki",
        "empty": "Nie znaleziono odnośników",
        "showing_links": "Wyświetlanie {shown} z {total} linków",
        "subtitle": "Linki znalezione w e-mailu",
        "title": "Linki"
      },
      "preview": {
        "not_available": {
          "description": "Nie mogliśmy wygenerować podglądu dla tego emaila.",
          "title": "Podgląd obrazu niedostępny"
        },
        "subtitle": "Podgląd wiadomości e-mail",
        "title": "Podgląd"
      },
      "sender": {
        "domain": "Domena",
        "email": "E-mail",
        "empty": "Nie znaleziono analizy nadawcy",
        "ip": "Adres IP",
        "mx": "DNS rekordy MX",
        "subtitle": "Analiza nadawcy",
        "title": "Nadawca",
        "type": "Typ",
        "type_text": {
          "free": "Bezpłatna usługa",
          "paid": "Usługa płatna"
        }
      }
    },
    "anonymized": {
      "title": "Zanonimizowane zagrożenie"
    },
    "browser_isolation": {
      "button": "Otwórz link w izolacji przeglądarki",
      "copied": "Skopiowano do schowka",
      "heading": "Izolacja przeglądarki",
      "host": "Host",
      "notice": "BrowserLing to usługa zewnętrzna, która zapewnia bezpieczne środowisko do otwierania linków. Klikając przycisk poniżej, zostaniesz przekierowany na stronę internetową BrowserLing. Moxso nie jest powiązany z BrowserLing i nie ponosi odpowiedzialności za jakiekolwiek treści lub działania, które mają miejsce na stronie internetowej BrowserLing.",
      "path": "Ścieżka",
      "scheme": "Schemat",
      "secured_by": "Zabezpieczone przez BrowserLing"
    },
    "buttons": {
      "delete": "Usuń zagrożenie",
      "download_html": "Pobierz HTML",
      "fraudulent": "Złośliwy",
      "legitimate": "Autentyczny",
      "mark_as_fraudulent": "Oznacz jako złośliwy",
      "mark_as_legitimate": "Oznacz jako autentyczny",
      "mark_as_spam": "Oznacz jako spam",
      "notify_reporters": "Powiadom zgłaszających",
      "notify_reporters_description": "Powiadom reporterów o zmianie statusu ich raportów.",
      "show_headers": "Pokaż nagłówki e-maila",
      "show_less": "Pokaż mniej",
      "show_more": "Pokaż więcej",
      "spam": "Spam"
    },
    "comment_added": "Dodano komentarz",
    "created_at": "Utworzono dnia",
    "current": "Bieżące",
    "disabled": {
      "button": "Przejdź do ustawień",
      "heading": "Zarządzanie zagrożeniami jest wyłączone",
      "text": "Zapewnij swoim pracownikom bezpieczny sposób powiadamiania Cię i podejmowania działań przeciwko potencjalnym zagrożeniom czającym się w ich skrzynkach odbiorczych, chroniąc w ten sposób integralność Twojej organizacji na co dzień. Bądź o krok przed wszelkimi potencjalnymi szkodami."
    },
    "export_csv": {
      "description": "Pobieranie obejmuje tylko zagrożenia z wybranym statusem w eksporcie CSV.",
      "subtitle": "Wybierz status zagrożenia",
      "title": "Pobierz CSV"
    },
    "filter": {
      "status": {
        "all": "Status: Wszystkie",
        "forwarded": "Status: Przekazano",
        "fraudulent": "Status: Fałszywy",
        "legitimate": "Status: Autentyczny",
        "spam": "Status: Spam",
        "unhandled": "Status: Nierozwiązany"
      }
    },
    "forwarding_enabled": "Przekazywanie włączone",
    "forwarding_warning": "Zgłoszone zagrożenia są tylko do odczytu i muszą być obsługiwane w zewnętrznym systemie.",
    "from": "Od",
    "headers": "Nagłówki",
    "mark_as": "Oznacz jako:",
    "no_more_unhandled_threats_button": "Zamknij",
    "no_more_unhandled_threats_text": "Przejrzałeś wszystkie zgłoszone zagrożenia. Twoja skrzynka odbiorcza jest teraz bezpieczna.",
    "no_more_unhandled_threats_title": "Wszystko jasne!",
    "note_placeholder": "Dodaj notatkę do reporterów...",
    "related_threats": "Powiązane zagrożenia",
    "relative_time": {
      "days_ago": "{count} dzień temu | {count} dni temu",
      "hours_ago": "{count} godzinę temu | {count} godzin temu",
      "minutes_ago": "{count} minutę temu | {count} minut temu"
    },
    "report_information": "Informacje o zgłoszeniu",
    "reported_by": "Zgłoszone przez: {name}",
    "reports": {
      "clicked_link_warning": "Kliknięto link",
      "phishing": "Phishing",
      "reported_as_phishing": "Zgłoszono jako phishing",
      "reported_as_spam": "Zgłoszono jako spam",
      "reporter_note": "Notatka zgłaszającego",
      "spam": "Spam"
    },
    "review_next_threat_button": "Przejrzyj następne zagrożenie",
    "review_next_threat_text": "Czy chcesz przejrzeć następne nieobsłużone zagrożenie?",
    "status_updated": "Status zaktualizowany",
    "subject": "Temat",
    "this_threat_has_been_forwarded": "To zagrożenie zostało przekazane do systemu zewnętrznego. Nie przeprowadzono analizy.",
    "timeline": {
      "analysis_completed": "Analiza zakończona",
      "button": "Zapisz",
      "status_transition": "Status zmieniono z {from} na {to}",
      "textarea_placeholder": "Dodaj komentarz...",
      "title": "Aktywność"
    },
    "transition_description": "Potwierdź, które zgłoszenia otrzymają ten status.",
    "x_of_n_selected": "{x} z {n} wybrano"
  },
  "titles": {
    "automations": {
      "subtitle": "Zautomatyzowane sekwencje szkoleniowe",
      "title": "Automatyzacja"
    },
    "breaches": {
      "subtitle": "Poznaj naruszenia danych w swoim środowisku pracy.",
      "title": "Naruszenia"
    },
    "dashboard": {
      "subtitle": "Przegląd twojej przestrzeni roboczej.",
      "title": "Przegląd"
    },
    "group": {
      "subtitle": "Jeden aktywny członek grupy. | {count} aktywnych członków grupy."
    },
    "groups": {
      "subtitle": "Zorganizuj swoich pracowników w grupy.",
      "title": "Grupy"
    },
    "integrations": {
      "subtitle": "Przegląd integracji",
      "title": "Integracje"
    },
    "resilience": {
      "subtitle": "Przegląd odporności Twojej organizacji.",
      "title": "Odporność"
    },
    "simulations": {
      "custom_templates": {
        "subtitle": "Przegląd wszystkich twoich niestandardowych szablonów",
        "title": "Niestandardowe szablony"
      },
      "subtitle": "Symuluj ataki phishingowe na swoim zespole.",
      "title": "Symulacje"
    },
    "team": {
      "subtitle": "Wszyscy pracownicy obecnie w twojej przestrzeni roboczej.",
      "title": "Pracownicy"
    },
    "threat": {
      "title": "Raport o zagrożeniu"
    },
    "threats": {
      "subtitle": "Przegląd wszystkich zagrożeń i ich statusu",
      "title": "Zagrożenia"
    },
    "training": {
      "course": {
        "subtitle": "Przegląd wszystkich kursów",
        "title": "Kursy"
      },
      "course_overview": {
        "title": "Przegląd kursu"
      },
      "custom_uploads": {
        "subtitle": "Przegląd wszystkich plików niestandardowych",
        "title": "Przesłane pliki"
      },
      "deadlines": {
        "subtitle": "Przegląd terminów",
        "title": "Terminy"
      },
      "participation": {
        "subtitle": "Przegląd uczestnictwa w szkoleniach",
        "title": "Przegląd uczestnictwa"
      },
      "subtitle": "Przegląd szkoleń twojej organizacji",
      "title": "Szkolenia",
      "video": {
        "subtitle": "Przegląd wszystkich filmów",
        "title": "Filmy wideo"
      },
      "video_overview": {
        "title": "Przegląd wideo"
      }
    }
  },
  "training": {
    "actions": {
      "edit": "Edytuj",
      "edit_categories": "Edytuj kategorie",
      "save": "Zapisz"
    },
    "completed_status": {
      "completed": "Zakończono",
      "not_completed": "Nieukończone"
    },
    "courses": {
      "actions": {
        "collapse_all": "Zwiń wszystko",
        "delete_course": "Usuń kurs",
        "edit": "Edytuj",
        "edit_categories": "Edytuj kategorie",
        "edit_course": "Edytuj kurs",
        "expand_all": "Rozwiń wszystko",
        "preview_course": "Podgląd kursu",
        "save": "Zapisz"
      },
      "add_step": {
        "quiz": "Treść quizu",
        "text": "Treść tekstowa",
        "video": "Treść wideo"
      },
      "create": {
        "button": "Utwórz kurs"
      },
      "create_button": "Utwórz kurs",
      "create_success": "Pomyślnie utworzono kurs",
      "create_title": "Utwórz nowy kurs",
      "default_language_badge": "Domyślny",
      "default_language_label": "Język domyślny",
      "default_language_placeholder": "Wybierz język domyślny",
      "delete": {
        "are_you_sure": "Czy na pewno chcesz usunąć ten krok? Tej czynności nie można cofnąć.",
        "course_are_you_sure": "Czy na pewno chcesz usunąć ten kurs? Wszystkie obowiązkowe szkolenia i punkty powiązane z tym kursem również zostaną usunięte. Tej czynności nie można cofnąć.",
        "translation_are_you_sure": "Czy na pewno chcesz usunąć to tłumaczenie? Tej czynności nie można cofnąć."
      },
      "details": {
        "heading": "Szczegóły"
      },
      "edit_name_dialog": {
        "save": "Zapisz tytuł",
        "title": "Edytuj tytuł kursu"
      },
      "errors": {
        "select_category": "Wybierz co najmniej jedną kategorię",
        "select_locale": "Wybierz co najmniej jeden język"
      },
      "form": {
        "labels": {
          "categories": "Kategorie",
          "risk_categories": "Kategorie",
          "title": "Tytuł"
        },
        "placeholders": {
          "categories": "Wybierz kategorie",
          "title": "Wpisz tytuł"
        }
      },
      "labels": {
        "categories": "Kategoria | Kategorie",
        "no_categories": "Brak kategorii"
      },
      "language_card": {
        "add_language": "Dodaj język",
        "editing": "Edytowanie",
        "select_language": "Wybierz język",
        "switch": "Przełącz",
        "translate_with_ai": "Tłumacz z AI"
      },
      "navigation": {
        "course": "Kurs",
        "participants": "Uczestnicy"
      },
      "notifications": {
        "course_deleted": "Kurs usunięty",
        "name_updated": "Nazwa kursu została zaktualizowana",
        "saved": "Zapisano",
        "settings_saved": "Zmiany zapisane",
        "step_deleted": "Krok usunięty"
      },
      "preview": "Podgląd",
      "publish": "Opublikuj kurs",
      "publish_confirm": "Tak, opublikuj kurs",
      "publish_confirm_description": "Czy na pewno chcesz opublikować ten kurs? Nie można go cofnąć i natychmiast pojawi się w hubie.",
      "publish_success": "Kurs opublikowany",
      "quiz_editor": {
        "actions": {
          "cancel": "Anuluj",
          "save": "Zapisz"
        },
        "ai_prompt": {
          "button": "Prompt dla AI",
          "generate": "Generuj",
          "label": "Opisz quiz, który AI ma utworzyć",
          "no_previous_steps": "Dodaj wcześniej w kursie krok wideo lub tekstowy, aby wykorzystać go jako kontekst.",
          "placeholder": "Stwórz quiz o...",
          "select_helper": "Wybierz kroki",
          "select_label": "Wybierz poprzednie kroki i/lub napisz własny prompt, aby wygenerować pytania do quizu.",
          "step_number": "Krok {order}",
          "step_type": {
            "quiz": "Quiz",
            "text": "Tekst",
            "video": "Wideo"
          },
          "title": "Wygeneruj quiz za pomocą AI",
          "untitled": "Bez tytułu"
        },
        "heading": {
          "description": "Quiz",
          "title": "Krok {step}"
        },
        "select_action": {
          "ai": {
            "description": "Pozwól AI automatycznie wygenerować pytania quizowe na podstawie istniejącej treści tego kursu.",
            "title": "AI generuje z treści"
          },
          "manual": {
            "description": "Zbuduj własny quiz od podstaw, ręcznie dodając pytania i odpowiedzi.",
            "title": "Utwórz quiz ręcznie"
          }
        }
      },
      "select_languages_description": "Wybierz języki, które chcesz uwzględnić w treściach kursu.",
      "set_current_language_as_default": "Ustaw jako domyślny",
      "settings": {
        "edit_description": "Edytuj opis kursu",
        "save": "Zapisz"
      },
      "status": {
        "draft": "wersja robocza",
        "missing_content_warning": "W kursie brakuje treści w co najmniej jednym języku",
        "published": "opublikowany"
      },
      "steps": {
        "empty": {
          "description": "Kliknij powyżej przycisk edycji, aby dodać treść",
          "title": "Pusty krok"
        },
        "intro": "Wprowadzenie",
        "knowledge_check": "Sprawdzenie wiedzy",
        "missing_translation": "Brak tłumaczenia dla tego języka",
        "quiz": "Quiz",
        "text": "Tekst",
        "video": "Wideo"
      },
      "tabs": {
        "course": "Kurs",
        "participants": "Uczestnicy"
      },
      "text_editor": {
        "actions": {
          "cancel": "Anuluj",
          "edit": "Edytuj",
          "save": "Zapisz"
        },
        "ai_prompt": {
          "button": "Przycisk AI w edytorze tekstu",
          "generate": "Generuj",
          "label": "Opisz, co chcesz, aby zrobiła AI",
          "placeholder": "\"Pomóż mi sprawić, aby tekst był bardziej formalny\"",
          "title": "Wygeneruj kartę tekstową za pomocą AI"
        },
        "ai_viewer": {
          "accept": "Zaakceptuj",
          "back": "Anuluj",
          "caption": "Przejrzyj treść wygenerowaną przez AI i zdecyduj, czy ją zaakceptować, czy wygenerować ponownie",
          "generating": "Generowanie treści kursu",
          "heading": "Przejrzyj wygenerowaną treść"
        },
        "apply_image": {
          "button": "Zastosuj do innych języków",
          "has_image": "Ma obraz",
          "subtitle": "Wybierz języki, do których ma zostać zastosowany ten obraz",
          "title": "Zastosuj obraz do innych języków"
        },
        "course_title_badge": "Tytuł kursu",
        "heading": {
          "description": "Edytor tekstu",
          "title": "Krok {step}"
        },
        "labels": {
          "after": "Po",
          "before": "Przed",
          "excerpt": "Fragment",
          "image_upload": "Obraz",
          "remove_image": "Usuń obraz",
          "title": "Tytuł",
          "uploaded_image_alt": "Przesłany obraz"
        },
        "placeholders": {
          "content": "Wprowadź treść",
          "excerpt": "Wprowadź fragment",
          "title": "Wprowadź tytuł"
        },
        "title_linked_tooltip": "Używane jako tytuł w {language} wersji kursu."
      },
      "title_summary": {
        "course_title": "Tytuł kursu",
        "description": "Używane jako tytuł w {language} wersji kursu."
      },
      "translate": {
        "open": "Przetłumacz kurs",
        "submit": "Przetłumacz",
        "title": "Przetłumacz kurs"
      },
      "translate_success": "Kurs przetłumaczony.",
      "translation_list_label": "Tłumaczenie | Tłumaczenia",
      "unpublish": "Wycofaj publikację kursu",
      "unpublish_confirm": "Tak, wycofaj publikację kursu",
      "unpublish_confirm_description": "Czy na pewno chcesz wycofać publikację tego kursu? Natychmiast zniknie z huba.",
      "unpublish_success": "Publikacja kursu wycofana",
      "untitled": "Bez tytułu",
      "validation": {
        "content_missing_in_languages": "Brakuje treści w {count} językach",
        "missing_content": "Brak treści",
        "missing_excerpt": "Brak opisu",
        "missing_image": "Brak obrazu",
        "missing_questions": "Brak pytań",
        "missing_title": "Brak tytułu",
        "options_missing_text": "Niektóre odpowiedzi nie mają tekstu",
        "questions_missing_correct_options": "Niektóre pytania nie mają poprawnych odpowiedzi",
        "questions_missing_text": "Niektóre pytania nie mają tekstu",
        "step_issues": "Problemy z krokami"
      },
      "video_card": {
        "empty_search": {
          "description": "Spróbuj zmienić słowa kluczowe lub wyczyść wyszukiwanie, aby zobaczyć wszystkie dostępne filmy.",
          "title": "Brak filmów pasujących do wyszukiwania"
        },
        "empty_state": {
          "description": "Brak dostępnych filmów. Najpierw musisz utworzyć filmy w sekcji niestandardowych przesyłek wideo."
        },
        "fallback_translation_tooltip": "Ten film korzysta z tłumaczenia zapasowego",
        "search_placeholder": "Szukaj wideo",
        "selected": {
          "button": "Zmień wideo",
          "title": "WIDEO"
        },
        "title": "Wybierz wideo"
      },
      "video_editor": {
        "empty_search": {
          "description": "Spróbuj doprecyzować słowa kluczowe lub wyczyść wyszukiwanie, aby zobaczyć wszystkie filmy.",
          "title": "Żadne filmy nie pasują do wyszukiwania"
        },
        "empty_state": {
          "description": "Ten krok jest pusty. Kliknij przycisk Edytuj powyżej, aby dodać treść."
        },
        "fallback_translation_tooltip": "To wideo używa tłumaczenia zapasowego",
        "search_placeholder": "Szukaj filmów",
        "selected": {
          "button": "Zmień wideo",
          "title": "WIDEO"
        },
        "subtitle": "Wybierz film, który chcesz dodać do tego kroku.",
        "title": "Wybierz wideo"
      }
    },
    "custom_uploads": {
      "subtitle": "Filmy stworzone przez Twoją organizację",
      "title": "Treści własne",
      "video": {
        "badges": {
          "quiz": "Quiz",
          "video": "Wideo"
        },
        "create": {
          "create_video": "Utwórz wideo",
          "next_steps_text": "Wypełnij poniższe informacje, aby skonfigurować swój film. Po utworzeniu filmu zostaniesz przeniesiony na stronę wideo, gdzie możesz wybrać to tłumaczenie i przesłać plik wideo.",
          "video_created": "Film utworzony"
        },
        "delete": {
          "are_you_sure": "Czy na pewno chcesz usunąć ten film? Tej czynności nie można cofnąć.",
          "button": "Usuń",
          "video_deleted": "Usunięto wideo"
        },
        "form": {
          "labels": {
            "categories": "Kategorie",
            "description": "Opis",
            "language": "Język",
            "title": "Tytuł"
          },
          "placeholders": {
            "categories": "Wybierz kategorie",
            "description": "Wprowadź opis",
            "language": "Wybierz język",
            "title": "Wprowadź tytuł"
          }
        },
        "publish": "Opublikuj",
        "publish_confirm": "Opublikuj",
        "publish_confirm_description": "Publikacja sprawia, że ten film jest dostępny w hubie i może być używany na całej platformie.",
        "publish_success": "Film opublikowany",
        "publish_unavailable": "Przed publikacją dodaj wideo do wszystkich tłumaczeń.",
        "quiz": {
          "available_quizzes": "Dostępne quizy",
          "create": "Utwórz",
          "edit": "Edytuj",
          "quiz_deleted": "Quiz usunięty",
          "quiz_saved": "Quiz zapisany",
          "quizzes": "Quizy",
          "quizzes_translated": "Przetłumaczone quizy."
        },
        "single": {
          "details": {
            "heading": "Szczegóły",
            "text": "Szczegóły wideo"
          },
          "labels": {
            "categories": "Kategoria | Kategorie",
            "created_at": "Utworzono o",
            "published_at": "Opublikowano dnia",
            "updated_at": "Zaktualizowano dnia"
          },
          "title": "Niestandardowe wideo"
        },
        "status": {
          "draft": "wersja robocza",
          "published": "opublikowany"
        },
        "translations": {
          "add_translation": "Dodaj tłumaczenie",
          "ai": {
            "done_translate_button": "Zrobione",
            "processing_n_languages": "Przetwarzanie jednego języka | Przetwarzanie {count} języków",
            "text": "Użyj DeepL, aby automatycznie przetłumaczyć tytuł i opis filmu na wybrany język.",
            "title": "Przetłumacz szczegóły wideo za pomocą AI",
            "translate_button": "Tłumacz",
            "translating_your_video": "Tłumaczenie szczegółów wideo",
            "video_now_available_in": "Tłumaczenia zostały utworzone w jednym dodatkowym języku | Tłumaczenia zostały utworzone w {count} dodatkowych językach",
            "video_translate_success": "Sukces!"
          },
          "available_translations": "Dostępne tłumaczenia",
          "create_title": "Dodaj tłumaczenie",
          "default_badge": "Domyślna",
          "delete": "Usuń",
          "delete_are_you_sure": "Czy na pewno chcesz usunąć to tłumaczenie? Tej czynności nie można cofnąć.",
          "edit": "Edytuj",
          "edit_translation": "Edytuj tłumaczenie",
          "empty": "Brak tłumaczeń dla tego wideo",
          "make_default": "Ustaw jako domyślny",
          "manual": {
            "text": "Napisz tłumaczenie od nowa w nowym języku.",
            "title": "Ręcznie przetłumacz wideo"
          },
          "quiz": {
            "create": "Stwórz quiz",
            "edit": "Edytuj quiz",
            "other_translations_have_quizzes": "Inne tłumaczenia mają quizy",
            "other_translations_have_quizzes_want_to_translate": "Inne tłumaczenia już mają quizy. Czy chcesz automatycznie przetłumaczyć ten quiz na te języki?",
            "some_translations_have_no_quizzes": "Niektóre tłumaczenia nie mają obecnie quizów. Przetłumaczyć teraz?",
            "this_translation_has_quizzes_in_other_languages_translate_automatically": "To tłumaczenie zawiera quizy w innych językach. Przetłumaczyć automatycznie?",
            "translate_quiz": "Przetłumacz",
            "update_this_quiz_and_translate_others": "Zaktualizuj ten quiz i przetłumacz inne quizy",
            "update_this_quiz_only": "Zaktualizuj tylko ten quiz"
          },
          "save_changes": "Zapisz zmiany",
          "single": {
            "edit": {
              "subtitle": "Zaktualizuj szczegóły wideo",
              "title": "Szczegóły wideo"
            },
            "upload": {
              "subtitle": "Prześlij plik wideo do tego tłumaczenia.",
              "title": "Prześlij wideo",
              "video_deleted": "Film usunięty",
              "video_uploaded": "Przesłano wideo"
            }
          },
          "translation_added": "Dodano tłumaczenie",
          "translation_deleted": "Tłumaczenie usunięte",
          "translation_updated": "Tłumaczenie zaktualizowane",
          "translations": "Tłumaczenia",
          "video": "Wideo"
        },
        "unpublish": "Cofnij publikację",
        "unpublish_confirm": "Cofnij publikację",
        "unpublish_confirm_description": "Cofnięcie publikacji ukryje ten film w hubie. Nadal będzie dostępny w automatyzacjach, w których jest już używany.",
        "unpublish_success": "Film wycofany z publikacji"
      }
    },
    "deadlines": {
      "bulk_reminder_dialog_confirm": "Wyślij {count} przypomnienie | Wyślij {count} przypomnienia | Wyślij {count} przypomnień",
      "bulk_reminder_dialog_text": "To powiadomi {count} pracowników. Każdy pracownik otrzyma jedno powiadomienie, nawet jeśli ma wiele przypisań.",
      "bulk_reminder_dialog_title": "Wyślij przypomnienia do wszystkich pasujących do wybranych filtrów",
      "bulk_reminders_sent": "Wysłano przypomnienia",
      "delete_reminder": "Usuń przypomnienie",
      "participation_title": "Uczestnictwo",
      "reminder_deleted": "Przypomnienie usunięte",
      "reminder_sent": "Wysłano przypomnienie",
      "send_bulk_reminder": "Wyślij przypomnienia do wszystkich",
      "send_reminder": "Wyślij przypomnienie"
    },
    "default_language_updated": "Zaktualizowano język domyślny",
    "default_translation_tooltip": "To jest obecnie język domyślny. Wybierz inny język przed jego usunięciem.",
    "errors": {
      "select_category": "Wybierz co najmniej jedną kategorię"
    },
    "filter": {
      "course": "Pokaż tylko kursy",
      "video": "Pokaż tylko filmy"
    },
    "form": {
      "labels": {
        "categories": "Kategorie",
        "no_categories": "Brak kategorii"
      },
      "placeholders": {
        "categories": "Wybierz kategorie"
      }
    },
    "invited_status": {
      "invited": "Zaproszony",
      "not_invited": "Nie zaproszono"
    },
    "moxso_courses": {
      "description": "Kursy dostarczane przez Moxso",
      "title": "Kursy Moxso"
    },
    "moxso_uploads": {
      "subtitle": "Filmy dostarczane przez Moxso",
      "title": "Filmy Moxso"
    },
    "quiz": "Quiz",
    "search_courses": {
      "description": "Wyniki wyszukiwania pasujące do zapytania",
      "title": "Wyniki wyszukiwania"
    },
    "type": {
      "course": "Kurs",
      "user_course": "Kurs użytkownika",
      "video": "Wideo"
    },
    "user_defined_courses": {
      "description": "Kursy utworzone przez Twoją organizację",
      "title": "Kursy niestandardowe"
    }
  },
  "translations": {
    "ai": {
      "overwrite_existing_translations_text": "Spowoduje to usunięcie istniejących tłumaczeń i przetłumaczenie ich od nowa.",
      "overwrite_existing_translations_title": "Nadpisz istniejące tłumaczenia",
      "select_languages_to_translate_item_into": "Wybierz języki, dla których chcesz wygenerować tłumaczenia",
      "translate_from": "Przetłumacz z"
    },
    "deepl_privacy": "Polityka prywatności DeepL",
    "deepl_text": "To wyśle kopię twojego tłumaczenia do DeepL, zewnętrznej usługi tłumaczeniowej z wykorzystaniem AI. Twoja treść będzie przetwarzana zewnętrznie, a {link} będzie miał zastosowanie.",
    "quizzes": {
      "done_translate_button": "Zrobione",
      "processing_n_languages": "Przetwarzanie jednego języka | Przetwarzanie {count} języków",
      "quiz_now_available_in": "Twoje quizy są teraz dostępne w jednym dodatkowym języku | Twoje quizy są teraz dostępne w {count} dodatkowych językach",
      "quiz_translate_success": "Sukces!",
      "select_the_languages_you_want_to_translate_your_quiz_into": "Wybierz języki, na które chcesz przetłumaczyć swój quiz.",
      "translate_button": "Przetłumacz",
      "translate_from": "Przetłumacz z",
      "translate_multiple_choice_quiz": "Przetłumacz quiz wielokrotnego wyboru",
      "translating_your_quiz": "Tłumaczenie twojego quizu"
    }
  },
  "two_factor_challenge": {
    "back_to_login": "Wróć do logowania",
    "code": {
      "label": "Kod uwierzytelniający",
      "placeholder": "123456"
    },
    "heading": "Uwierzytelnianie dwuskładnikowe",
    "recovery_code": {
      "label": "Kod odzyskiwania",
      "placeholder": "aaaaaaaaaa-bbbbbbbbbb"
    },
    "submit": "Zweryfikuj",
    "text": "Wpisz kod z aplikacji uwierzytelniającej albo użyj kodu odzyskiwania, aby kontynuować.",
    "use_authenticator_code": "Użyj kodu z aplikacji",
    "use_recovery_code": "Użyj kodu odzyskiwania"
  },
  "uploads": {
    "file_upload": {
      "click_to_upload": "Kliknij, aby przesłać",
      "delete": {
        "are_you_sure": "Czy na pewno chcesz usunąć ten plik? Tej czynności nie można cofnąć.",
        "button": "Usuń"
      },
      "file_upload_limit": "{fileType} · do {fileSize} · zalecana rozdzielczość {imageRatio}",
      "or_drag_and_drop": "{click} lub przeciągnij i upuść",
      "placeholder": "plik",
      "title": "Prześlij plik",
      "up_to": "Do",
      "upload_failed": {
        "button": "Prześlij nowy",
        "subtitle": "Nie udało się przesłać podanego pliku.",
        "title": "Przesyłanie nie powiodło się"
      },
      "upload_in_progress": {
        "processing_subtitle": "Przesyłanie zakończone. Możesz bezpiecznie opuścić tę stronę, gdy je przetwarzamy.",
        "processing_title": "Przetwarzanie Twojego pliku...",
        "uploading_subtitle": "Twój plik jest przesyłany.",
        "uploading_title": "Przesyłanie pliku..."
      }
    },
    "image_upload": {
      "click_to_upload": "Kliknij, aby przesłać",
      "delete": {
        "are_you_sure": "Czy na pewno chcesz usunąć ten obraz? Tej czynności nie można cofnąć.",
        "button": "Usuń"
      },
      "or_drag_and_drop": "lub przeciągnij i upuść",
      "upload_failed": {
        "button": "Prześlij nowy",
        "subtitle": "Nie udało się przesłać podanego pliku.",
        "title": "Przesyłanie nie powiodło się"
      },
      "upload_in_progress": {
        "processing_subtitle": "Przesyłanie zakończone. Możesz bezpiecznie opuścić tę stronę, gdy je przetwarzamy.",
        "processing_title": "Przetwarzanie Twojego pliku...",
        "uploading_subtitle": "Twój plik jest przesyłany.",
        "uploading_title": "Przesyłanie pliku..."
      }
    },
    "video_upload": {
      "click_to_upload": "Kliknij, aby przesłać",
      "delete": {
        "are_you_sure": "Czy na pewno chcesz usunąć ten film? Tej operacji nie można cofnąć.",
        "button": "Usuń"
      },
      "format": "MP4",
      "max": "Maks.",
      "or_drag_and_drop": "lub przeciągnij i upuść",
      "up_to": "Do",
      "upload_failed": {
        "button": "Prześlij ponownie",
        "subtitle": "Przesłanie dostarczonego pliku nie powiodło się.",
        "title": "Przesyłanie nie powiodło się"
      },
      "upload_in_progress": {
        "processing_subtitle": "Przesyłanie zakończone. Możesz bezpiecznie opuścić tę stronę - plik jest przetwarzany.",
        "processing_title": "Przetwarzanie Twojego pliku...",
        "uploading_subtitle": "Twój plik jest przesyłany.",
        "uploading_title": "Przesyłanie pliku..."
      }
    }
  },
  "upsell": {
    "click_to_open": "Kliknij, aby dowiedzieć się więcej",
    "contact": "Powiadom Customer Success",
    "knowledge_base": "Baza wiedzy",
    "learn_more": "Dowiedz się więcej",
    "locked_feature": "Zablokowana funkcja",
    "notify_success": "Powiadomienie wysłano do zespołu Customer Success",
    "upgrade_required": "Ta funkcja wymaga uaktualnienia"
  },
  "user_settings": {
    "subtitle": "Zarządzaj ustawieniami zabezpieczeń swojego konta administratora.",
    "title": "Bezpieczeństwo i dostęp"
  },
  "validate_domain": {
    "login": "Zaloguj się",
    "success": "Domena została pomyślnie zweryfikowana."
  },
  "videos": {
    "error": "Transmisja strumieniowa jest obecnie niedostępna."
  },
  "workspace_onboarding": {
    "invite_admins": {
      "form": {
        "button": "Zaproś administratora",
        "description": "Dodaj kolejnych administratorów, jeśli inne osoby również mają pomagać w konfiguracji lub zarządzaniu Moxso. Wszyscy administratorzy mają ten sam dostęp i widzą te same zmiany.",
        "title": "Zaproś kolejnego administratora"
      },
      "header": {
        "description": "Zdecyduj, kto powinien mieć dostęp administratora od początku. Jeśli więcej niż jedna osoba będzie zarządzać cyberbezpieczeństwem lub Moxso, zaproś je teraz, aby konfiguracja i odpowiedzialność były współdzielone od pierwszego dnia. Wszyscy administratorzy mają ten sam dostęp i widzą te same zmiany.",
        "title": "Zaproś administratorów"
      },
      "intro": {
        "admin_added": "Masz już więcej niż jednego administratora w tym obszarze roboczym.",
        "description": "Jeden administrator może dobrze sprawdzić się w mniejszych zespołach, a kilku administratorów może ułatwić przekazywanie obowiązków i współpracę.",
        "eyebrow": "Zalecane przed uruchomieniem",
        "recommendation": "Wybierz konfigurację, która pasuje do Twojego zespołu, i zaproś dodatkowych administratorów, jeśli odpowiedzialność jest współdzielona.",
        "title": "Współdziel dostęp administratora"
      },
      "list": {
        "added_on": "Dodano",
        "description": "Przejrzyj administratorów, którzy obecnie mają dostęp do tego obszaru roboczego.",
        "title": "Administratorzy obszaru roboczego",
        "you": "Ty"
      }
    },
    "kick_off": {
      "complete": "Zaplanuj kickoff",
      "dates": {
        "description": "Zaplanuj daty rozpoczęcia",
        "locked": "Zablokowane",
        "locked_description": "Spełnij powyższe wymagania, aby odblokować planowanie.",
        "simulation": {
          "custom_date": "Data niestandardowa",
          "custom_date_description": "Wybierz konkretny dzień",
          "label": "Data rozpoczęcia symulacji",
          "one_week_before": "1 tydzień przed szkoleniem",
          "recommended": "Zalecane"
        },
        "title": "Daty rozpoczęcia",
        "training": {
          "description": "Tego dnia pracownicy otrzymają pierwszy moduł szkoleniowy.",
          "label": "Data rozpoczęcia szkolenia",
          "placeholder": "Wybierz datę"
        }
      },
      "header": {
        "description": "Wybierz dzień rozpoczęcia szkolenia zwiększającego świadomość pracowników. Wcześniej odbywa się bazowa symulacja phishingowa, aby zmierzyć punkt wyjścia.",
        "title": "Zaplanuj rozpoczęcie"
      },
      "validation": {
        "description": "Ukończ te kroki, zanim zaplanujesz szkolenie.",
        "requirements_count": "Ukończono {count} z {total}",
        "set_up": "Skonfiguruj",
        "title": "Weryfikacja przed rozpoczęciem"
      }
    },
    "microsoft_manual_setup": {
      "junk": {
        "button": "Jak ominąć filtry wiadomości-śmieci",
        "heading": "Omiń filtr wiadomości-śmieci",
        "text": "Ten przewodnik zawiera instrukcje krok po kroku, jak umożliwić wiadomościom Moxso omijanie filtrów wiadomości-śmieci."
      },
      "safe_links": {
        "button": "Jak ominąć Safe Links",
        "heading": "Omiń Safe Links",
        "text": "Ten przewodnik zawiera instrukcje krok po kroku, jak umożliwić wiadomościom Moxso omijanie Safe Links."
      },
      "spam": {
        "button": "Jak ominąć filtry spamu",
        "heading": "Omiń filtr spamu",
        "text": "Ten przewodnik zawiera instrukcje krok po kroku, jak umożliwić wiadomościom Moxso omijanie filtrów spamu."
      },
      "tenant_allow_block": {
        "button": "Jak dodać Moxso do listy dozwolonych po IP w Outlooku",
        "heading": "Dodaj adresy IP Moxso do Tenant Allow/Block Lists",
        "text": "Ten przewodnik zawiera instrukcje krok po kroku, jak dodać adresy IP Moxso do Tenant Allow/Block Lists w Microsoft Defender, aby zapewnić prawidłowe dostarczanie wiadomości e-mail."
      },
      "third_party": {
        "button": "Jak dodać adresy IP i domeny Moxso do Microsoft Defender",
        "heading": "Dodaj adresy IP i domeny Moxso do Microsoft Defender",
        "text": "Ten przewodnik zawiera instrukcje krok po kroku, jak dodać adresy IP i domeny Moxso do ustawień Third-Party Phishing Simulation w Microsoft Defender, aby zapewnić prawidłowe testowanie i dostarczanie wiadomości e-mail."
      }
    },
    "onboarding_actions": {
      "back": "Wstecz",
      "continue": "Kontynuuj",
      "knowledge_base": "Baza wiedzy",
      "mark_as_completed": "Oznacz jako ukończone",
      "skip": "Skonfiguruj później"
    },
    "progress_badge": {
      "kick_off_planned": "Zaplanowano rozpoczęcie",
      "simulation_date": "Data rozpoczęcia symulacji",
      "training_start": "Data rozpoczęcia szkolenia",
      "workspace_setup": "Konfiguracja:"
    },
    "reporting_add_in": {
      "confirm_setup": {
        "description": "Jeśli w Twojej skrzynce pocztowej widoczna jest wtyczka Moxso, pracownicy mogą zacząć używać jej do zgłaszania podejrzanych wiadomości bezpośrednio ze swojej skrzynki odbiorczej.",
        "manage_later": "Zobacz, jak działa zgłaszanie, w {link}.",
        "subtitle": "Ukończ przewodnik dla swojego dostawcy poczty e-mail i kontynuuj, gdy dodatek zostanie wdrożony.",
        "this_guide": "tym przewodniku",
        "title": "Czy wtyczka Moxso jest widoczna w Twojej skrzynce pocztowej?"
      },
      "continue_disabled_tooltip_text": "Wybierz dostawcę poczty e-mail, aby kontynuować.",
      "follow_guide": {
        "gmail": "Gmail",
        "outlook": "Outlook",
        "title": "Postępuj zgodnie z poniższym przewodnikiem"
      },
      "guide_picker": {
        "gmail": {
          "description": "Przewodnik krok po kroku, jak skonfigurować reporting add-in w Gmailu.",
          "title": "Gmail"
        },
        "outlook": {
          "description": "Przewodnik krok po kroku, jak skonfigurować reporting add-in w Outlooku.",
          "title": "Outlook"
        },
        "title": "Wybierz swojego dostawcę poczty e-mail"
      },
      "header": {
        "description": "Skonfiguruj reporting add-in Moxso, aby pracownicy mogli szybko zgłaszać podejrzane wiadomości bezpośrednio ze swojej skrzynki odbiorczej w ramach codziennej pracy z pocztą e-mail.",
        "title": "Skonfiguruj reporting add-in"
      }
    },
    "setup_provider": {
      "add_simulation": {
        "button": "Utwórz szkic symulacji",
        "continue_disabled_tooltip_text": "Skonfiguruj kampanię symulacji phishingu, aby kontynuować",
        "description": "Przygotowaliśmy kampanię symulacji phishingu na podstawie profilu Twojej firmy. Ta kampania posłuży jako punkt odniesienia do identyfikowania obszarów do poprawy.",
        "description_cta": "Kliknij przycisk poniżej, aby utworzyć symulację",
        "header": {
          "description": "Skonfiguruj kampanię symulacji phishingu, która będzie wysyłać ciągłe, realistyczne wiadomości, aby pomóc pracownikom ćwiczyć rozpoznawanie zagrożeń. Ustawienia kampanii i grupę docelową możesz zmienić po jej uruchomieniu.",
          "title": "Skonfiguruj swoją pierwszą symulację phishingu"
        },
        "settings_card": {
          "Audience": "Grupa docelowa",
          "Credential harvest": "Pozyskiwanie danych logowania",
          "Delivery rate": "Częstotliwość wysyłki",
          "Name": "Nazwa",
          "all_employees": "Wszyscy pracownicy",
          "baseline_campaign": "Kampania bazowa",
          "credential_harvest": "Włączone",
          "delivery_rate": "Średnia"
        },
        "simulation_created": "Szkic symulacji utworzony",
        "subtitle": "Gotowe do uruchomienia",
        "title": "Zalecane ustawienia"
      },
      "buttons": {
        "back": "Wstecz",
        "continue": "Kontynuuj"
      },
      "header": {
        "description": "Skonfiguruj integrację, aby automatycznie synchronizować dane pracowników z systemem. Dzięki temu dane pozostają aktualne, a ręczne aktualizacje nie są potrzebne.",
        "title": "Konfiguruj integracje"
      },
      "integration": {
        "header": {
          "description": "Wybierz, czy chcesz zintegrować z bazą danych HR (dostawca tożsamości), czy zamiast tego importować pracowników ręcznie przez plik CSV. Nie zalecamy opcji ręcznej, ponieważ nie pozwoli to systemowi na automatyczne synchronizowanie i aktualizowanie w czasie (śledzenie nowych lub nieaktywnych użytkowników).",
          "title": "Synchronizuj pracowników"
        },
        "warning": "Konto administratora z globalnymi uprawnieniami jest wymagane do skonfigurowania synchronizacji z Microsoft Entra ID lub Google Workspace."
      },
      "provider": {
        "csv_import": "Import CSV",
        "description": "Wybierz platformę używaną do zarządzania tożsamościami i pracownikami.",
        "employees": "Pracownicy",
        "google": "Google Workspace",
        "google_sync": "Google Sync",
        "microsoft": "Microsoft",
        "microsoft_sync": "Microsoft Entra ID",
        "okta": "Okta",
        "title": "Wybierz dostawcę"
      },
      "recommendations": {
        "create_target_group": {
          "description": "Utwórz grupę z pracownikami, których chcesz objąć działaniami, aby łatwo przypisywać im symulacje i szkolenia, wybierając tę grupę bezpośrednio.",
          "title": "Utwórz grupę docelową"
        },
        "heading": {
          "description": "Wykonaj te kroki przed importem pracowników, aby upewnić się, że synchronizowane są właściwe dane. Chociaż nie jest to obowiązkowe, zaoszczędzi ci to czasu później.",
          "title": "Przygotuj się do integracji"
        },
        "verify_language_settings": {
          "description": "Upewnij się, że ustawienia językowe pracowników są poprawne, aby do Moxso była synchronizowana właściwa wersja językowa.",
          "title": "Sprawdź ustawienia językowe"
        },
        "warning": "Upewnij się, że nowi pracownicy zawsze są dodawani do grup, które są zsynchronizowane z Moxso."
      },
      "saml_scim": {
        "header": {
          "description": "Skonfiguruj jednokrotne logowanie i automatyczne aprowizowanie użytkowników. Uzupełnij obie sekcje poniżej, a następnie kontynuuj po połączeniu dostawcy tożsamości.",
          "title": "Skonfiguruj SAML i SCIM"
        }
      },
      "setup_method": {
        "header": {
          "description": "Użyj SAML i SCIM do bezpiecznego logowania i automatycznego aprowizowania albo połącz dostawcę za pomocą standardowej integracji.",
          "title": "Wybierz konfigurację"
        },
        "provider_integration": {
          "description": "Synchronizuj pracowników bezpośrednio z Microsoft Entra ID, Google Workspace, Slacka lub pliku CSV.",
          "title": "Standardowa integracja"
        },
        "recommended": "Zalecane",
        "saml_scim": {
          "description": "Włącz jednokrotne logowanie i zautomatyzuj aprowizowanie użytkowników.",
          "title": "SAML i SCIM"
        }
      },
      "whitelisting": {
        "buttons": {
          "change_guides": "Zmień instrukcję",
          "confirm_whitelist": "Potwierdź allowlisting",
          "manual": "Ręcznie",
          "test_whitelist": "Przetestuj allowlisting"
        },
        "continue_disabled_tooltip_text": "Przed kontynuowaniem potwierdź, że allowlisting działa poprawnie.",
        "follow_guide": {
          "gmail": "Gmail",
          "outlook": "Outlook",
          "title": "Postępuj według poniższej instrukcji"
        },
        "guide_picker": {
          "gmail": {
            "description": "Instrukcja krok po kroku, jak przepuszczać wiadomości w Gmailu.",
            "title": "Gmail"
          },
          "outlook": {
            "description": "Instrukcja krok po kroku, jak przepuszczać wiadomości w Outlooku.",
            "title": "Outlook"
          },
          "title": "Wybierz swojego dostawcę poczty e‑mail"
        },
        "header": {
          "description": "Skonfiguruj allowlisting naszych adresów IP i domen, aby symulacje phishingowe trafiały do skrzynek odbiorczych pracowników i nie były blokowane przez filtry antyspamowe.",
          "title": "Upewnij się, że wiadomości nie są oznaczane jako spam"
        },
        "send_test": {
          "buttons": {
            "no": "Nie, potrzebuję pomocy",
            "send_test": "Wyślij wiadomość testową",
            "yes": "Tak, otrzymałem(-am) ją"
          },
          "confirm": {
            "text": "Sprawdź swoją skrzynkę odbiorczą (i folder spamu).",
            "title": "Czy otrzymałeś wiadomość? | Czy otrzymałeś wiadomości?"
          },
          "description": "Wyślij wiadomość testową, aby potwierdzić, że jest dostarczana do Twojej skrzynki odbiorczej na adres {email} (a nie do folderu spamu). {try_a_few_times}, każda wiadomość używa innej treści i domen.",
          "subtitle": "Wyślij wiadomość testową",
          "success": {
            "text": "Twoja konfiguracja jest poprawna. Możesz przejść do następnego kroku.",
            "title": "Allowlisting działa poprawnie"
          },
          "title": "Potwierdź, że allowlisting działa",
          "try_a_few_times": "Spróbuj kilka razy"
        }
      }
    },
    "simulation": {
      "targeting": {
        "add_services": "Dodaj usługi",
        "ceo": "Dane kontaktowe CEO",
        "cfo": "Dane kontaktowe CFO",
        "content_description": "Dodaj kontakty kadry kierowniczej i swoje usługi, aby symulacje były bardziej realistyczne.",
        "content_title": "Spersonalizuj symulacje",
        "cto": "Dane kontaktowe CTO",
        "description": "Skonfiguruj realistyczne targetowanie dla swojej organizacji.",
        "edit_services": "Edytuj usługi",
        "no_services": "Nie wybrano usług",
        "services": "Usługi",
        "services_title": "Wybierz usługi",
        "title": "Skonfiguruj symulacje"
      }
    },
    "steps": {
      "add_simulation": "Symulacje",
      "invite_admins": "Administratorzy",
      "kick_off": "Rozpoczęcie",
      "reporting_add_in": "Dodatek do zgłaszania",
      "setup_provider": "Integracje",
      "training": "Szkolenia",
      "verify_domains": "Domeny",
      "welcome": "Witamy",
      "whitelisting": "Allowlisting"
    },
    "training": {
      "header": {
        "description": "Wybierz, czy Moxso ma automatycznie przypisywać szkolenia, czy chcesz planować je samodzielnie, a następnie dostosuj konfigurację do swojej organizacji.",
        "title": "Skonfiguruj szkolenia"
      },
      "mode": {
        "continue_disabled": "Wybierz sposób szkolenia, aby kontynuować.",
        "description": "Wybierz sposób, aby ukończyć ten krok.",
        "title": "Wybierz sposób prowadzenia szkoleń"
      }
    },
    "verify_domains": {
      "buttons": {
        "add": "Dodaj",
        "resend": "Wyślij ponownie",
        "verify": "Zweryfikuj"
      },
      "continue_disabled_tooltip_text": "Przed kontynuowaniem zweryfikuj co najmniej jedną domenę",
      "domain_placeholder": "firma.com",
      "empty": {
        "subtitle": "Dodaj powyżej domeny swojej firmy, aby kontynuować",
        "title": "Nie dodano jeszcze żadnych domen"
      },
      "heading": {
        "description": "Dodaj wszystkie domeny firmowe używane w adresach e‑mail pracowników, aby móc ich zaimportować. W celu potwierdzenia każdej domeny na adres {email} zostanie wysłana wiadomość weryfikacyjna.",
        "title": "Potwierdź swoje domeny"
      },
      "labels": {
        "add_domain": "Dodaj domenę",
        "not_verified": "Niezweryfikowana",
        "verification_pending": "Weryfikacja w toku",
        "verified": "Zweryfikowana",
        "verified_on": "Zweryfikowano: {date}"
      },
      "verification_email_sent": "Wiadomość weryfikacyjna wysłana",
      "your_domains": "Twoje domeny"
    },
    "welcome": {
      "connect_provider": {
        "description": "Przygotuj się do integracji i synchronizacji pracowników",
        "title": "Konfiguruj integracje"
      },
      "description": "Być może znasz już poniższe kroki, ale teraz upewnimy się, że wszystkie zostały ukończone, abyś mógł przejść na żywo. Wszystkie dane testowe, które mogłeś wcześniej utworzyć, zostały teraz usunięte.",
      "get_started": "Zacznij",
      "invite_admins": {
        "description": "Zdecyduj, czy inne osoby również powinny pomagać w konfiguracji i bieżącej pracy administracyjnej.",
        "title": "Zaproś administratorów"
      },
      "launch_phishing_simulation": {
        "description": "Utwórz symulację bazową i skonfiguruj oszustwa na prezesa oraz targetowanie oprogramowania.",
        "title": "Symulacje"
      },
      "reporting_add_in": {
        "description": "Dodaj przycisk zgłaszania Moxso do skrzynek odbiorczych pracowników.",
        "title": "Skonfiguruj reporting add-in"
      },
      "review_and_start": {
        "description": "Przejrzyj konfigurację i zacznij korzystać z Moxso.",
        "title": "Zacznij używać Moxso"
      },
      "subtitle": "Witamy w Moxso",
      "title": "Przygotujmy Cię do startu.",
      "training": {
        "description": "Wybierz sposób szkolenia i ramy zgodności ważne dla organizacji.",
        "title": "Szkolenia"
      },
      "verify_domains": {
        "description": "Zweryfikuj domeny, których chcesz używać z Moxso.",
        "title": "Zweryfikuj domeny"
      },
      "whitelist_email": {
        "description": "Upewnij się, że wiadomości nie są oznaczane jako spam.",
        "title": "Skonfiguruj białą listę"
      }
    }
  },
  "workspace_report": {
    "assignments": "Przypisania",
    "avg_score": "Średni wynik",
    "compared_against": "W porównaniu z {period}",
    "department": "Dział",
    "employee": "Pracownik",
    "employees_at_risk": "Pracownicy zagrożeni",
    "generated": "Wygenerowano {date}",
    "group": "Grupa",
    "group_breakdown": "Podział na grupy",
    "group_breakdown_description": "Zagregowane sygnały, przypisania i działania według grup",
    "group_breakdown_description_without_hri": "Zagregowane przypisania według grup",
    "group_breakdown_note": "Średni wynik jest ważony liczbą pracowników w każdej grupie. Pasek sygnałów dzieli aktywność na negatywny, neutralny i pozytywny sentyment.",
    "group_breakdown_note_without_hri": "Średni wynik jest ważony liczbą pracowników w każdej grupie.",
    "hri_summary": "Podsumowanie HRI obszaru roboczego",
    "human_risk_intelligence": "Human Risk Intelligence",
    "interventions": "Działania",
    "interventions_by_type": "Działania według typu",
    "last_six_months": "Ostatnie 6 miesięcy",
    "loading": "Ładowanie raportu obszaru roboczego…",
    "missed": "Pominięte",
    "no_employees_at_risk": "Brak pracowników zagrożonych",
    "no_groups": "Brak danych o grupach",
    "no_risk_indicators": "Brak wskaźników ryzyka",
    "operational_metrics": "Metryki operacyjne",
    "performance_by_team": "Wyniki według zespołów",
    "resilience_score": "Wynik odporności",
    "risk_index": "Indeks ryzyka {value}/10 · mniej znaczy lepiej",
    "risk_indicator": "Wskaźnik ryzyka",
    "risk_level": "Poziom ryzyka",
    "risk_levels": {
      "high": "Wysoki",
      "low": "Niski",
      "moderate": "Umiarkowany"
    },
    "security_behaviour_overview": "Przegląd zachowań związanych z bezpieczeństwem",
    "signals": "Sygnały",
    "signals_by_sentiment": "Sygnały według sentymentu",
    "signals_by_severity": "Sygnały według ważności",
    "threshold": "Próg {value}% · posortowano od niskiego do wysokiego",
    "title": "Raport obszaru roboczego",
    "top_five_period": "Top 5 w tym okresie",
    "total": "łącznie: {count}",
    "total_employees": "łącznie pracowników: {count}",
    "total_groups": "grupy: {count}",
    "total_signals": "sygnały: {count}",
    "training": "Metryki szkoleń",
    "training_simulations_risk": "Szkolenia, symulacje i ryzyko",
    "trend": "Trend",
    "trend_title": "Odporność, współczynnik kliknięć i zgłoszeń",
    "trending_risk_indicators": "Aktualne wskaźniki ryzyka",
    "unavailable": "Raport jest niedostępny",
    "unavailable_description": "Nie można było załadować raportu. Sprawdź, czy adres URL raportu jest prawidłowy i nie wygasł.",
    "workspace_summary": "Podsumowanie obszaru roboczego"
  }
}
